/* eslint-disable prettier/prettier */
module.exports = {
  app: "App",
  news: "Noticias",
  component: "Componente",
  download: "Descargar",
  downloading: "Descargando",
  unableToDownload: "No se puede descargar",
  features: "Funcionalidades",
  applications: "Aplicaciones",
  dashboard: "Panel",
  customers: "Clientes",
  warehouses: "Almacenes",
  management: "Gestión",
  carriers: "Transportistas",
  operations: "Operaciones",
  warehousing: "Almacenaje",
  quote: "Cotización",
  business: "Empresa",
  invoices: "Facturas",
  prepayments: "Prepagos",
  billsToPay: "Cuentas por Pagar",
  modules: "Módulos",
  agency: "Agencia",
  pages: "Páginas",
  gallery: "Galería",
  pricing: "Precios",
  privacyPolicy: "Política de Privacidad",
  feedback: "Comentarios",
  report: "Informe",
  faqS: "Preguntas Frecuentes",
  advanceComponent: "Componente Avanzado",
  blank: "En blanco",
  session: "Sesión",
  login: "Iniciar sesión",
  reset: "Restablecer",
  register: "Registrar",
  lockScreen: "Pantalla de bloqueo",
  forgotPassword: "Olvidé mi contraseña",
  forgotYourPassword: "¿Olvidaste tu contraseña?",
  letsGetYouBackIn: "Vamos a reconectarte",
  recoverPassword: "Recuperar contraseña",
  dontWorryJustEnterYourEmailAddressBelowAndWellAssistYou: "¡No te preocupes! Ingresa tu dirección de correo electrónico abajo y te ayudaremos.",
  withInstructionsToResetYourPassword: "con instrucciones para restablecer tu contraseña",
  checkYourEmail: "Revisa tu correo electrónico",
  emailNotReceived: "¿No recibiste el correo?",
  resend: "Reenviar",
  uiComponents: "Componentes de UI",
  alerts: "Alertas",
  appBar: "Barra de App",
  avatars: "Avatares",
  buttons: "Botones",
  bottomNavigations: "Navegaciones Inferiores",
  badges: "Insignias",
  cards: "Tarjetas",
  cardsMasonry: "Tarjetas en Mosaico",
  chip: "Chip",
  dialog: "Diálogo",
  dividers: "Divisores",
  drawers: "Cajones",
  draft: "Borrador",
  totalQuotes: "Total de Cotizaciones",
  inspect: "Inspeccionar",
  expansionPanel: "Panel Expansible",
  gridList: "Lista en Cuadrícula",
  list: "Lista",
  menu: "Menú",
  popOverTooltip: "Pop Over y Tooltip",
  progress: "Progreso",
  snackbar: "Notificación",
  selectionControls: "Controles de Selección",
  dateTimePicker: "Selector de Fecha y Hora",
  tabs: "Pestañas",
  stepper: "Paso a Paso",
  notification: "Notificación",
  notifications: "Notificaciones",
  sweetAlert: "Alerta",
  autoComplete: "Autocompletar",
  aboutUs: "Sobre Nosotros",
  widgets: "Widgets",
  forms: "Formularios",
  formElements: "Elementos de Formulario",
  textField: "Campo de Texto",
  selectList: "Lista de Selección",
  charts: "Gráficos",
  reCharts: "Re Charts",
  reactChartjs2: "React Chartjs 2",
  icons: "Iconos",
  themifyIcons: "Iconos Themify",
  simpleLineIcons: "Iconos de Línea Simple",
  materialIcons: "Iconos Material",
  tables: "Tablas",
  basic: "Básico",
  dataTable: "Tabla de Datos",
  responsive: "Responsivo",
  maps: "Mapas",
  googleMaps: "Google Maps",
  leafletMaps: "Leaflet Maps",
  inbox: "Bandeja de Entrada",
  users: "Usuarios",
  userProfile1: "Perfil de Usuario 1",
  userProfile2: "Perfil de Usuario 2",
  userManagement: "Gestión de Usuarios",
  userList: "Lista de Usuarios",
  calendar: "Calendario",
  cultures: "Culturas",
  selectable: "Seleccionable",
  customRendering: "Renderizado Personalizado",
  chat: "Chat",
  todo: "Tareas",
  editor: "Editor",
  wysiwygEditor: "Editor WYSIWYG",
  quillEditor: "Editor Quill",
  dragAndDrop: "Arrastrar y Soltar",
  reactDragula: "React Dragula",
  reactDnd: "React Dnd",
  ecommerce: "E-commerce",
  shopList: "Lista de Tienda",
  shopGrid: "Cuadrícula de Tienda",
  invoice: "Factura",
  crm: "CRM",
  ratings: "Valoraciones",
  number: "Número",
  welcomeBack: "¡Bienvenido de nuevo!",
  pleaseCreateANewPasswordForYourAccount: "Por favor, crea una nueva contraseña para tu cuenta",
  emailOrUsername: "Correo o nombre de usuario",
  rememberMe: "Recuérdame",
  notRegisteredYet: "¿Aún no estás registrado?",
  clickToResend: "Haz clic para reenviar",
  clickHere: "haz clic aquí.",
  youWillBeRedirectedToTheSignInPageIfYouAreNotRedirectedAutomatically: "Serás redirigido a la página de inicio de sesión. Si no eres redirigido automáticamente, ",
  createAnAccount: "Crear una cuenta",
  web: "Web",
  done: "Completado",
  inProgress: "En Progreso",
  waiting: "Esperando",
  subscribed: "Suscrito",
  searchItem: "Buscar Ítem",
  startDate: "Fecha de Inicio",
  endDate: "Fecha de Fin",
  password: "Contraseña",
  newPassword: "Nueva contraseña",
  createNewPassword: "Crear nueva contraseña",
  filters: "Filtros",
  private: "Privado",
  corporate: "Corporativo",
  name: "Nombre",
  volume: "Volumen",
  sidebarOverlay: "Superposición de Barra Lateral",
  appSettings: "Configuración de App",
  sidebarImage: "Imagen de Barra Lateral",
  miniSidebar: "Barra Lateral Mini",
  boxLayout: "Diseño en Caja",
  rtlLayout: "Diseño RTL",
  darkMode: "Modo Oscuro",
  light: "Claro",
  dark: "Oscuro",
  refresh: "Actualizar",
  refreshing: "Actualizando",
  record: "Grabar",
  play: "Reproducir",
  start: "Iniciar",
  cancel: "Cancelar",
  copy: "Copiar",
  send: "Enviar",
  add: "Agregar",
  update: "Actualizar",
  confirm: "Confirmar",
  delete: "Eliminar",
  yes: "Sí",
  no: "No",
  addNewContact: "Agregar nuevo contacto",
  editAContact: "Editar un contacto",
  addNewLocation: "Agregar nueva ubicación",
  editALocation: "Editar una ubicación",
  summary: "Resumen",
  week: "Semana",
  weekday: "Día de la Semana",
  month: "Mes",
  firstName: "Nombre",
  lastName: "Apellido",
  address: "Dirección",
  description: "Aquí puedes subir tus propios archivos (como inventario, personal o listas de servicios) o",
  total: "Total",
  selectRoom: "Seleccionar Habitación",
  selectDescription: "Seleccionar Descripción",
  addNew: "Agregar nuevo",
  revoke: "Revocar",
  assign: "Asignar",
  save: "Guardar",
  saveComment: "Guardar Comentario",
  create: "Crear",
  savePublishTask: "Guardar y Publicar Tarea",
  accept: "Aceptar",
  accepted: "Aceptado",
  complete: "Completo",
  back: "Atrás",
  ok: "Ok",
  next: "Siguiente",
  saveChanges: "Guardar Cambios",
  cancelChanges: "Cancelar Cambios",
  more: "Más",
  remove: "Eliminar",
  changePhoto: "Cambiar foto",
  booking: "Reserva",
  enterBooking: "Ingresar reserva",
  user: "Usuario",
  promo: "Promoción",
  themeColor: "Color del Tema",
  selectProject: "Seleccionar Proyecto",
  shop: "Tienda",
  cart: "Carrito",
  checkout: "Finalizar Compra",
  product: "Producto",
  removeProduct: "Eliminar Producto",
  noItemFound: "No se encontraron ítems",
  saas: "SAAS",
  multilevel: "Multinivel",
  level1: "Nivel 1",
  level2: "Nivel 2",
  imageCropper: "Recortador de Imagen",
  videoPlayer: "Reproductor de Video",
  dropzone: "Zona de Carga",
  cropImage: "Recortar Imagen",
  preview: "Vista previa",
  projects: "Proyectos",
  projectDetail: "Detalle del Proyecto",
  clients: "clientes",
  shipments: "Envíos",
  editShipment: "Editar Envío",
  viewShipment: "Ver Envío",
  newShipment: "Nuevo Envío",
  loadBy: "Cargar por",
  createShipment: "Crear Envío",
  products: "Productos",
  latestScan: "Última Lectura",
  dateOfLoading: "Fecha de Carga",
  editProduct: "Editar Producto",
  newProduct: "Nuevo Producto",
  noProductsToShow: "No hay productos para mostrar",
  theProductWasRemovedSuccesfully: "El producto fue eliminado exitosamente",
  containers: "Contenedores",
  settings: "Configuración",
  cartonQuantity: "Cantidad de Cajas",
  palletQuantity: "Cantidad de Pallets",
  despatches: "Despachos",
  edit: "Editar",
  details: "Detalles",
  detail: "Detalle",
  locations: "Ubicaciones",
  comments: "Comentarios",
  estimatedDates: "Fechas estimadas",
  destinationWh: "Almacén de Destino",
  vessel: "Buque",
  vesselName: "Nombre del Buque",
  travel: "Viaje",
  container: "Contenedor",
  containerType: "Tipo de Contenedor",
  selectContainerType: "Seleccionar Tipo de Contenedor",
  shipmentType: "Tipo de envío",
  containerNumbers: "Números de Contenedor",
  grossWeight: "Peso Bruto",
  inputWeight: "Ingresar Peso",
  project: "Proyecto",
  totalQuantity: "Cantidad Total",
  totalPallets: "Total de Pallets",
  eta: "ETA",
  etaFinalPort: "ETA Puerto Final",
  etaWarehouse: "ETA Almacén",
  pickUpDate: "Fecha de Recolección",
  scanDate: "Fecha de Lectura",
  departureDate: "Fecha de Salida",
  arrivalAtDestination: "Fecha de Entrega",
  hawb: "HAWB",
  flightNumber: "Número de Vuelo",
  airline: "Aerolínea",
  etaUnpackData: "ETA Datos de Desembalaje",
  actualDates: "Fechas reales",
  agent: "Agente",
  agentId: "ID del Agente",
  agentParentCode: "ID padre del Agente",
  email: "Correo electrónico",
  businessAddress: "Dirección Comercial",
  businessContacts: "Contactos Comerciales",
  businessName: "Nombre Comercial",
  businessNumber: "Número Comercial",
  businessRegistration: "Registro Comercial",
  businessRegistrationNumber: "Número de Registro Comercial",
  mainEmailAddress: "Dirección de correo principal",
  website: "Sitio web",
  bodyType: "Tipo de Carrocería",
  fuelType: "Tipo de Combustible",
  condition: "Condición",
  engine: "Motor",
  ownership: "Propiedad",
  branch: "Sucursal",
  fleetStatus: "Estado de la Flota",
  dryStandard: "Seco Estándar",
  dryHigh: "Seco Alto",
  tank: "Tanque",
  open: "Abierto",
  openTop: "Techo Abierto",
  openTopHigh: "Techo Abierto Alto",
  flat: "Plano",
  flatStandard: "Plano Estándar",
  flatHigh: "Plano Alto",
  reeferStandard: "Refrigerado Estándar",
  reeferHigh: "Refrigerado Alto",
  po: "PO #",
  sku: "SKU",
  itemRemovedSuccessfully: "¡Ítem eliminado exitosamente!",
  import: "Importar",
  export: "Exportar",
  importCsvFile: "Importar archivo CSV",
  printDeliveryDocket: "Imprimir Comprobante de Entrega",
  despatch: "Despacho",
  qtyOfCartonsDespatched: "Cant. de Cajas Despachadas",
  qtyOfPalletsDespatched: "Cant. de Pallets Despachados",
  ofDespatches: "Nº de Despachos",
  ofOrdersDespatched: "Nº de Pedidos Despachados",
  stockOnHand: "Stock disponible",
  stockOnHandDetailed: "Stock disponible - Detallado",
  crossDockStatus: "Estado Cross-Dock",
  packing: "Embalaje",
  addMaterial: "Agregar Material",
  fillAllFieldsToSave: "Complete todos los campos para guardar",
  addItem: "Agregar ítem",
  instructionStatus: "Estado de la instrucción",
  selectWhen: "Seleccionar Cuándo",
  addInstruction: "Agregar Instrucción",
  availableInstructions: "Instrucciones Disponibles",
  remark: "Observación",
  inputYourRemarkAndPressEnter: "Ingresa tu observación y presiona Enter",
  uplift: "Recolección",
  coordinator: "Coordinador",
  selectedInstructions: "instrucciones seleccionadas",
  selectAStatus: "Seleccionar un estado",
  applyChooseLocations: "Aplicar y elegir ubicaciones",
  filterConditions: "Filtrar Condiciones",
  filterLocations: "Filtrar Ubicaciones",
  conditions: "Condiciones",
  typeOfPacking: "Tipo de Embalaje",
  itemStatus: "Estado del Ítem",
  itemNumber: "Número del Ítem",
  width: "Ancho",
  length: "Largo",
  leader: "Líder",
  searchLeader: "Buscar Líder",
  staffs: "Personal",
  searchForStaff: "Buscar personal",
  fleets: "Flotas",
  searchForFleet: "Buscar flota",
  height: "Altura",
  cartonPerPallet: "Cajas por Pallet",
  palletHeight: "Altura del Pallet",
  heightWithPallet: "Altura con Pallet",
  heightIncPallet: "Altura incl. Pallet",
  ti: "Ti",
  hi: "Hola",
  selectProductsBelowToAddThem: "Selecciona productos a continuación para agregarlos",
  productSkuSearch: "Búsqueda de Producto (SKU)",
  productName: "Nombre del Producto",
  shippingItem: "Ítem de Envío",
  truckTransport: "Camión/Transporte",
  customerName: "Nombre del Cliente",
  addNewProject: "Agregar Nuevo Proyecto",
  projectName: "Nombre del Proyecto",
  projectCustomer: "Cliente del Proyecto",
  importFiles: "Importar Archivos",
  fileHistory: "Historial de Archivos",
  projectCreatedWithSuccess: "¡Proyecto creado exitosamente!",
  uploadNewFile: "Subir Nuevo Archivo",
  imapHost: "Host IMAP",
  imapPort: "Puerto IMAP",
  emailUser: "Usuario de Correo",
  emailPassword: "Contraseña de Correo",
  useTls: "Usar TLS",
  addNewComment: "Agregar nuevo comentario",
  typeYourCommentHere: "Escribe tu comentario aquí",
  order: "Pedido",
  origin: "Origen",
  destination: "Destino",
  type: "Tipo",
  dateCreated: "Fecha de creación",
  dateUpdated: "Fecha de actualización",
  buyerName: "Nombre del Comprador",
  shipVia: "Enviar via",
  shipTo: "Enviar a",
  incoterm: "Incoterm",
  createNewSupplier: "Crear nuevo proveedor",
  fulfilled: "Cumplido",
  quantityOrdered: "Cantidad pedida",
  quantityRequested: "Cantidad solicitada",
  quantityFullfilled: "Cantidad cumplida",
  variation: "Variación",
  switchToActualInventory: "Cambiar a Inventario Real",
  switchToQuotedInventory: "Cambiar a Inventario Cotizado",
  switchToEstimatedInventory: "Cambiar a Inventario Estimado",
  searchByNameOrEmail: "Buscar por nombre o correo",
  supplierDetails: "Detalles del Proveedor",
  supplier: "Proveedor",
  supplierName: "Nombre del Proveedor",
  supplierCode: "Código del Proveedor",
  address1: "Dirección 1",
  address2: "Dirección 2",
  suburbTown: "Barrio/Ciudad",
  streetNumber: "Número",
  postalCode: "Código Postal",
  state: "Estado",
  country: "País",
  contactName: "Nombre del contacto de facturación",
  locationStatus: "Estado de la ubicación",
  filterByShipment: "Filtrar por Envío #",
  noInformationToBeShown: "No hay información para mostrar.",
  loadingShipments: "Cargando Envíos",
  loadingDispatches: "Cargando Despachos",
  loadingSuppliers: "Cargando Proveedores...",
  loadingNotifications: "Cargando Notificaciones",
  task: "Tarea",
  usedBy: "Usado por",
  fleetNumber: "Número de Flota",
  make: "Marca",
  model: "Modelo",
  body: "Carrocería",
  position: "Posición",
  username: "Nombre de Usuario",
  location: "Ubicación",
  mainContact: "Contacto Principal",
  role: "Rol",
  rooms: "Habitaciones",
  fullName: "Nombre completo",
  symbol: "Símbolo",
  decimalPoints: "Decimales",
  lastUpdate: "Última Actualización",
  lastModified: "Última Modificación",
  flatFee: "Tarifa Fija",
  hourlyFee: "Tarifa por Hora",
  halfHourFee: "Tarifa por Media Hora",
  triggers: "Disparadores",
  tasksType: "Tipo de Tareas",
  jobsType: "Tipo de Trabajos",
  branches: "Sucursales",
  updated: "Actualizado",
  color: "Color",
  icon: "Icono",
  packaging: "Embalaje",
  configuration: "Configuración",
  currency: "Moneda",
  currencies: "Monedas",
  measurements: "Medidas",
  addCustomCurrency: "Agregar moneda personalizada",
  displayUnit: "Unidad de visualización",
  languages: "Idiomas",
  prefix: "Prefijo",
  language: "Idioma",
  room: "Habitación",
  types: "Tipos",
  descriptiveSymbol: "Símbolo Descriptivo",
  descriptiveSymbols: "Símbolos Descriptivos",
  exceptionSymbol: "SÍMBOLO DE EXCEPCIÓN",
  exceptionSymbols: "Símbolos de Excepción",
  locationSymbol: "SÍMBOLO DE UBICACIÓN",
  locationSymbols: "Símbolos de Ubicación",
  photoIsMandatory: "La foto es obligatoria",
  selectTheRoom: "Seleccionar la habitación",
  editRoom: "Editar habitación",
  addNewType: "Agregar nuevo tipo",
  editType: "Editar tipo",
  addNewDescriptiveSymbol: "Agregar nuevo símbolo descriptivo",
  selectSymbol: "Seleccionar Símbolo",
  editDescriptiveSymbol: "Editar símbolo descriptivo",
  addNewExceptionSymbol: "Agregar nuevo símbolo de excepción",
  editExceptionSymbol: "Editar símbolo de excepción",
  addNewLocationSymbol: "Agregar nuevo símbolo de ubicación",
  editLocationSymbol: "Editar símbolo de ubicación",
  addNewOne: "Agregar nuevo",
  createFleet: "Crear Flota",
  editFleet: "Editar Flota",
  viewFleet: "Ver Flota",
  editThisFleet: "Editar esta flota",
  addANewFleet: "Agregar una nueva flota",
  viewThisFleet: "Ver esta flota",
  vinNumber: "Número VIN",
  year: "Año",
  engineType: "Tipo de Motor",
  plateNumber: "Número de Placa",
  addCondition: "Agregar Condición",
  typeMode: "Modo de Tipo",
  warehouse: "Almacén",
  searchForWarehouse: "Buscar almacén",
  searchForBranch: "Buscar sucursal",
  capacity: "Capacidad",
  capacityOfEachLiftvan: "Capacidad de cada Liftvan",
  volumeCapacityM3: "Capacidad de Volumen (m³)",
  weightCapacityKG: "Capacidad de Peso (Kg)",
  outOfService: "Fuera de Servicio",
  serialNumber: "Número de Serie",
  inputSerialNumber: "Ingresar Número de Serie",
  mechanicalElectricalChecklist: "Lista de verificación Mecánica y Eléctrica",
  hasTheMEChecklistBeenDoneOnThisItem: "¿Se realizó la lista M&E en este ítem?",
  isItWorking: "¿Está funcionando?",
  userDetails: "Detalles del Usuario",
  permissions: "Permisos",
  placeName: "Nombre del Lugar",
  local: "Local",
  companyId: "ID de la Empresa",
  suppliers: "Proveedores",
  newSupplier: "Nuevo Proveedor",
  viewSupplier: "Ver Proveedor",
  editSupplier: "Editar Proveedor",
  printSupplier: "Imprimir Proveedor",
  editPlace: "Editar Lugar",
  newPlace: "Nuevo Lugar",
  newUser: "Nuevo Usuario",
  createdAt: "Creado en",
  voyage: "Viaje",
  voyageNumber: "Número de Viaje",
  voyageStatus: "Estado del Viaje",
  voyageInformation: "Información del Viaje",
  containerNumber: "Número de Contenedor",
  inputContainer: "Ingresar Contenedor",
  inputShipment: "Ingresar Envío",
  internalReference: "Referencia Interna",
  exportShipment: "Exportar Envío",
  eventProductUpdate: "Actualización de Producto del Evento",
  importProductsEvents: "Importar Eventos de Productos",
  view: "Ver",
  close: "Cerrar",
  closed: "Cerrado",
  closedForInvoicing: "Cerrado para Facturación",
  closedForReceiving: "Cerrado para Recepción",
  createNetwork: "Crear red",
  createCustomer: "Crear cliente",
  createAgent: "Crear agente",
  createSupplier: "Crear proveedor",
  linkAccounts: "Vincular cuentas",
  understood: "Entendido",
  productEvents: "Eventos de Producto",
  birthDate: "Fecha de Nacimiento",
  emergencyName: "Nombre de Emergencia",
  emergencyPhone: "Teléfono de Emergencia",
  emergencyRelationship: "Parentesco de Emergencia",
  gender: "Género",
  skills: "Habilidades",
  residencyStatus: "Estado de Residencia",
  certificates: "Certificados",
  addressLine1: "Línea de Dirección 1",
  addressLine2: "Línea de Dirección 2",
  suburb: "Barrio",
  staffStatus: "Estado del Personal",
  staffMnt: "Personal - MNT",
  editStaff: "Editar Personal",
  newStaff: "Nuevo Personal",
  saveAsUser: "Guardar como Usuario",
  yourPasswordMustBeAtLeast12CharactersLong: "Tu contraseña debe tener al menos 12 caracteres",
  yourPasswordMustContainAtLeastOneSpecialCharacter: "Tu contraseña debe contener al menos un carácter especial",
  pleaseEnterYourPassword: "Por favor, ingresa tu contraseña",
  yourPasswordMustBeAtMaximumOf30CharactersLong: "Tu contraseña debe tener como máximo 30 caracteres",
  pleaseEnterAValidPhoneNumber: "Por favor, ingresa un número de teléfono válido",
  phoneNumber: "Número de teléfono",
  pleaseEnterALastName: "Por favor, ingresa un Apellido",
  yourLastNameMustBeAtLeast4CharactersLong: "Tu apellido debe tener al menos 4 caracteres",
  pleaseEnterAFirstName: "Por favor, ingresa un Nombre",
  yourFirstNameMustBeAtLeast4CharactersLong: "Tu nombre debe tener al menos 4 caracteres",
  pleaseEnterAName: "Por favor, ingresa un Nombre",
  yourNameMustBeAtLeast4CharactersLong: "Tu nombre debe tener al menos 4 caracteres",
  yourRegistrationNumberMustBeAtLeast4CharactersLong: "Tu número de registro debe tener al menos 4 caracteres",
  pleaseEnterAPhoneNumber: "Por favor, ingresa un Número de Teléfono",
  yourPhoneMustBeAtLeast6CharactersLong: "Tu teléfono debe tener al menos 6 caracteres",
  yourWebMustBeAtLeast4CharactersLong: "Tu sitio web debe tener al menos 4 caracteres",
  pleaseEnterAAddressLine: "Por favor, ingresa una Línea de Dirección",
  yourAddressLineMustBeAtLeast4CharactersLong: "Tu línea de dirección debe tener al menos 4 caracteres",
  pleaseEnterASuburb: "Por favor, ingresa un Barrio",
  yourSuburbMustBeAtLeast4CharactersLong: "Tu barrio debe tener al menos 4 caracteres",
  pleaseEnterAStateNumber: "Por favor, ingresa un Estado",
  yourStateMustBeAtLeast3CharactersLong: "Tu estado debe tener al menos 3 caracteres",
  pleaseEnterAPostalCodeNumber: "Por favor, ingresa un Código Postal",
  yourPostalCodeMustBeAtLeast4CharactersLong: "Tu código postal debe tener al menos 4 caracteres",
  pleaseEnterACountry: "Por favor, ingresa un País",
  yourCountryMustBeAtLeast4CharactersLong: "Tu país debe tener al menos 4 caracteres",
  newItemSType: "Tipo del nuevo ítem",
  editItemSType: "Editar tipo del ítem",
  newItemSDescription: "Descripción del nuevo ítem",
  editItemSDescription: "Editar descripción del ítem",
  network: "Red",
  anErrorOccurredTryAgain: "Ocurrió un error, inténtalo de nuevo",
  operationPerformedSuccessfully: "Operación realizada exitosamente",
  resendWelcomeEmail: "Reenviar correo de bienvenida",
  resendWelcomeEmailConfirmation: "¿Enviar un correo de bienvenida a [name]?",
  welcomeEmailSentSuccessfully: "Correo de bienvenida enviado correctamente",
  labelCreated: "Etiqueta Creada",
  sunday: "Domingo",
  monday: "Lunes",
  tuesday: "Martes",
  wednesday: "Miércoles",
  thursday: "Jueves",
  friday: "Viernes",
  saturday: "Sábado",
  january: "Enero",
  february: "Febrero",
  march: "Marzo",
  april: "Abril",
  may: "Mayo",
  june: "Junio",
  july: "Julio",
  august: "Agosto",
  september: "Septiembre",
  october: "Octubre",
  november: "Noviembre",
  december: "Diciembre",
  customerSTimeZone: "Zona horaria del cliente",
  startTime: "Hora de Inicio",
  endTime: "Hora de Fin",
  whatsapp: "Whatsapp",
  sms: "SMS",
  originAddress: "Dirección de origen",
  destinationAddress: "Dirección de destino",
  active: "Activo",
  Active: "Activo",
  disabled: "Deshabilitado",
  sendToAmos: "Enviar a AMOS",
  printReports: "Imprimir informes",
  cancelOrder: "Cancelar pedido",
  cancelQuote: "Cancelar cotización",
  inactive: "Inactivo",
  Inactive: "Inactivo",
  invertStatuses: "Invertir estados",
  filterByStatus: "Filtrar por estado",
  activeInactive: "Activo / Inactivo",
  selectType: "Seleccionar tipo",
  selectStatus: "Seleccionar estado",
  userCode: "Código de usuario",
  enterUserCode: "Ingresar código de usuario",
  emailAddress: "Dirección de correo electrónico",
  mobileNumber: "Número de móvil",
  contactType: "Tipo de contacto",
  enterHere: "Ingresar aquí",
  dateOfBirth: "Fecha de nacimiento",
  typeOfUser: "Tipo de usuario",
  thisUserIsALeader: "Este usuario es un líder",
  checkThisBoxIfTheUserAboveIsAlsoALeader: "Marca esta casilla si el usuario anterior también es un líder",
  useEmailAddress: "Usar dirección de correo electrónico",
  citySuburb: "Ciudad / Localidad",
  postcode: "Código postal",
  countryOrRegion: "País o Región",
  timezone: "Zona Horaria",
  enterFirstName: "Ingresar nombre",
  enterLastName: "Ingresar apellido",
  dateNumberFormat: "Formato de fecha / número",
  defaultCurrency: "Moneda predeterminada",
  userInactive: "Usuario inactivo",
  roles: "Roles",
  communications: "Comunicaciones",
  communicationSubscriptions: "Suscripciones de comunicación",
  searchByEnter: "Buscar presionando Enter",
  approve: "Aprobar",
  decline: "Rechazar",
  activeNetwork: "Red activa",
  invites: "Invitaciones",
  reject: "Rechazar",
  approved: "Aprobado",
  waitingForApproval: "Esperando aprobación",
  sendToReview: "Enviar a revisión",
  automaticallyInvitationSentBy: "Invitación enviada automáticamente por",
  importerExporter: "Importador y Exportador",
  newRole: "Nuevo rol",
  editRole: "Editar rol",
  continue: "Continuar",
  saveWithoutAssigning: "Guardar sin asignar",
  saveAndAssign: "Guardar y asignar",
  createRole: "Crear rol",
  createRoom: "Crear habitación",
  updateRole: "Actualizar rol",
  assignUser: "Asignar usuario",
  productSIsRequired: "¡Se requiere(n) producto(s)!",
  roleName: "Nombre del rol",
  roleDescriptionOptional: "Descripción del rol (opcional)",
  quoteAssignedTo: "Cotización asignada a",
  manager: "Gerente",
  searchForManager: "Buscar gerente",
  youMustEnterAnEntityName: "*Debe ingresar un nombre de entidad",
  youMustEnterAnAddress: "*Debe ingresar una dirección",
  youMustEnterASuburbTown: "*Debe ingresar una localidad/ciudad",
  youMustEnterAState: "*Debe ingresar un estado",
  youMustEnterACountry: "*Debe ingresar un país",
  youMustEnterAPostalcode: "*Debe ingresar un código postal",
  youMustEnterARegistrationNumber: "*Debe ingresar un número de registro",
  youMustEnterABillingEmail: "*Debe ingresar un correo de facturación",
  youMustEnterAMobile: "*Debe ingresar un móvil",
  youMustEnterATimezone: "*Debe ingresar una zona horaria",
  youMustEnterAConsultant: "*Debe ingresar un consultor",
  youMustEnterAContactPerson: "*Debe ingresar una persona de contacto",
  youMustEnterAFirstName: "*Debe ingresar un nombre",
  youMustEnterALastName: "*Debe ingresar un apellido",
  youMustEnterAnEmail: "*Debe ingresar un correo electrónico",
  youMustEnterAName: "*Debe ingresar un nombre",
  youMustEnterAPhoneNumber: "*Debe ingresar un número de teléfono",
  youMustEnterAParentCode: "*Debe ingresar un número de ID padre",
  youMustEnterALocationName: "*Debe ingresar un nombre de ubicación",
  youMustEnterAStatus: "*Debe ingresar un estado",
  youMustEnterAnEstablishedYear: "*Debe ingresar el año de fundación",
  youMustEnterASince: "*Debe ingresar una fecha de inicio",
  youMustEnterAnEntityLegalName: "*Debe ingresar el nombre legal de la entidad",
  youMustEnterAWebsite: "*Debe ingresar un sitio web",
  youMustEnterAContactName: "*Debe ingresar un nombre de contacto",
  youMustEnterAContactType: "*Debe ingresar un tipo de contacto",
  startTypingToSearchDots: "Comience a escribir para buscar...",
  established: "Establecido",
  establishedYear: "Año de fundación",
  since: "Desde",
  entity: "Entidad",
  entityLegalName: "Nombre legal de la entidad",
  mobile: "Móvil",
  customerDetails: "Detalles del cliente",
  editCustomer: "Editar Cliente",
  useTheSameAddressForPostalAddress: "¿Usar la misma dirección como dirección postal?",
  registrationNumber: "Número de registro",
  addAnotherContact: "Agregar otro contacto",
  includeInEmail: "Incluir en correo electrónico",
  consultant: "Consultor",
  searchConsultant: "Buscar consultor",
  searchWarehouse: "Buscar almacén",
  searchTimezone: "Buscar zona horaria",
  billingEmail: "Correo de facturación",
  postalAddress: "Dirección postal",
  contact: "Contacto",
  contactPerson: "Persona de Contacto",
  invalidLink: "Enlace inválido",
  closeWindow: "Cerrar ventana",
  youHaventAcceptedTheInvitation: "No has aceptado la invitación",
  thisLinkIsNotValidPleaseCheckIfYouHaveAccessedTheCorrectLink: "Este enlace no es válido. Por favor, verifica si has accedido al enlace correcto",
  youCanSafelyCloseThisWindowNowIfYouNeedAnyFurtherAssistanceFeelFreeToReachOutHaveAGreatDay: "Puedes cerrar esta ventana de forma segura. Si necesitas más ayuda, no dudes en contactarnos. ¡Que tengas un buen día!",
  enterLocationName: "Ingresar nombre de ubicación",
  enterWebsite: "Ingresar sitio web",
  enterRegistrationNumber: "Ingresar número de registro",
  primaryContact: "Contacto principal",
  createLocation: "Crear ubicación",
  viewLocation: "Ver ubicación",
  editLocation: "Editar ubicación",
  jobType: "Tipo de Trabajo",
  warehouseOrigin: "Almacén de origen",
  warehouseDestination: "Almacén de destino",
  tag: "Etiqueta",
  billingAs: "Facturar como:",
  leadSourceFrom: "Fuente del prospecto",
  moveCoordinator: "Coordinador de mudanza",
  inventoryQuoted: "Inventario cotizado",
  inventoryLeader: "Líder de inventario",
  inventoryActual: "Inventario real",
  myDetails: "Mis datos",
  orderDetails: "Detalles del Pedido",
  actualAsQuoted: "Real según cotizado",
  movingFrom: "Mudando desde",
  movingTo: "Mudando hacia",
  itemQuantity: "Cantidad de artículos",
  inventories: "Inventarios",
  originContact: "Contacto de origen",
  destinationContact: "Contacto de destino",
  seeAccessChecklist: "Ver lista de verificación de acceso",
  pickupAccessDetails: "Detalles de acceso para recogida",
  deliveryAccessDetails: "Detalles de acceso para entrega",
  noContactsAdded: "No se han agregado contactos",
  complement: "Complemento",
  street: "Calle",
  typeOfBuilding: "Tipo de edificio",
  loadingDockHeight: "Altura del muelle de carga",
  liftAvailable: "Elevador disponible",
  accessInstructions: "Instrucciones de acceso",
  navigationNotes: "Notas de navegación",
  createYourShipeeziAccount: "Crea tu cuenta de Shipeezi",
  createAccount: "Crear tu cuenta",
  haveAnAccountSignIn: "¿Tienes cuenta? Inicia sesión",
  mode: "Modo",
  service: "Servicio",
  editOrder: "Editar Pedido",
  newOrder: "Nuevo Pedido",
  weight: "Peso",
  truckType: "Tipo de camión",
  carrier: "Transportista",
  truckBookingNumber: "Número de reserva del camión",
  trackingNumber: "Número de Seguimiento",
  palletsPerTruck: "Paletas por camión",
  deliveryDate: "Fecha de entrega",
  proposedDeliveryDate: "Fecha de entrega propuesta",
  bookingDetails: "Detalles de la reserva",
  deliveryAddress: "Dirección de entrega",
  deliveryAddressLine: "Línea de dirección de entrega",
  deliveryAddressSuburb: "Localidad de dirección de entrega",
  receiver: "Receptor",
  senderAddress: "Dirección del remitente",
  senderAddressLine: "Línea de dirección del remitente",
  senderAddressSuburb: "Localidad de dirección del remitente",
  palletsQty: "Cantidad de paletas",
  cartonQty: "Cantidad de cajas",
  despatchDate: "Fecha de despacho",
  pleaseEnterAYourFirstName: "*Por favor, ingresa tu nombre.",
  pleaseEnterAYourLastName: "*Por favor, ingresa tu apellido.",
  pleaseEnterAYourEmailAddress: "*Por favor, ingresa tu dirección de correo electrónico.",
  pleaseEnterAPassword: "*Por favor, ingresa una contraseña.",
  pleaseConfirmAPassword: "*Por favor, confirma la contraseña.",
  pleaseEnterAUsername: "*Por favor, ingresa un nombre de usuario.",
  pleaseEnterAMobilePhone: "*Por favor, ingresa un número de móvil.",
  atLeastOnePhotoIsRequired: "*Se requiere al menos una foto",
  atLeastOneProductIsRequired: "Se requiere al menos un producto",
  thisEmailIsInvalid: "*Este correo electrónico es inválido",
  thisFieldIsRequired: "Este campo es obligatorio",
  selectAnAccessRule: "Seleccionar una regla de acceso",
  youNeedToSelectAtLeastOneBranch: "*Debes seleccionar al menos una sucursal",
  youNeedToSelectAtLeastOneSection: "*Debes seleccionar al menos una sección",
  youNeedToSelectAtLeastOneContact: "*Debes seleccionar al menos un contacto",
  youMustEnterACustomer: "*Debes ingresar un cliente",
  youMustEnterAEmail: "*Debes ingresar un correo electrónico",
  youMustEnterAnMobile: "*Debes ingresar un móvil",
  youMustHaveAtLeastOneLocation: "*Debes tener al menos una ubicación",
  youMustHaveAtLeastOnePrimaryLocation: "*Debes tener al menos una ubicación principal",
  pleaseEnterAValidEmail: "*Por favor ingresa un correo electrónico válido",
  quoted: "Cotizado",
  actual: "Real",
  totalItems: "Total de artículos",
  registered: "Registrado",
  loaded: "Cargado",
  taken: "Tomado",
  delivered: "Entregado",
  void: "Nulo",
  disposal: "Disposición",
  missing: "Faltante",
  missingShipment: "Envío faltante",
  shipped: "Enviado",
  packed: "Embalado",
  uplifted: "Recogido",
  bol: "BoL",
  selectNewStatusForItem: "Seleccionar nuevo estado para el artículo",
  item: "Artículo",
  items: "Artículos",
  packer: "Embalador",
  selectPacker: "Seleccionar embalador",
  selectNewStatusForItems: "Seleccionar nuevo estado para los artículos",
  newStatus: "Nuevo estado",
  changeItemsStatus: "Cambiar estado de artículos",
  addNewItem: "Agregar nuevo artículo",
  createNewItem: "Crear nuevo artículo",
  addNewRoom: "Agregar nueva habitación",
  editItem: "Editar artículo",
  viewItem: "Ver artículo",
  createNewOne: "Crear + Uno nuevo",
  comment: "Comentario",
  createNewComment: "Crear nuevo comentario",
  newComment: "Nuevo comentario",
  commentBy: "Comentario por",
  hideCommentHistory: "Ocultar historial de comentarios",
  seeCommentHistory: "Ver historial de comentarios",
  copyInfoFromPickup: "Copiar información de recogida",
  copyInfoFromDelivery: "Copiar información de entrega",
  pickup: "Recolección",
  pickUp: "Recoger",
  delivery: "Entrega",
  switchToManual: "Cambiar a ingreso manual de dirección",
  switchToGoogle: "Cambiar a ingreso por Google Maps",
  addAnotherAddress: "Agregar otra dirección",
  selectATask: "Seleccionar una tarea",
  enterADateInField: "Ingresar una fecha en el campo",
  theSurveyDateMustBeGreaterThanTheCurrentDate: "La fecha de la encuesta debe ser posterior a la fecha actual",
  time: "Hora",
  date: "Fecha",
  addATask: "Agregar una tarea",
  enterOnTheVideoSurvey: "Ingresar a la encuesta por video",
  startVideoSurvey: "Iniciar encuesta por video",
  scheduleAVideoSurvey: "Programar una encuesta por video",
  thisDateIsInvalid: "Esta fecha es inválida",
  notAvailable: "No disponible",
  addATaskHomeSurveyOrVideoSurveyToCreateAQuote: "Agrega una tarea de Inspección domiciliaria o Encuesta por video para crear una cotización",
  pickupAccess: "Acceso de recogida",
  deliveryAccess: "Acceso de entrega",
  switchToPickupAccess: "Cambiar a acceso de recogida",
  switchToDeliveryAccess: "Cambiar a acceso de entrega",
  duplicate: "Duplicar",
  willTheEntryOfTheHouseBeObstructed: "¿Estará obstruida la entrada de la casa?",
  driveway: "Acceso vehicular",
  steep: "Empinado",
  long: "Largo",
  whatIsTheLengthM: "¿Cuál es la longitud (m)?",
  residence: "Residencia",
  residenceType: "Tipo de residencia",
  house: "Casa",
  apartment: "Apartamento",
  level: "Nivel",
  howManyLevels: "¿Cuántos niveles?",
  groundFloor: "Planta baja",
  split: "Dividido",
  multiStorey: "Varios pisos",
  steps: "Escalones",
  notAuthorizedByCustomer: "No autorizado por el cliente",
  photos: "Fotos",
  addPhoto: "Agregar foto",
  hasLift: "¿Tiene ascensor?",
  lift: "Ascensor",
  internal: "Interno",
  external: "Externo",
  streetAccess: "Acceso a la calle",
  wide: "Amplio",
  narrow: "Estrecho",
  step: "Escalón",
  normal: "Normal",
  permitRequired: "Se requiere permiso",
  oneWay: "Sentido único",
  culDeSac: "Callejón sin salida",
  roundabout: "Rotonda",
  speedHumps: "Reductores de velocidad",
  noThroughRoad: "Sin paso",
  road: "Terrestre",
  sea: "Marítimo",
  air: "Aéreo",
  ferry: "Ferry",
  storage: "Almacenamiento",
  other: "Otro",
  parking: "Estacionamiento",
  parkingType: "Tipo de estacionamiento",
  carry: "Cargar",
  carryM: "Cargar (m)",
  treesPowerline: "Árboles/Línea eléctrica",
  overhanging: "Con voladizo",
  low: "Bajo",
  action: "Acción",
  vehicleSize: "Tamaño del vehículo",
  small: "Pequeño",
  rigid: "Rígido",
  semi: "Semi",
  isFerryRequired: "¿Se requiere ferry?",
  saveAComment: "Guardar un comentario",
  createComment: "Crear comentario",
  saveABookmark: "Guardar un marcador",
  takeAScreenshot: "Tomar una captura de pantalla",
  accessDetailsDescribedAboveAreAccurateToTheBestOfMyKnowledge: "Los detalles de acceso descritos anteriormente son precisos según mi mejor conocimiento",
  specialInstructions: "Instrucciones especiales",
  itemInstructionStatus: "Estado de instrucción del artículo",
  deleteAddress: "Eliminar dirección",
  thereAreItemsOrMaterialsRegisteredWithThisAddressIfYouDeleteThisAddressNowAllItemsWillBeRegisteredWithTheMainDeliveryAddressWouldYouLikeToDoThat: "Hay artículos o materiales registrados con esta dirección. Si eliminas esta dirección, todos los artículos quedarán registrados con la dirección de entrega principal. ¿Deseas hacerlo?",
  inventory: "Inventario",
  itemDetails: "Detalles del artículo",
  materialDetails: "Material - Detalles",
  addAnother: "Agregar otro",
  fileIsTooBigMax2Mb: "El archivo es demasiado grande (máx. 2 MB)",
  thisFileExtensionIsNotAllowed: "Esta extensión de archivo no está permitida",
  fileIsTooBigMax8Mb: "El archivo es demasiado grande (máx. 8 MB)",
  fileAlreadyExistsInThisFolder: "Ya existe un archivo con este nombre en esta carpeta",
  anotherFolderWithThisNameAlreadyExists: "Ya existe otra carpeta con este nombre",
  newFolder: "Nueva carpeta",
  upload: "Subir",
  uploading: "Subiendo",
  uploadingYourContent: "Subiendo tu contenido",
  share: "Compartir",
  shared: "Compartido",
  unshare: "Dejar de compartir",
  notBeingShared: "No se está compartiendo",
  stopSharing: "Dejar de compartir",
  cancelRequest: "Cancelar solicitud",
  requestDocument: "Solicitar documento",
  empty: "Vacío",
  file: "Archivo",
  files: "Archivos",
  folder: "Carpeta",
  rename: "Renombrar",
  currentStock: "Stock actual",
  theFolderNameIsRequired: "El nombre de la carpeta es obligatorio",
  theFileNameIsRequired: "El nombre del archivo es obligatorio",
  accessChecklistSummary: "Resumen de lista de verificación de acceso",
  selectAnOption: "Seleccionar una opción",
  searchTask: "Buscar tarea",
  anErrorOccuredTryAgain: "Ocurrió un error, inténtalo de nuevo.",
  secondContact: "Segundo contacto",
  pleaseSelectAQuoteType: "Por favor, selecciona un tipo de cotización",
  pleaseFillAReference: "Por favor, completa una referencia",
  pleaseSelectAStatus: "Por favor, selecciona un estado",
  pleaseSelectAConsultant: "Por favor, selecciona un consultor",
  pleaseSelectAManager: "Por favor, selecciona un gerente",
  pleaseSelectAMode: "Por favor, selecciona un modo",
  pleaseFillPickUpCustomerFields: "Por favor, completa los campos del cliente en recogida",
  pleaseFillPickUpAddressFields: "Por favor, completa los campos de dirección de recogida",
  pleaseFillDeliveryCustomerFields: "Por favor, completa los campos del cliente en entrega",
  pleaseFillDeliveryAddressFields: "Por favor, completa los campos de dirección de entrega",
  pleaseCheckTheAccessDetailsDescribedOnPickupAccess: "Por favor, verifica los detalles de acceso descritos en acceso de recogida",
  customRange: "Rango personalizado",
  summaryFromSales: "Resumen de ventas",
  toAddAnOrderClickOnTheButtonBelow: "Para agregar un pedido, haz clic en el botón de abajo.",
  addOrderToAShipment: "Agregar pedido a un envío",
  addOrder: "Agregar pedido",
  addOrders: "Agregar pedidos",
  changeOrderToAShipment: "Cambiar pedido a un envío",
  selectShipmentsBelowToAddThem: "Selecciona los envíos de abajo para agregarlos.",
  matchOrigin: "Coincidir origen",
  matchDestination: "Coincidir destino",
  notSent: "No enviado",
  shipmentOrigin: "Origen del Envío",
  shipmentDestination: "Destino del Envío",
  portName: "Nombre del Puerto",
  airportName: "Nombre del Aeropuerto",
  recordDeleted: "Registro eliminado",
  noVideoRecorded: "No hay video grabado",
  noCommentsRegistered: "No hay comentarios registrados",
  noScreenshotsRegistered: "No hay capturas de pantalla registradas",
  noBookmarksRegistered: "No hay marcadores registrados",
  videoSurvey: "Encuesta en Video",
  videos: "Videos",
  communication: "Comunicación",
  document: "Documento",
  documents: "Documentos",
  documentSharing: "Compartir Documentos",
  documentsForThisBooking: "Documentos para esta reserva",
  map: "Mapa",
  costing: "Costeo",
  addProduct: "Agregar Producto",
  addProducts: "Agregar Productos",
  addProductToCarton: "Agregar Producto a la Caja",
  sendEmail: "Enviar Correo",
  sendSMS: "Enviar SMS",
  attachmentFailedPleaseTryAgainLater: "Error en adjunto. ¡Por favor intenta más tarde!",
  clickToViewJson: "Haz clic para ver el JSON",
  closeJsonFile: "Cerrar archivo JSON",
  invalidEmailFormat: "Formato de Correo Inválido",
  emailSuccessfullySent: "¡Correo enviado exitosamente!",
  somethingWentWrongPleaseTryAgain: "Algo salió mal. ¡Por favor intenta de nuevo!",
  typeTheEmailAddressEnter: "Escribe la dirección de correo + enter",
  addGroupCosting: "Agregar Costeo de Grupo",
  deleteConfirmation: "Confirmación de Eliminación",
  areYouSureYouWantToRemoveThisItem: "¿Estás seguro de que deseas eliminar este ítem?",
  selectAtLeastOneItemToChangeStatus: "Selecciona al menos un ítem para cambiar el estado",
  anItemWasAddToTheSelectedRoom: "Un ítem fue agregado a la habitación seleccionada",
  aRoomHasBeenAddedToTheInventory: "Una habitación fue agregada al inventario",
  anItemWasUpdatedAtTheSelectedRoom: "Un ítem fue actualizado en la habitación seleccionada",
  anItemWasRemovedFromTheSelectedRoom: "Un ítem fue eliminado de la habitación seleccionada",
  couldNotFindItemToDuplicate: "No se pudo encontrar el ítem para duplicar",
  emailSentSuccesfuly: "¡Correo enviado exitosamente!",
  smsSentSuccesfuly: "¡SMS enviado exitosamente!",
  couldNotSendEmail: "No se pudo enviar el correo",
  ifAMatchingAccountWasFoundAnEmailWasSentTo: "Si se encontró una cuenta coincidente, se envió un correo a",
  toAllowYouToResetYourPassword: "para permitirte restablecer tu contraseña.",
  isAnUser: "Es un usuario",
  isNotAnUser: "No es un usuario",
  allContacts: "Todos los contactos",
  seeAllOfYourBusinessContacts: "Ver todos tus contactos comerciales",
  editContact: "Editar contacto",
  addContact: "Agregar contacto",
  addLocation: "Agregar ubicación",
  addContactUser: "Agregar usuario de contacto",
  editContactUser: "Editar usuario de contacto",
  viewAllContacts: "Ver todos los contactos",
  registerAsAnUser: "Registrarse como usuario",
  editThisBusinessContact: "Editar este contacto comercial",
  contactDetails: "Detalles del Contacto",
  pleaseEnterARegistrationNumber: "Por favor, ingresa un número de registro",
  otherDetails: "Otros detalles",
  shipeeziNetwork: "Red Shipeezi",
  agentIsConnectedToTheShipeezisNetwork: "El agente está conectado a la red de Shipeezi",
  inviteToNetwork: "Invitar a la red",
  actions: "Acciones",
  sortBy: "Ordenar por",
  inactiveCompany: "Empresa inactiva",
  billing: "Facturación",
  primary: "Principal",
  secondary: "Secundario",
  general: "General",
  generalPhoto: "Foto General",
  overview: "Resumen",
  manageUsers: "Gestionar usuarios",
  monthlyPayment: "Pago mensual",
  addSeats: "Agregar asientos",
  currentPlan: "Plan actual",
  changePlan: "Cambiar plan",
  lastPaidInvoice: "Última factura pagada",
  billingDetails: "Detalles de facturación",
  editPaymentDetails: "Editar detalles de pago",
  cardHolder: "Titular de la tarjeta",
  creditCardNumber: "Número de tarjeta de crédito",
  cvv: "CVV",
  expDate: "Fecha de vencimiento",
  billingAddress: "Dirección de Facturación",
  people: "Personas",
  resources: "Recursos",
  configurations: "Configuraciones",
  preferences: "Preferencias",
  orderType: "Tipo de Pedido",
  leadSource: "Fuente del lead",
  statuses: "Estados",
  integrations: "Integraciones",
  apiAllied: "API Allied",
  history: "Historial",
  checklistForms: "Checklists y Formularios",
  fleet: "Flota",
  equimpent: "Equipo",
  staff: "Personal",
  itemList: "Lista de Ítems",
  packagingType: "Tipo de embalaje",
  modeType: "Tipo de modo",
  exceptionCodes: "Códigos de excepción",
  exceptionLocationCode: "Código de ubicación de excepción",
  materials: "Materiales",
  instructions: "Instrucciones",
  itemDestination: "Destino del ítem",
  automation: "Automatización",
  access: "Acceso",
  iso174511: "ISO17451-1:2016 - Certificado",
  createNewUser: "Crear nuevo usuario",
  createNewRole: "Crear nuevo rol",
  createNewCustomer: "Crear nuevo cliente",
  deleteCustomer: "Eliminar cliente",
  deleteAgent: "Eliminar agente",
  deleteSelected: "Eliminar seleccionados",
  typePressEnter: "Escribe + Presiona enter",
  createUser: "Crear usuario",
  viewUser: "Ver usuario",
  viewUsers: "Ver usuarios",
  editUser: "Editar usuario",
  useCompanyAddress: "Usar dirección de la empresa",
  timezoneIsUpdatedAutomaticallyToMatchYourComputerTimezone: "La zona horaria se actualiza automáticamente para coincidir con la de tu computadora",
  inactiveUser: "Usuario inactivo",
  activeUser: "Usuario activo",
  logUserOut: "Cerrar sesión del usuario",
  searchAndSelectTheRoleTo: "Buscar y seleccionar el rol para",
  assignUsers: "Asignar usuarios",
  searchAndSelectUsersTo: "Buscar y seleccionar usuarios para",
  viewRole: "Ver rol",
  editThisRole: "Editar este rol",
  viewThisRole: "Ver este rol",
  setPermissions: "Establecer permisos",
  addANewItem: "Agregar un nuevo ítem",
  viewAnItem: "Ver un ítem",
  editAnItem: "Editar un ítem",
  editLocationForCustomer: "Editar ubicación del cliente",
  createNewLocationForCustomer: "Crear nueva ubicación del cliente",
  viewLocationForCustomer: "Ver ubicación del cliente",
  editOrderType: "Editar tipo de pedido",
  createNewOrderType: "Crear nuevo tipo de pedido",
  editLeadSource: "Editar fuente del lead",
  createNewLeadSource: "Crear nueva fuente del lead",
  leadSourceStatus: "Estado de la fuente del lead",
  editStatus: "Editar estado",
  createNewStatus: "Crear nuevo estado",
  itemName: "Nombre del Ítem",
  itemCode: "Código del Ítem",
  itemVolume: "Volumen del Ítem",
  itemWeight: "Peso del Ítem",
  photosAreMandatory: "Las fotos son obligatorias",
  brandIsMandatory: "La marca es obligatoria",
  commentIsMandatory: "El comentario es obligatorio",
  mEChecklistIsMandatory: "El Checklist M&E es obligatorio",
  inactiveItem: "Ítem inactivo",
  roomName: "Nombre de la Habitación",
  roomCode: "Código de la Habitación",
  inactiveLocation: "Ubicación Inactiva",
  editPackagingType: "Editar Tipo de Embalaje",
  createPackagingType: "Crear Tipo de Embalaje",
  packagingTypeName: "Nombre del tipo de embalaje",
  packagingTypeCode: "Código del tipo de embalaje",
  yourComment: "Tu comentario",
  packagingTypeStatus: "Estado del tipo de embalaje",
  reason: "Motivo",
  code: "Código",
  enterTypeOfContact: "Ingresar tipo de contacto",
  dimensions: "Dimensiones",
  couldnTSubscribeShipment: "No se pudo suscribir el envío",
  couldnTRetrieveShipmentStatus: "No se pudo recuperar el estado del envío",
  voyageStatusUpdated: "Estado del viaje actualizado",
  pod: "POD",
  pressEnterToAdd: "Presiona enter para agregar",
  inputYourComments: "Ingresa tus comentarios",
  portOfDestination: "Puerto de Destino",
  placeOfDestination: "Lugar de destino",
  containerGateInAtPol: "Entrada del contenedor en POL",
  containerGateInPort: "Entrada del contenedor en el puerto",
  nextPort: "Próximo Puerto",
  containerLoadedAtFirstPolPortOfLoad: "Contenedor cargado en el primer POL (Puerto de Carga)",
  containerGateOutAtPodPortOfDischarge: "Salida del contenedor en POD (Puerto de Descarga)",
  originPort: "Puerto de Origen",
  finalDestinationPort: "Puerto de Destino Final",
  estimatedArrival: "Llegada estimada",
  actualArrival: "Llegada real",
  carrierEstimatedArrival: "Llegada Estimada por el Naviero",
  carrierActualArrival: "Llegada Real por el Naviero",
  arrivalAtPort: "Llegada al Puerto",
  departureAtPort: "Salida del Puerto",
  predictiveArrivalAt: "Llegada predictiva en",
  arrivalAt: "Llegada en",
  editCurrency: "Editar Moneda",
  createCurrency: "Crear Moneda",
  editItemInstruction: "Editar Instrucción del Ítem",
  createItemInstruction: "Crear Instrucción del Ítem",
  addANewCurrency: "Agregar una nueva moneda",
  australianDollar: "Dólar australiano",
  a: "A$",
  currencyView: "Vista de Moneda",
  currencyStatus: "Estado de la moneda",
  editLanguage: "Editar Idioma",
  actualStatus: "Estado real",
  createNewLanguage: "Crear nuevo idioma",
  baseLanguage: "Idioma base",
  en: "EN",
  measurementStatus: "Estado de la medida",
  flag: "Bandera",
  where: "Dónde",
  usage: "Uso",
  filteringBy: "Filtrando por ",
  editModeType: "Editar tipo de modo",
  createModeType: "Crear tipo de modo",
  editThisModeType: "Editar este tipo de modo",
  addNewModeType: "Agregar nuevo tipo de modo",
  modeTypeStatus: "Estado del tipo de modo",
  needAddAHomeOrVideoSurvey: "Necesitas agregar una inspección domiciliaria o por video",
  quotedInventory: "Inventario cotizado",
  chooseADestination: "Elegir un destino",
  aMaterialWasAddToTheSelectedRoom: "Se agregó un material a la habitación seleccionada",
  pressEnterToSaveOrEscToCancel: "Presiona Enter para guardar o ESC para cancelar",
  youHaveToChooseAQuoteModeToAddAnItem: "Debes elegir un modo de cotización para agregar un artículo",
  youHaveToChooseAQuoteModeToAddAMaterial: "Debes elegir un modo de cotización para agregar un material",
  youHaveToSelectARoomBeforeAddAMaterial: "Debes seleccionar una habitación antes de agregar un material",
  aRoomWithThisNameAlreadyExists: "Ya existe una habitación con este nombre",
  youHaveToSelectARoomBeforeAddAnItem: "Debes seleccionar una habitación antes de agregar un artículo",
  generateToken: "Generar token",
  copyToken: "Copiar token",
  copiedSuccessfully: "Copiado exitosamente",
  unitQty: "Cantidad unitaria",
  productQty: "Cantidad de productos",
  qtyStock: "Cantidad (Stock)",
  qtyShipping: "Cantidad (Envío)",
  latitude: "Latitud",
  longitude: "Longitud",
  vesselType: "Tipo de buque",
  vesselPosition: "Posición del buque",
  speedKnots: "Velocidad (nudos)",
  editMeasurement: "Editar Medida",
  createMeasurement: "Crear Medida",
  createNewStaff: "Crear nuevo personal",
  viewStaff: "Ver personal",
  male: "Masculino",
  female: "Femenino",
  createService: "Crear servicio",
  editService: "Editar servicio",
  viewService: "Ver servicio",
  serviceStatus: "Estado del servicio",
  sellDescription: "Descripción de venta",
  serviceDescription: "Descripción del servicio",
  sellType: "Tipo de venta",
  m3Fee: "Tarifa M3",
  defaultPrice: "Precio predeterminado",
  serviceGroup: "Grupo de servicio",
  inputMessage: "Ingresar mensaje",
  viewChecklist: "Ver lista de verificación",
  editChecklist: "Editar lista de verificación",
  createChecklist: "Crear lista de verificación",
  emptyList: "Lista vacía",
  addAll: "Agregar todo",
  addType: "Agregar tipo",
  addBranch: "Agregar sucursal",
  jobTypeAlreadyExistInTheList: "El tipo de trabajo ya existe en la lista",
  branchAlreadyExistInTheList: "La sucursal ya existe en la lista",
  riskAssessment: "Evaluación de riesgos",
  vehicleTrailer: "Vehículo/Remolque",
  required: "Obligatorio",
  title: "Bienvenido a Shipeezi — donde la visibilidad, el control y la simplicidad se unen",
  needAction: "Necesita acción",
  answerAction: "Responder acción",
  addNewQuestion: "Agregar nueva pregunta",
  trigger: "Disparador",
  addNewTrigger: "Agregar nuevo disparador",
  notes: "Notas",
  taskTypeAlreadyExistInTheList: "El tipo de tarea ya existe en la lista",
  taskType: "Tipo de Tarea",
  questions: "Preguntas",
  appTriggers: "Disparadores de la app",
  beforeStartTask: "Antes de iniciar la tarea",
  beforeContinueTask: "Antes de continuar la tarea",
  beforeFinishTask: "Antes de finalizar la tarea",
  beforeAcceptTask: "Antes de aceptar la tarea",
  text: "Texto",
  checkbox: "Casilla de verificación",
  decimal: "Decimal",
  integer: "Entero",
  signature: "Firma",
  photo: "Foto",
  checkboxText: "Casilla y texto",
  radioButton: "Botón de opción",
  textarea: "Área de texto",
  radioButtonText: "Botón de opción y texto",
  johnny: "Johnny",
  bravo: "Bravo",
  john: "John",
  sampleEmailCom: "muestra@correo.com",
  emergency: "Emergencia",
  pendingCustomerUpload: "Pendiente de carga del cliente",
  sharedWithCustomer: "Compartido con el cliente",
  resendRequest: "Reenviar solicitud",
  uploadedByCustomer: "Subido por el cliente",
  noDocumentsRequestedYet: "Aún no se han solicitado documentos",
  donTWorryIfAnyDocumentsAreRequestedByUsYouWillBeNotifiedAndWillBeAbleToManageThem: "No te preocupes, si nosotros solicitamos algún documento, serás notificado y podrás gestionarlos",
  oneOrMoreRequiredFieldsAreEmpty: "Uno o más campos obligatorios están vacíos",
  noChangeHasBeenDetected: "No se ha detectado ningún cambio",
  noCommentsBeTheFirstToComment: "¡Sin comentarios! Sé el primero en comentar...",
  mainAddress: "Dirección principal",
  createANewBusinessContact: "Crear un nuevo contacto empresarial",
  editABusinessContact: "Editar un contacto empresarial",
  includeInCommunications: "Incluir en comunicaciones",
  thisUserNeedsToHaveSomeProjectSelected: "Este usuario debe tener algún proyecto seleccionado",
  thisUserNeedsToHaveSomeRoleSelected: "Este usuario debe tener algún rol seleccionado",
  thePasswordDoesNotMatch: "La contraseña no coincide",
  selectPerformancePrediction: "Seleccionar predicción de rendimiento",
  performancePrediction: "Predicción de rendimiento",
  passwordAndConfirmPasswordMustBeTheSame: "La contraseña y la confirmación deben ser iguales",
  newPasswordAndConfirmPasswordMustBeTheSame: "La nueva contraseña y la confirmación deben ser iguales",
  hiThere: "¡Hola!",
  pleaseFindTheJsonFileAttachedForShipmentS: "Por favor, encuentra el archivo JSON adjunto para los envíos",
  best: "Saludos, ",
  discard: "Descartar",
  discardChanges: "Descartar cambios",
  areYouSureYouWantToDiscardAllChanges: "¿Estás seguro de que deseas descartar todos los cambios?",
  thisActionIsPermanentAndCannotBeUndone: "¡Esta acción es permanente y no se puede deshacer!",
  shipeeziAustralia: "Shipeezi Australia",
  supportShipeeziCom: "support@shipeezi.com",
  wwwShipeeziCom: "www.shipeezi.com",
  shipeeziKey: "Clave de Shipeezi",
  termsOfUsePrivacyPolicySecurityPolicy: "Términos de uso, Política de privacidad, Política de seguridad",
  andSaasAgreement: " y acuerdo SaaS ",
  agreed: "aceptado",
  thisCurrencyIsAlreadyRelatedToACompanyThereforeYouCannotChangeHisStatus: "Esta moneda ya está relacionada con una empresa, por lo tanto no puedes cambiar su estado",
  select: "Seleccionar",
  hello: "Hola,",
  dateRange: "Rango de Fechas",
  viewToday: "Ver hoy",
  activeQuotes: "Cotizaciones activas",
  quotedVolume: "Volumen cotizado",
  videoSurveys: "Encuestas por video",
  activeOrders: "Pedidos activos",
  orderVolume: "Volumen de pedidos",
  branchOrigin: "Sucursal de origen",
  branchDestination: "Sucursal de destino",
  material: "Material",
  accessStatus: "Estado de acceso",
  instruction: "Instrucción",
  scheduleCreateSuccessfully: "Horario creado exitosamente",
  sendAutomaticalyASmsEmailInvite: "Enviar automáticamente una invitación por SMS/Correo",
  theEmailOrPhoneIsAlreadyInUseByAnotherCustomer: "El correo electrónico o teléfono ya está en uso por otro cliente",
  wouldYouLikeToSendTheDetailsOfTheCallToYourCustomerBy: "¿Te gustaría enviar los detalles de la llamada a tu cliente por",
  assignRole: "Asignar rol",
  duplicateRole: "Duplicar rol",
  accessRule: "Regla de acceso",
  accessRules: "Reglas de Acceso",
  membersInGroup: "Miembros en este grupo",
  showAll: "Mostrar todo",
  enterNameForThisGroup: "Ingresar nombre para este grupo",
  describeThisGroupInFewWords: "Describe este grupo en pocas palabras",
  groupCreatedSuccessfully: "Grupo '{{groupName}}' creado exitosamente",
  groupUpdatedSuccessfully: "Grupo '{{groupName}}' actualizado exitosamente",
  anErrorOccurredWhileUpdatingGroup: "Ocurrió un error al actualizar el grupo '{{groupName}}'. Por favor, contacta",
  thisIsADefaultSystemGroupThatCannotBeModifiedButYouCanAddOrRemoveMembersFromIt: "Este es un grupo del sistema predeterminado que no puede ser modificado, pero puedes agregar o eliminar miembros de él",
  kindlyResolveTheFormErrorsBeforeProceeding: "Por favor, resuelve los errores del formulario antes de continuar...",
  theGroupNameAlreadyExistsPleaseChooseADifferentName: "El nombre de grupo '{{groupName}}' ya existe. Por favor, elige un nombre diferente",
  changeStatus: "Cambiar estado",
  purchase: "Compra",
  purchaseOrder: "Orden de Compra",
  salesOrder: "Orden de venta",
  asPlanned: "Según lo planificado",
  potentialDelay: "Retraso potencial",
  delayed: "Retrasado",
  selectAVideoSurveyOfToday: "Seleccionar una encuesta por video de hoy",
  openVideoSurvey: "Abrir encuesta por video",
  searchOrAddAReference: "Buscar o agregar una referencia",
  searchOriginAddress: "Buscar dirección de origen",
  searchDestinationAddress: "Buscar dirección de destino",
  searchOrAddACustomer: "Buscar o agregar un cliente",
  jobAlreadyExists: "El trabajo ya existe",
  associateCustomer: "Asociar cliente",
  thereIsAlreadyACustomerWithThisEmailOrPhoneNumberDoYouWantToAssociateTheTask: "Ya existe un cliente con este correo electrónico o número de teléfono, ¿deseas asociar la tarea?",
  associate: "Asociar",
  phone: "Número de teléfono",
  translation: "Traducción",
  viewActivity: "Ver actividad",
  seeActivity: "Ver actividad",
  activity: "Actividad",
  createItem: "Crear artículo",
  folders: "Carpetas",
  shipment: "Envío",
  quotes: "Cotizaciones",
  estimate: "Estimación",
  loadingQuotes: "Cargando cotizaciones",
  quotesWonVsLost: "Cotizaciones ganadas vs perdidas",
  quotesWon: "cotizaciones ganadas",
  quotesLost: "cotizaciones perdidas",
  won: "Ganado",
  lost: "Perdido",
  lastUpdatedOn: "Última actualización",
  instructionsNotFound: "Instrucciones no encontradas",
  quotesPerformed: "Cotizaciones realizadas",
  ordersByType: "Pedidos por tipo",
  orders: "Pedidos",
  loadingOrders: "Cargando pedidos",
  itFeelsABitEmpty: "Se siente un poco vacío",
  videoName: "Nombre del video",
  fetchingVideo: "Obteniendo video",
  fetchDetails: "Obtener detalles",
  videoUploadInProgress: "Carga de video en progreso",
  noVideoAvailable: "No hay video disponible",
  screenshots: "Capturas de pantalla",
  imageOfAScreenshot: "Imagen de una captura de pantalla",
  fetchingScreenshots: "Obteniendo capturas de pantalla",
  seeMore: "Ver más",
  noScreenshotAvailable: "No hay captura de pantalla disponible",
  fetchingComments: "Obteniendo comentarios",
  noCommentsAvailable: "No hay comentarios disponibles",
  screenSharing: "Compartir pantalla",
  bookmarks: "Marcadores",
  fetchingBookmarks: "Obteniendo marcadores",
  noBookmarksAvailable: "No hay marcadores disponibles",
  bookmarkSavedSuccessfully: "Marcador guardado exitosamente.",
  couldNotSaveBookmark: "No se pudo guardar el marcador",
  searchByCustomerNamePhoneNumberOrEmailAddress: "Buscar por nombre de cliente, número de teléfono o dirección de correo",
  searchManager: "Buscar gerente",
  totalQty: "Cantidad total",
  totalVolume: "Volumen Total",
  totalWeight: "Peso total",
  contacts: "Contactos",
  createANewWarehouse: "Crear un nuevo almacén",
  editWarehouse: "Editar Almacén",
  createANewBranch: "Crear una nueva sucursal",
  editBranch: "Editar Sucursal",
  viewBranch: "Ver Sucursal",
  viewWarehouse: "Ver Almacén",
  closeAllPanels: "Cerrar todos los paneles",
  collapseAllPanels: "Contraer todos los paneles",
  expandAllPanels: "Expandir todos los paneles",
  expandAll: "Expandir todo",
  collapseAll: "Contraer todo",
  tba: "TBA",
  editMaterial: "Editar material",
  createANewMaterial: "Crear un nuevo material",
  materialStatus: "Estado del material",
  isAnItem: "¿Es un artículo?",
  editInstruction: "Editar instrucción",
  createInstruction: "Crear instrucción",
  when: "Cuando",
  editTaskType: "Editar tipo de tarea",
  createTaskType: "Crear tipo de tarea",
  taskTypeStatus: "Estado del tipo de tarea",
  isBookable: "¿Es reservable?",
  isItBookable: "¿Es reservable?",
  viewDestination: "Ver destino",
  editDestination: "Editar destino",
  createDestination: "Crear destino",
  destinationStatus: "Estado del destino",
  colorValueMustStartWithAndCannotBeAWhiteColor: "El valor de color debe comenzar con # y no puede ser blanco",
  automaticSequencing: "Secuenciación automática",
  nextNumber: "Siguiente número",
  changeStatuses: "Cambiar estados",
  changeAllSelectedStatusesTo: "Cambiar todos los estados seleccionados a",
  changeItemStatuses: "Cambiar estados de artículos",
  changeAllSelectedItemsStatusesTo: "Cambiar todos los estados de artículos seleccionados a",
  visibilityControlAndTransparencyOfYourShipments: "Visibilidad, control y transparencia de tus envíos.",
  yourRequestHasExpiredMakeANewRecovery: "Tu solicitud ha expirado. Realiza una nueva recuperación",
  pleaseEnterAEmail: "Por favor, ingresa un correo electrónico.",
  resetPassword: "Restablecer contraseña",
  pleaseCheckYourEmail: "Por favor, revisa tu correo electrónico.",
  yourPasswordHasBeenUpdated: "Tu contraseña ha sido actualizada.",
  returnToLogin: "Volver al inicio de sesión",
  backToLogin: "Volver al inicio de sesión",
  didnTReceiveTheEmail: "¿No recibiste el correo? ",
  aPasswordResetMessageWasSentToYourEmailAddress: "Se envió un mensaje de restablecimiento de contraseña a tu dirección de correo.",
  enterTheEmailAddressAssociatedWithYourAccountAndWeLlSendYouALinkToResetYourPassword: "Ingresa la dirección de correo electrónico asociada con tu cuenta y te enviaremos un enlace para restablecer tu contraseña",
  createAccessOption: "Crear opción de acceso",
  editAccessOption: "Editar opción de acceso",
  drivewayLength: "Longitud del acceso vehicular",
  carryDistance: "Distancia de carga",
  switchTo: "Cambiar a",
  questionFieldsAreRequired: "Los campos de preguntas son obligatorios.",
  triggerFieldTypeIsRequired: "El tipo de campo del disparador es obligatorio.",
  valueOfEntryIsAlreadyInUsed: "El valor de la entrada ya está en uso",
  aRoleOfTypeSystemIsSelectedAndCannotBeChanged: "Está seleccionado un rol de tipo sistema y no puede ser cambiado",
  theDateIsWrong: "La fecha es incorrecta",
  theUserMustBeAtLeast18YearsOldAndUnder100YearsOld: "El usuario debe tener al menos 18 años y menos de 100 años",
  approveQuote: "Aprobar cotización",
  doYouReallyWantToApproveTheQuote: "¿Realmente deseas aprobar la cotización?",
  areYouSureYouWantToDeliverThisOrder: "¿Estás seguro de que deseas entregar este pedido?",
  areYouSureYouWantToCancelTheOrder: "¿Estás seguro de que deseas cancelar el pedido?",
  yesCancelOrder: "Sí, cancelar pedido",
  areYouSureYouWantToCancelTheQuote: "¿Estás seguro de que deseas cancelar la cotización?",
  yesCancelQuote: "Sí, cancelar cotización",
  oops: "¡Ups!",
  youShouldCancelTheseTasksInYourAppBeforeContinue: "Debes cancelar estas tareas en tu aplicación antes de continuar.",
  itLooksLikeSomeTasksOfThisOrderAreInProgress: "Parece que algunas tareas de este pedido están en progreso.",
  declineQuote: "Rechazar cotización",
  doYouReallyWantToDeclineTheQuote: "¿Realmente deseas rechazar la cotización?",
  viewInCalendarMode: "Ver en modo calendario",
  viewInGridMode: "Ver en modo cuadrícula",
  removeAll: "Eliminar todo",
  roleNotFound: "Rol no encontrado",
  userNotFound: "Usuario no encontrado",
  searchForRole: "Buscar rol...",
  searchForUser: "Buscar usuario...",
  inbound: "Entrante",
  atPort: "En puerto",
  atDc: "En DC",
  ofTotalContainers: "Del total de contenedores",
  containerDistributionByDestination: "Distribución de contenedores por destino",
  shareLink: "Compartir enlace",
  cameraOff: "Cámara apagada",
  video: "Video",
  microphone: "Micrófono",
  joinNow: "Unirse ahora",
  youDidnTAddAnyItemsYet: "Aún no has agregado artículos",
  copied: "Copiado",
  shareViaApp: "Compartir por App",
  shareViaLink: "Compartir por enlace",
  shareViaSms: "Compartir por SMS",
  shareViaWhatsapp: "Compartir por Whatsapp",
  openWhatsappToShare: "Abrir Whatsapp para compartir",
  shareViaEMail: "Compartir por correo electrónico",
  shareTheVideoSurveyWithTheCustomer: "Compartir la encuesta de video con el cliente",
  shareTheInventoryWithTheCustomer: "Compartir el inventario con el cliente",
  shareTheEstimateWithTheCustomer: "Compartir la estimación con el cliente",
  shareInventory: "Compartir inventario",
  shareEstimate: "Compartir estimación",
  shareVideoSurvey: "Compartir encuesta de video",
  inventoryUpdated: "Inventario actualizado",
  youAreAboutToLeaveVideoSurveyAreYouSure: "Estás a punto de salir de la encuesta de video. ¿Estás seguro?",
  theCustomerWillBeForcedToLeaveToo: "El cliente también será obligado a salir.",
  youHaveUnsavedChangesInTheInventory: "Tienes cambios sin guardar en el inventario.",
  audioDeviceTest: "Prueba de dispositivo de audio",
  recording: "Grabando...",
  playing: "Reproduciendo...",
  leave: "Salir",
  noIssuesDetected: "No se detectaron problemas",
  inputDevice: "Dispositivo de entrada",
  inputLevel: "Nivel de entrada",
  speaker: "Altavoz",
  outputDevice: "Dispositivo de salida",
  outputLevel: "Nivel de salida",
  connectivityAndBandwidthTest: "Prueba de conectividad y ancho de banda",
  taskTypeIsRequired: "El tipo de tarea es obligatorio.",
  orderTypeIsRequired: "El tipo de pedido es obligatorio.",
  orderTypeStatus: "Estado del tipo de pedido",
  sequence: "Secuencia",
  poNumber: "Número de OP",
  despatchedQuantity: "Cantidad despachada",
  destinationDcCmlDc: "DC destino (CML DC)",
  estimateClearedForPickUp: "Estimación autorizada para recogida",
  estimateUnpackDate: "Fecha estimada de desembalaje",
  actualArriveWh: "Llegada real al almacén",
  bookedFor: "Reservado para",
  at: "a",
  contactEmailCom: "contacto@correo.com",
  expectedCallQuality: "Calidad de llamada esperada:",
  deliverOrder: "Entregar pedido",
  generateReport: "Generar informe",
  generatePDFreports: "Generar informes PDF",
  hideSection: "Ocultar sección",
  showSection: "Mostrar sección",
  online: "En línea",
  offline: "Sin conexión",
  collapse: "Contraer",
  allow: "Permitir",
  notAllow: "No permitir",
  allowCustomer: "Permitir al cliente",
  screenshotSavedSuccessfully: "Captura de pantalla guardada exitosamente",
  couldNotSaveScreenshot: "No se pudo guardar la captura de pantalla",
  couldNotRetrieveScreenshots: "No se pudieron obtener las capturas de pantalla",
  loadingDespatches: "Cargando despachos",
  checklistStatus: "Estado de la lista de verificación",
  warehouseStatus: "Estado del almacén",
  branchStatus: "Estado de la sucursal",
  someRequiredInformationAreMissing: "Falta información requerida",
  addAnExistentContact: "Agregar un contacto existente",
  selectAContact: "Seleccionar un contacto",
  hideInput: "Ocultar entrada",
  hideForm: "Ocultar formulario",
  createNewContact: "Crear nuevo contacto",
  loadingData: "Cargando datos...",
  qty: "Cantidad",
  isThisMaterialAnItem: "¿Es este material un artículo?",
  automationAndControlForIncreasedSupplyChainVisibility: "Automatización y control para mayor visibilidad de la cadena de suministro.",
  youHavenTAddedAnyItemsYet: "Aún no has agregado artículos",
  youHavenTAddedAnyMaterialYet: "Aún no has agregado ningún material",
  prices: "Precios",
  createNewPrice: "Crear nuevo precio",
  price: "Precio",
  addNewGroup: "Agregar nuevo grupo",
  DimensionFee: "Tarifa de {dimension}",
  searchAgent: "Buscar agente",
  preferredUplift: "Recogida preferida",
  accessRuleName: "Nombre de regla de acceso",
  addAccessRule: "Agregar regla de acceso",
  groupName: "Nombre del grupo",
  newGroup: "Nuevo grupo",
  subTotal: "Subtotal",
  deleteThisLine: "Eliminar esta línea",
  thereMustBeAtLeastOneServiceInAGroup: "Debe haber al menos un servicio en un grupo",
  deleteThisGroup: "Eliminar este grupo",
  thereMustBeAtLeastOneGroupInAPrice: "Debe haber al menos un grupo en un precio",
  editGroupName: "Editar nombre del grupo",
  searchCurrency: "Buscar moneda",
  searchService: "Buscar servicio",
  priceCreatedSuccessfully: "Precio creado exitosamente",
  groupAddedSuccessfully: "Grupo agregado exitosamente",
  serviceAddedSuccessfully: "Servicio agregado exitosamente",
  pressToConfirmGroupNameChange: "Presiona para confirmar el cambio de nombre del grupo",
  pressToCancelGroupNameChange: "Presiona para cancelar el cambio de nombre del grupo",
  fillNameAndPressSaveOrEnter: "Completa el nombre y presiona guardar o Enter",
  addNewLine: "Agregar nueva línea",
  originCosts: "Costos de origen",
  destinationCosts: "Costos de destino",
  extras: "Extras",
  deleteThisPrice: "Eliminar este precio",
  agentSelected: "Agente seleccionado",
  pricingListUpdatedOn: "Lista de precios actualizada el",
  noneAgentSelected: "Ningún agente seleccionado",
  totalCosts: "Costos totales",
  manageNeverBeenEasier: "Gestionar nunca fue tan fácil",
  visibilityAtItsBest: "Visibilidad en su máxima expresión",
  shipeeziIsTheEssentialToolForCompaniesOfAllSizesToConsolidateAutomateAndUncomplicateInformationAndShipmentFlowAcrossTheGlobe: "Shipeezi es la herramienta esencial para empresas de todos los tamaños para consolidar, automatizar y simplificar el flujo de información y envíos en todo el mundo",
  saveTimeAndMoney: "Ahorra tiempo y dinero",
  withShipeeziVisibilityAndIncreasedControlIsDeliveredSavingMoreThan30InLogisticsCostsAnd60InTimeReporting: "Con Shipeezi, se logra mayor visibilidad y control, ahorrando más del 30% en costos logísticos y 60% en tiempo de informes",
  createYourAccount: "Crea tu cuenta",
  youAreJustMomentsAwayOfHavingFullVisibilityAndControlOverYourShipments: "Estás a momentos de tener plena visibilidad y control sobre tus envíos",
  confirmPassword: "Confirmar contraseña",
  haveAnAccount: "¿Tienes cuenta?",
  signIn: "Iniciar sesión",
  shipeezi: "© Shipeezi",
  termsOfUse: "Términos de uso",
  passwordsDonTMatch: "*Las contraseñas no coinciden",
  companyName: "Nombre de la empresa",
  companyType: "Tipo de empresa",
  selectCompanyType: "Seleccionar tipo de empresa",
  spShipper: "SP - Expedidor",
  fmFreightManager: "FM - Gerente de carga",
  mvMoving: "MV - Mudanzas",
  getEmailsFromShipeeziAboutProductUpdatesIndustryNewsAndEventsIfYouChangeYourMindYouCanUnsubscribeAtAnyTime: "Recibe correos de Shipeezi sobre actualizaciones de productos, noticias del sector y eventos.",
  byContinuingYouReAgreeingToShipeeziS: "Al continuar, aceptas los términos de Shipeezi",
  requestAccount: "Solicitar cuenta",
  ourTeamWillGetInTouchWithYouAsSoonAsPossible: "Nuestro equipo se pondrá en contacto contigo lo antes posible.",
  thankYouForSignUpYouCanCheckYourEmailToProceed: "Gracias por registrarte. Puedes revisar tu correo para continuar.",
  youWillReceiveAnEmailTo: "Recibirás un correo a",
  toConfirmYourSignUp: "para confirmar tu registro.",
  thereWasAnErrorCreatingTheAccount: "Hubo un error al crear la cuenta",
  captcha: "Captcha",
  captchaExpired: "Captcha expirado",
  and: "y",
  leaveVideoSurvey: "Salir de la encuesta de video",
  wellDoneOnTheMeetingWith: "¡Buen trabajo en la reunión con",
  donTForgetWhatYouHaveAvailableFromThisMeeting: "No olvides lo que tienes disponible de esta reunión.",
  didYouLeaveTheMeetingByMistake: "¿Saliste de la reunión por error? ",
  rejoinTheMeetingHere: "Volver a unirse a la reunión aquí",
  packingMaterial: "Material de embalaje",
  estimateQuote: "Cotización estimada",
  agents: "Agentes",
  editEstimate: "Editar estimación",
  charge: "Cargo",
  quantity: "Cantidad",
  rate: "Tarifa",
  margin: "Margen",
  markUp: "Margen de ganancia",
  discount: "Descuento",
  totalCost: "Costo total",
  paymentMethod: "Método de pago",
  creditCard: "Tarjeta de crédito",
  credit_card: "Tarjeta de crédito",
  account: "Cuenta",
  cash: "Efectivo",
  goBackToApp: "Volver a la app",
  closeTab: "Cerrar pestaña",
  openCommunication: "Abrir comunicación",
  enableMicrophone: "Habilitar micrófono",
  disableMicrophone: "Deshabilitar micrófono",
  enableCamera: "Habilitar cámara",
  disableCamera: "Deshabilitar cámara",
  shareScreen: "Compartir pantalla",
  stopSharingScreen: "Dejar de compartir pantalla",
  cannotShareScreenWhenAnotherUserIsSharing: "No se puede compartir pantalla cuando otro usuario está compartiendo",
  screenSharingIsNotSupportedWithThisBrowser: "El uso compartido de pantalla no es compatible con este navegador",
  emailConfirmationTimeHasExpired: "El tiempo de confirmación de correo ha expirado",
  thereWasAnErrorConfirmingTheEmail: "Hubo un error al confirmar el correo electrónico",
  emailSuccessfullyConfirmed: "Correo electrónico confirmado exitosamente",
  backToLoginPage: "Volver a la página de inicio de sesión",
  goToShipeeziBlog: "Ir al blog de Shipeezi",
  isNowVerified: "¡está ahora verificado!",
  chooseAPassword: "Elige una contraseña",
  useLettersNumbersAndSymbolsForSafety: "Usa letras, números y símbolos para mayor seguridad",
  confirmYourPassword: "Confirma tu contraseña",
  theSameOneFromAbove: "La misma de arriba",
  youJustNeedToCreateAPasswordForYourAccount: "Solo necesitas crear una contraseña para tu cuenta.",
  predictiveDeparture: "Salida predictiva:",
  departure: "Salida",
  arrival: "Llegada",
  nextPortArrival: "Llegada al próximo puerto:",
  decimalSeparator: "Separador decimal",
  thousandSeparator: "Separador de miles",
  usePoint: "Usar punto (.)",
  useComma: "Usar coma (,)",
  newService: "Nuevo servicio",
  createANewServiceOrGroup: "Crear un nuevo servicio o grupo",
  createNewGroup: "Crear nuevo grupo",
  inventoryList: "Lista de inventario",
  openLegacyVersion: "Abrir versión anterior",
  closeThisScreen: "Cerrar esta pantalla",
  changeGroupStatus: "Cambiar estado del grupo",
  noAssociatedService: "No hay servicio asociado.",
  viewGroups: "Ver grupos",
  groups: "Grupos",
  seemsLikeYouDidnTCreateAnyGroup: "Parece que no has creado ningún grupo :(",
  searchGroups: "Buscar grupos",
  groupCosting: "Costo del grupo",
  totalOfPrice: "Total del precio ",
  sent: "Enviado",
  group: "Grupo",
  changeStatusTo: "Cambiar estado a",
  totalOf: "Total de",
  lastUpdated: "Última actualización",
  thisServiceCannotBeActivatedBecauseIsUnavailable: "Este servicio no puede activarse porque no está disponible",
  thisServiceCannotBeEditedBecauseIsUnavailable: "Este servicio no puede editarse porque no está disponible",
  loadingPrices: "Cargando precios",
  updatePrices: "Actualizar precios",
  reviewPrices: "Revisar precios",
  editFile: "Editar archivo",
  uploadCsv: "Subir CSV",
  uploadCsvFile: "Subir archivo CSV",
  downloadTemplate: "Descarga nuestra plantilla CSV aquí",
  clickToDownloadThePriceTemplateAndFillPrices: "Haz clic para descargar la plantilla de precios y completar los precios",
  noFilesUploaded: "No se han subido archivos",
  noneDataHasFilled: "No se han completado datos",
  fee: "Tarifa",
  thisServiceDoesNotExist: "Este servicio no existe",
  thereIsNoRelationshipBetweenThisServiceAndTheGroup: "No hay relación entre este servicio y el grupo",
  thisGroupDoesNotExist: "Este grupo no existe",
  thereIsNoRelationshipBetweenThisGroupAndTheService: "No hay relación entre este grupo y el servicio",
  theValueOfThisFieldIsInvalid: "El valor de este campo es inválido",
  thisCurrencyDoesNotExist: "Esta moneda no existe",
  nonGrouped: "No agrupado",
  wasEditedSuccessfully: "¡fue editado exitosamente!",
  thisRecordCannotBeEditedBecauseThereIsAnErrorInTheServiceOrGroup: "Este registro no puede editarse porque hay un error en el servicio o grupo",
  theseServicesWillNotBeUpdatedIfYouWouldLikeToCorrectThemYouShouldEditFile: "Estos servicios no se actualizarán. Si deseas corregirlos, debes editar el archivo",
  thisCanBeCorrectedIfYouClickIn: "Esto se puede corregir si haces clic en ",
  latestUpload: "Última carga",
  youCanOnlyContinueAfterAllWarningsHaveBeenResolved: "Solo puedes continuar después de que todas las advertencias hayan sido resueltas",
  timeControl: "Control de tiempo",
  arrivedAtTheResidence: "Llegó a la residencia",
  breakFrom: "Descanso desde",
  to: "Para",
  leavingTheResidence: "Saliendo de la residencia",
  arrivedBackToTheWarehouse: "Regresó al almacén",
  timeSummary: "Resumen de tiempo",
  transitTime: "Tiempo de tránsito",
  breakTime: "Tiempo de descanso",
  workTime: "Tiempo de trabajo",
  totalTime: "Tiempo total",
  extraStaff: "Personal extra",
  deleteSubscriber: "Eliminar suscriptor",
  whenYouDeleteANotification: "Cuando eliminas una notificación, el contacto asociado recibirá",
  wouldYouLikeToProceed: "¿Deseas continuar?",
  pricesUpdatedSuccessfully: "Precios actualizados exitosamente",
  weWillUpdateAllPricesDisregardingThoseMarkedWith: "Actualizaremos todos los precios, exceptuando los marcados con",
  ifYouWantToUpdateThesePricesYouShouldEditFile: "Si deseas actualizar estos precios, debes editar el archivo",
  newMessage: "¡Nuevo mensaje!",
  oopsIncorrectCredentials: "¡Ups! Credenciales incorrectas.",
  leaveWithoutSave: "Salir sin guardar",
  youHaveUnsavedChangesAreYouSureYouWantToLeave: "Tienes cambios sin guardar. ¿Estás seguro de que deseas salir?",
  youShouldSaveYourWorkBeforeLeaving: "Debes guardar tu trabajo antes de salir.",
  doYouReallyWantToDeleteThisAgent: "¿Realmente deseas eliminar este agente?",
  agentDetails: "Detalles del agente",
  toAllowYourPasswordReset: "para permitir el restablecimiento de tu contraseña.",
  sorryTheLinkHasExpired: "Lo sentimos, el enlace ha expirado.",
  theResetPasswordLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow: "El enlace para restablecer la contraseña ha expirado. Puedes solicitar uno nuevo haciendo clic en el botón de abajo",
  resetPasswordLink: "Enlace para restablecer contraseña",
  emailSuccessfullyResent: "Correo reenviado exitosamente",
  anUnknownErrorHasOccurred: "Ha ocurrido un error desconocido",
  emailOrUsernameIsRequired: "El correo electrónico o nombre de usuario es obligatorio",
  passwordIsRequired: "La contraseña es obligatoria",
  userLoggedIn: "Usuario con sesión iniciada",
  thereWasAnErrorCapturingYourEmailToResend: "Hubo un error al capturar tu correo electrónico para reenviar",
  theEmailConfirmationLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow: "El enlace de confirmación de correo ha expirado. Puedes solicitar uno nuevo haciendo clic en el botón de abajo",
  resendConfirmationLink: "Reenviar enlace de confirmación",
  thankYouForRequestingAnAccountWithShipeezi: "Gracias por solicitar una cuenta con Shipeezi.",
  ourTeamWillBeInContactWithYouPriorToActivatingYourAccount: "Nuestro equipo se pondrá en contacto contigo antes de activar tu cuenta",
  companyDetails: "Agrega la información de tu empresa, dirección comercial y contacto principal",
  uploadCentre: "Sube tu información inicial para que Shipeezi pueda conectar tus datos",
  goBackToHomePage: "Volver a la página de inicio",
  goBackToLogin: "Volver al inicio de sesión",
  goBackToLoginPage: "Volver a la página de inicio de sesión",
  previous: "Anterior",
  skip: "Omitir por ahora",
  downloadOurCsvTemplateHere: "Descarga nuestra plantilla CSV aquí",
  addAdditionalUsers: "Agregar usuarios adicionales",
  theContactDetailsUsedToRegisterHasBecomeAnAdminUserAlready: "Los datos de contacto usados para registrarse ya se han convertido en un usuario administrador",
  registeredUsers: "Usuarios registrados",
  addUser: "Agregar usuario",
  aud: "AUD",
  youCanSelectToUploadYourOwnFilesInformationNowOrLaterIfYouPreferYouCanUseOurDefaultInformationTheseInformationIsInRegardsToYourInventoryItemsServicesFleetStaffAndSoOn: "Puedes optar por subir tus propios archivos ahora o más tarde. Si prefieres, puedes usar nuestra información predeterminada.",
  uploadOwnList: "Subir mi propia lista",
  useShipeeziSDefaultList: "Usar la lista predeterminada de Shipeezi",
  inventoryListIso174511: "Lista de inventario ISO17451-1:2016 Certificada",
  usingShipeeziSDefault: "Usando el predeterminado de Shipeezi",
  itemsRoomsPackagingTypeMethodOfPreparationModeTypeExceptionCodesExceptionLocationCodeItemInstructionsAndItemDestination: "Artículos, Habitaciones, Tipo de embalaje, Método de preparación, Tipo de modo, Códigos de excepción, Instrucciones de artículo y Destino de artículo",
  checklistForm: "Lista de verificación y Formulario",
  riskAssessmentTemplate: "Plantilla de evaluación de riesgos",
  usingShipeeziSSampleData: "Usando datos de muestra de Shipeezi",
  listOfMaterials: "Lista de materiales",
  aFewCommonTypesOfPackingMaterialsWillBeLoaded: "Se cargarán algunos tipos comunes de materiales de embalaje",
  services: "Servicios",
  oneServiceTypeWillBeCreated: "Se creará un tipo de servicio",
  oneStaffWillBeCreated: "Se creará un miembro del personal",
  oneVehicleWillBeCreated: "Se creará un vehículo",
  theseInstructionsCanBeUsedInTheSalesAndOperationsAppForUpliftDeliveryOrMoveCoordinator: "Estas instrucciones pueden usarse en la app de Ventas y Operaciones para recogida, entrega o coordinador de mudanza",
  usualAccessQuestionsWillBeCreatedHere: "Las preguntas habituales de acceso se crearán aquí",
  iso174511CertifiedItems: "ISO17451-1:2016 Certificado: Artículos, Habitaciones, Tipo de embalaje",
  csvUploaded: "CSV subido",
  asPerYourSelectionWeAreGoingToUploadTheStandardContentForTheFollowingSections: "Según tu selección, vamos a subir el contenido estándar para las siguientes secciones",
  youCanChooseFromTheListBelowWhichItemsYouWantToUploadAndWhichYouWantToUseShipeeziSDefault: "Puedes elegir de la lista de abajo qué elementos deseas subir y cuáles usar con el predeterminado de Shipeezi",
  weAreLoadingTheUploadedContentPleaseWait: "Estamos cargando el contenido subido, por favor espera",
  thisMightTakeAWhile: "Esto podría tardar un momento",
  ifThisIsTakingTooMuchLonger: "Si esto está tardando demasiado,",
  tryAgainHere: "intenta de nuevo aquí",
  thankYouForCompleteThisProcess: "Gracias por completar el proceso de configuración rápida.",
  readyToStartUsingShipeezi: "¿Listo para comenzar a usar Shipeezi?",
  getStarted: "Comenzar",
  confirmationEmailHasBeenSucessfullyResent: "¡El correo de confirmación fue reenviado exitosamente!",
  confirmationEmailCouldNotBeenResent: "El correo de confirmación no pudo ser reenviado.",
  resetUserPassword: "Restablecer contraseña del usuario",
  businessLogo: "Logo empresarial",
  businessIcon: "Ícono empresarial",
  addLogo: "Agregar logo",
  choosePicture: "Elegir imagen",
  maxSize: "Tamaño máximo",
  formats: "Formatos",
  crop: "Recortar",
  version: "Versión",
  profile: "Perfil",
  emailToResetPasswordSent: "Correo para restablecer contraseña enviado",
  "2Mb": "2 MB",
  maxFileSize: "Tamaño máximo de archivo:",
  fileTypes: "Tipos de archivo:",
  accountDetails: "Detalles de la cuenta",
  csvTemplateIsInvalid: "La plantilla CSV es inválida",
  line: "Línea",
  isRequired: "es obligatorio",
  mustBeOneOfTheValidOptions: "debe ser una de las opciones válidas",
  mustBeFilledInWithXOrLeftEmpty: "must be filled in with \"x\" or left empty",
  mustBeANumber: "debe ser un número",
  mustBeADateWithTheFormatDdMmYyyy: "debe ser una fecha con el formato dd/mm/aaaa",
  errorsFound: "Errores encontrados",
  errorsFoundInYourFile: "Errores encontrados en tu archivo",
  on: "Activado",
  csvWeHaveFoundSomeErrorsYouShouldAdjustThoseLinesToProceed: "CSV, hemos encontrado algunos errores. Debes ajustar esas líneas para continuar",
  donTKnowWhatSWrong: "¿No sabes qué está mal?",
  downloadOurTemplateHere: "Descarga nuestra plantilla aquí",
  downloadOurTemplate: "Descarga nuestra plantilla",
  logout: "Cerrar sesión",
  logOut: "Cerrar sesión",
  userProfile: "Perfil de usuario",
  helpCenter: "Centro de ayuda",
  dispatchFilters: "Filtros de despacho",
  allTasks: "Todas las tareas",
  allTeams: "Todos los equipos",
  unpublishedTasks: "Tareas no publicadas",
  publishedTasks: "Tareas publicadas",
  teamsWithUnpublishedTasks: "Equipos con tareas no publicadas",
  teamsWithPublishedTasks: "Equipos con tareas publicadas",
  someChangesMayTakeSomeTimeToBeAppliedOnThisScreen: "Algunos cambios pueden tardar en aplicarse en esta pantalla",
  thisFleetIsUnavailableOnThisDate: "Esta flota no está disponible en esta fecha",
  thisMemberIsUnavailableOnThisDate: "Este miembro no está disponible en esta fecha",
  theFilteredDataAffectsWhatYouSeeOnDispatch: "Los datos filtrados afectan lo que ves en Despacho",
  termsAndConditions: "Términos y condiciones",
  currentlyViewing: "Viendo actualmente",
  changeTo: "Cambiar a",
  switchingAccounts: "Cambiando de cuenta.",
  unknown: "Desconocido",
  messageHasBeenSentSuccessfully: "¡El mensaje fue enviado exitosamente!",
  avatar: "Avatar",
  approvingCompany: "Aprobando empresa...",
  theCompanyHasBeenApproved: "¡La empresa ha sido aprobada!",
  nowIsReadyToRockAndRoll: "ahora está lista para funcionar.",
  quoteType: "Tipo de cotización",
  allProjects: "Todos los proyectos",
  typeMobile: "Tipo Móvil",
  searchForTimezone: "Buscar zona horaria",
  inviteUser: "Invitar usuario",
  userEmail: "Correo del usuario",
  userAddedSuccessfully: "Usuario agregado exitosamente",
  unableToRegisterAdditionalUser: "No se puede registrar un usuario adicional",
  inviteSentSuccessfully: "¡Invitación enviada exitosamente!",
  saveAndInvite: "Guardar e invitar",
  createAndInvite: "Crear e invitar",
  anEmailWasSentToUsernameWithYourRequest: "Se envió un correo al usuario con tu solicitud",
  companyInvitation: "Invitación de empresa",
  inviteDeclined: "Invitación rechazada",
  youHaveBeenInvitedToBePartOf: "Has sido invitado a ser parte de ",
  youHaveBeenInvitedToBePartOfCompany: "Has sido invitado a ser parte de la empresa",
  youCanAcceptOrDeclineTheInvitationAndWeWillNotifyTheCompanyAdministrator: "Puedes aceptar o rechazar la invitación y notificaremos al administrador de la empresa",
  weWillNotifyTheAdministrator: "Notificaremos al Administrador.",
  weWillNotifyTheAdministratorFor: "Notificaremos al Administrador de",
  youCanCloseThisWindow: "Puedes cerrar esta ventana",
  ifYouRejectedThisInvitationByMistakePleaseRequestANewInvite: "Si rechazaste esta invitación por error, solicita una nueva invitación",
  here: "aquí",
  yourInvitationExpired: "Tu invitación ha expirado",
  companyUpdatedSuccessfully: "Empresa actualizada exitosamente",
  termsAcceptedSuccessfully: "Términos aceptados exitosamente",
  by: "por",
  entityName: "Nombre de la entidad",
  sorryTheLinkIsBroken: "Lo sentimos, el enlace está roto",
  theInviteLinkIsBroken: "El enlace de invitación está roto.",
  theInviteLinkIsBrokenYouCanRequestANewOneByClickingOnTheButtonBelow: "El enlace de invitación está roto. Puedes solicitar uno nuevo haciendo clic en el botón de abajo",
  resendInviteLink: "Reenviar enlace de invitación",
  goBack: "Volver",
  theInviteLinkHasExpiredYouCanRequestANewOneByClickingOnTheButtonBelow: "El enlace de invitación ha expirado. Puedes solicitar uno nuevo haciendo clic en el botón de abajo",
  thisFieldIsAnInvalidUrl: "Este campo contiene una URL inválida",
  thisFieldShouldHaveDigitsOnly: "Este campo debe contener solo dígitos",
  validFormats: "Formatos válidos",
  typeOfInstruction: "Tipo de instrucción",
  inputYourInstruction: "Ingresa tu instrucción",
  asYouAddedAnItemThatDoesNotBelongToTheIso174511: "Agregaste un artículo que no pertenece a ISO17451-1:2016",
  requestingNewInvite: "Solicitando nueva invitación",
  youHaveAlreadyAcceptedThisInvitation: "¡Ya has aceptado esta invitación!",
  loadingInvitation: "Cargando invitación...",
  userHasNotBeenInvited: "El usuario no ha sido invitado",
  navigation: "NAVEGACIÓN",
  someOfTheseEmailsProvidedIsInvalid: "Algunos de los correos proporcionados son inválidos",
  isThisAnItemDestination: "¿Es este un destino de artículo?",
  ssccQty: "Cantidad SSCC",
  etdAtOrigin: "ETD en origen",
  etaAtDestination: "ETA en destino",
  subjects: "Asuntos",
  favorites: "Favoritos",
  reports: "Informes",
  company: "Empresa",
  itFeelsEmptyRightNow: "Se siente vacío ahora mismo.",
  status: "Status",
  filter: "Filtrar",
  reference: "Referencia",
  referenceNumber: "Número de referencia",
  customer: "Cliente",
  pdf: "PDF",
  csv: "CSV",
  exportAs: "Exportar como",
  tags: "Etiquetas",
  nothingToShowHereYet: "Aún no hay nada que mostrar.",
  thisWarehouseDoesNotAllowStorageOfLooseItemsSelectAStorageBoxInstead: "Este almacén no permite almacenamiento de artículos sueltos. Selecciona una caja de almacenamiento",
  iConfirmThatAllTheDetailsAboveAreTrue: "Confirmo que todos los detalles anteriores son verdaderos",
  notInformed: "No informado",
  signHere: "Firma aquí",
  expandAllTasks: "Expandir todas las tareas",
  hideAllTasks: "Ocultar todas las tareas",
  checkIfAnyOfTheTasksEligibleForReportGenerationUpliftDeliveryLocalHasBeenCompletedAndHasADate: "Verifica si alguna tarea elegible para informes (Recogida, Entrega, Local) ha sido completada y tiene fecha",
  asn: "ASN",
  containerSize: "Tamaño del contenedor",
  selectOne: "Seleccionar uno",
  seal: "Precinto",
  consignee: "Destinatario",
  consigneeCode: "Código del consignatario",
  deliverToWarehouse: "Entregar al almacén",
  serviceType: "Tipo de servicio",
  shipTerms: "Términos de envío",
  mbl: "MBL",
  hbl: "HBL",
  loadingPort: "Puerto de carga",
  destinationPort: "Puerto de destino",
  dischargePort: "Puerto de descarga",
  searchAddress: "Buscar dirección",
  shipperOriginAirport: "Aeropuerto de origen del remitente",
  receiverDestinationAirport: "Aeropuerto de destino del receptor",
  airports: "Aeropuertos",
  ports: "Puertos",
  roads: "Carreteras",
  scannedDate: "Fecha de escaneo",
  pickUpFromOrigin: "Recoger en origen",
  ataAtOrigin: "ATA en origen",
  ataAtDestination: "ATA en destino",
  actualDeliveryDate: "Fecha de entrega real",
  senderOriginRoad: "Carretera de origen del remitente",
  receiverDestinationRoad: "Carretera de destino del receptor",
  roadName: "Nombre de carretera",
  estimatedDeliveryDate: "Fecha de entrega estimada",
  noReportsAddedToFavorites: "No hay informes añadidos a favoritos",
  go: "Ir",
  itemInstructions: "Instrucciones de artículo",
  chooseAnItemInstruction: "Elegir una instrucción de artículo",
  notHaveDatesYet: "Aún no tiene fechas",
  videoSurveyRecordDeleted: "Registro de encuesta de video eliminado",
  theVideoRecordedForThisSurveyWasDeletedAsTheStatusHasChangedTo: "El video grabado para esta encuesta fue eliminado ya que el estado cambió a",
  youDoNotHaveAccessToThisRecordAnymore: "Ya no tienes acceso a este registro.",
  diary: "Diario",
  day: "Día",
  days: "Días",
  see: "Ver",
  moreTasks: "más tareas",
  sequenceMustBeAValidNumber: "*La secuencia debe ser un número válido",
  sequenceMustBeAIntegerNumber: "*La secuencia debe ser un número entero",
  sequenceMustBeGreaterThan0: "*La secuencia debe ser mayor que 0",
  sequenceMustBeSmallerThan1000: "*La secuencia debe ser menor que 1000",
  noTasksRegisteredForTheDay: "No hay tareas registradas para el día",
  startsAt: "Comienza a: ",
  search: "Buscar",
  seeTaskOnOrder: "Ver tarea en pedido",
  taskDetails: "Detalles de la Tarea",
  storageBoxes: "Cajas de Almacenamiento",
  storageBoxTypes: "Tipos de Cajas de Almacenamiento",
  prepayment: "Prepago",
  noneInformationToShow: "Sin información que mostrar",
  tasks: "Tareas",
  assignTask: "Asignar tarea",
  printJob: "Imprimir trabajo",
  cancelTask: "Cancelar tarea",
  yesCancelTask: "Sí, cancelar tarea",
  areYouSureYouWantToCancelThisTask: "¿Estás seguro de que deseas cancelar esta tarea?",
  searchByFleet: "Buscar por flota",
  searchByStaff: "Buscar por personal",
  searchByLeader: "Buscar por líder",
  searchByStorageBox: "Buscar por caja de almacenamiento",
  orderReference: "Referencia del pedido",
  taskStartsAt: "La tarea comienza a",
  languageName: "Nombre del idioma",
  australianEnglishSystem: "Inglés australiano (Sistema)",
  thisIsTheName: "Este es el nombre",
  term: "Término",
  createdBy: "Creado por",
  lengthM: "Longitud (m)",
  taskList: "Lista de tareas",
  exception: "Códigos de excepción",
  cancelled: "Cancelado",
  labelTooltipRecording: "Grabando",
  labelTooltipNotRecording: "No grabando",
  youAreNotAllowedToEditThisQuote: "No tienes permiso para editar esta cotización",
  youAreNotAllowedToEditThisOrder: "No tienes permiso para editar este pedido",
  fileDownloadComplete: "Descarga de archivo completa",
  scheduleNow: "Programar ahora",
  videoSurveyUnavailable: "Encuesta de video no disponible",
  thisVideoSurveyHasBeenClosed: "Esta encuesta de video ha sido cerrada",
  pleaseScheduleAnotherSurveyToContinue: "Por favor, programa otra encuesta para continuar",
  youCanScheduleAnotherVideoSurveyNowOrLater: "Puedes programar otra encuesta de video ahora o más tarde",
  theCustomerHasRemovedTheCallRecordingPermission: "El cliente ha retirado el permiso de grabación de llamada",
  theCustomerAllowedTheRecordThisCallIsBeingRecordedFromNowOn: "El cliente permitió la grabación. Esta llamada está siendo grabada a partir de ahora",
  recordingVS: "Grabando",
  notRecording: "No grabando",
  readyToShip: "Listo para enviar",
  port: "Puerto",
  deliverTo: "Entregar a",
  plane: "Avión",
  journey: "Viaje",
  airwayBill: "Guía aérea",
  cfs: "CFS",
  addNewContainer: "Agregar nuevo contenedor",
  acmeClothing: "Acme Clothing",
  purchasingOrganisation: "Organización de compras",
  orderNumber: "Número de Pedido",
  amosToken: "Token AMOS",
  token: "Token",
  australia: "Australia",
  sistrs: "SISTRS",
  pleaseEnterAValidToken: "Por favor, ingresa un token válido",
  revokeConnection: "Revocar conexión",
  areYouSureYouWantToRevokeTheConnection: "¿Estás seguro de que deseas revocar la conexión?",
  amos: "AMOS",
  copyKey: "Copiar clave",
  inviteSISTR: "Invitar SISTR",
  editSISTR: "Editar SISTR",
  SISTRemail: "Correo SISTR",
  emailAlreadyExists: "El correo electrónico ya existe",
  waybills: "Guías de transporte",
  moreOrders: "Más pedidos",
  etd: "ETD",
  print: "Imprimir",
  seeReport: "Ver informe",
  reportType: "Tipo de informe",
  uploaded: "Subido",
  uploadFile: "Subir Archivo",
  documentsUploaded: "Documentos subidos",
  dragOrClickToUploadYourFile: "Arrastra o haz clic para subir tu archivo",
  waybill: "Guía de transporte",
  estimateDates: "Fechas estimadas",
  aircraftDestination: "Destino del avión",
  aircraftOrigin: "Origen del avión",
  aircraft: "Avión",
  unpackDate: "Fecha de desembalaje",
  pickDate: "Fecha de recogida",
  arrivalOfDestination: "Fecha de entrega",
  deleteShipment: "Eliminar envío",
  image: "Imagen",
  billOfLanding: "Conocimiento de embarque",
  enterBillOfLanding: "Ingresar conocimiento de embarque",
  billOfLandingMustBeAtLeast7CharactersLong: "El conocimiento de embarque debe tener al menos 7 caracteres",
  billOfLandingMustBeAtMax20CharactersLong: "El conocimiento de embarque no puede superar los 20 caracteres",
  tradingName: "Nombre comercial",
  youCanGetStartedTrackingShipmentsFromHereRegardlessOfHowManyForwardersOrRoutes: "Puedes comenzar a rastrear envíos desde aquí, independientemente de cuántos transitarios o rutas tengas",
  eitherUploadACsvFileUsingTheTemplateOrClickNextToEnterAContainerNumber: "Sube un archivo CSV usando la plantilla o haz clic en siguiente para ingresar un número de contenedor",
  uploadYourShipmentDetails: "Sube los detalles de tu envío",
  due: "Pendiente",
  notDefined: "No definido",
  viewFile: "Ver archivo",
  thisFileIsRequired: "Este archivo es obligatorio",
  tryAgain: "Intentar de nuevo",
  tryAgain2: "Intentar de nuevo",
  ifThisIsTakingTooLong: "Si esto está tardando demasiado,",
  uploadMade: "Carga realizada",
  theFileMustBeLessThan2mbInSize: "El archivo debe ser menor a 2 MB",
  invite: "Invitar",
  inviteSupplier: "Invitar proveedor",
  inviteSuppliers: "Invitar proveedores",
  doYouWantToInvite: "¿Deseas invitar a",
  toShipeezi: "a Shipeezi?",
  anInvitationWillBeSendTo: "Se enviará una invitación a",
  activeContainers: "Contenedores activos",
  avgContainerPerWeek: "Promedio de contenedores por semana",
  containersDelayed: "Contenedores retrasados",
  containersWaitingAtGate: "Contenedores esperando en la puerta",
  totalContainers: "Total de contenedores",
  containersTracked: "Contenedores rastreados",
  averageDelay: "Retraso promedio",
  shipmentsTracked: "Envíos rastreados",
  currentVesselsWithShipmentsBeingTracked: "Buques actuales con envíos siendo rastreados",
  ctaDate: "Fecha CTA",
  teu: "TEU",
  atd: "ATD",
  actualTimeOfDeparture: "Hora real de salida",
  etaDate: "Fecha ETA",
  arrivalDate: "Fecha de llegada",
  via: "Vía",
  customerEmail: "Correo del cliente",
  estimatedDate: "Fecha estimada",
  estimatedTimeOfPortArrival: "Tiempo estimado de llegada al puerto",
  estimatedTimeOfAirportArrival: "Tiempo estimado de llegada al aeropuerto",
  companyLogo: "Logo de la empresa",
  yourShipmentIsExpectedToArriveAt: "Se espera que tu envío llegue a",
  poweredBy: "Desarrollado por",
  localTime: "Hora local",
  booked: "Reservado",
  collectedFromShipper: "Recogido del remitente",
  notArrivedAtPortOfLoad: "No llegó al puerto de carga",
  waitingAtPortOfLoad: "Esperando en el puerto de carga",
  shippedOnBoard: "Embarcado a bordo",
  underway: "En camino",
  underwayToATranshipmentPort: "En camino a un puerto de transbordo",
  arrivalAtTranshipmentPort: "Llegada al puerto de transbordo",
  waitingAtTranshipmentPort: "Esperando en el puerto de transbordo",
  shippedOnBoardAtTranshipmentPort: "Embarcado a bordo en el puerto de transbordo",
  arrivedAtPortOrDischarge: "Llegó al puerto o descarga",
  waitingAtDestinationPort: "Esperando en el puerto de destino",
  leftTheDestinationPort: "Dejó el puerto de destino",
  shipmentCompleted: "Envío completado",
  maerskCode: "Código Maersk",
  maerskBeCode: "Código BE de Maersk",
  clientCode: "Código de cliente",
  addressCode: "Código de dirección",
  divisionCode: "Código de división",
  divisionDescription: "Descripción de división",
  departmentCode: "Código de departamento",
  departmentDescription: "Descripción de departamento",
  sscc: "SSCC",
  ssccQuantity: "Cantidad SSCC",
  quantityUnit: "Unidad de cantidad",
  purchasePrice: "Precio de compra",
  style: "Estilo",
  colour: "Color",
  size: "Talla",
  expand: "Expandir",
  deleteThisSsccAndYourProducts: "Eliminar este SSCC y sus productos",
  purchaseOrders: "Órdenes de compra",
  addNewOrder: "Agregar Nuevo Pedido",
  orderDate: "Fecha del Pedido",
  shipper: "Remitente",
  readyForBooking: "Listo para reservar",
  selectOrdersBelowToAddThem: "Selecciona los pedidos de abajo para agregarlos",
  expectedStartDate: "Fecha de inicio esperada",
  expectedEndDate: "Fecha de fin esperada",
  assigned: "Asignado",
  bookByDate: "Reservar antes de",
  createBooking: "Crear reserva",
  confirmed: "Confirmado",
  underReview: "En revisión",
  received: "Recibido",
  pending: "Pendiente",
  loadingBookings: "Cargando reservas",
  scanned: "Escaneado",
  noThanks: "No, gracias",
  cancelBooking: "Cancelar reserva",
  areYouSureYouWantToCancelTheBooking: "¿Estás seguro de que deseas cancelar la reserva?",
  scannedItems: "Artículos escaneados",
  thisOrderIsCancelled: "Este pedido está cancelado",
  packingType: "Tipo de embalaje",
  conditionAtOrigin: "Condición en origen",
  conditionAtDestination: "Condición en destino",
  conditionsAtOrigin: "Condiciones en origen",
  conditionsAtDestination: "Condiciones en destino",
  conditionAt: "Condición en",
  upgradeVersionToDoThis: "Actualiza la versión para hacer esto",
  viewProduct: "Ver producto",
  hscode: "HSCODE",
  unitPrice: "Precio unitario",
  totalPrice: "Precio total",
  shipDate: "Fecha de envío",
  fobPrice: "Precio FOB",
  createSSCC: "Crear SSCC",
  newSSCCwasCreated: "¡Se creó un nuevo SSCC!",
  finish: "Finalizar",
  closeSSCC: "Cerrar SSCC",
  noInformations: "Sin información",
  itsCurrentlyLocatedAt: "está actualmente ubicado en",
  atPosition: "en la posición",
  asReportedByMarineTrafficTerrestrialAutomaticIdentificationSystem: "según reportado por el Sistema de Identificación Automática Terrestre de MarineTraffic",
  theVesselIsCurrentlyAtPort: "El buque está actualmente en el puerto",
  afterAVoyageOriginatingFromPort: "después de un viaje que se originó en el puerto",
  currentLocation: "Ubicación actual",
  delayTime: "Tiempo de retraso",
  newETA: "Nuevo ETA",
  sendTrackingLinkToACustomer: "Enviar enlace de seguimiento a un cliente o alguien más",
  areYouSureYouWantToCloseThisSSCC: "¿Estás seguro de que deseas cerrar este SSCC?",
  thisActionCannotBeUndoneAndIfYouWantToModifyThisSSCCYouMustDeleteItAndCreateANewOne: "Esta acción no se puede deshacer. Si deseas modificar este SSCC, debes eliminarlo y crear uno nuevo",
  selectProductsBelowToAddThemToSSCC: "Selecciona productos de abajo para agregarlos al SSCC",
  printLabel: "Imprimir etiqueta",
  allSelectedSsccMustBeClosedToBePrinted: "Todos los SSCC seleccionados deben estar cerrados para ser impresos",
  moreContainers: "Más contenedores",
  portOfOrigin: "Puerto de carga (PoL)",
  consignmentInfo: "Información de consignación",
  originAgent: "Agente de origen",
  destinationAgent: "Agente de destino",
  estimateTimeOfDeparture: "Hora de salida",
  estimateTimeOfArrival: "Hora de llegada",
  atDepartureDock: "En muelle de salida",
  inactivateWaybill: "Inactivar guía de transporte",
  inactiveWaybill: "Guía de transporte inactiva",
  pleaseAddAValidContainerNumber: "Por favor, agrega un número de contenedor válido",
  waitingForUpdate: "Esperando actualización",
  generated: "Generado",
  containerNumberIsInvalid: "El número de contenedor es inválido",
  itemConditions: "Condiciones del artículo",
  addAPhoto: "Agregar una foto",
  conditionsAdded: "Condiciones agregadas",
  noConditions: "Sin condiciones",
  noPhotosAdded: "No se han agregado fotos",
  itemDescription: "Descripción del artículo",
  pleaseSelectADescriptiveSymbol: "Por favor, selecciona un símbolo descriptivo",
  cbm: "CBM",
  submitted: "Enviado",
  rejected: "Rechazado",
  partiallyDelivered: "Parcialmente entregado",
  bookingMustBeConfirmed: "La reserva debe estar confirmada",
  notificationCentre: "Centro de notificaciones",
  notificationCenter: "Centro de notificaciones",
  addEmailTemplate: "Agregar plantilla de correo",
  from: "De",
  subject: "Asunto",
  bcc: "CCO",
  createNewTemplate: "Crear nueva plantilla",
  templateName: "Nombre de la plantilla",
  newTemplate: "Nueva plantilla",
  emailDetails: "Detalles del correo",
  emailContent: "Contenido del correo",
  editEmailTemplate: "Editar plantilla de correo",
  viewEmailTemplate: "Ver plantilla de correo",
  smsDetails: "Detalles del SMS",
  smsContent: "Contenido del SMS",
  pushNotificationDetails: "Detalles de la notificación push",
  pushNotificationContent: "Contenido de la notificación push",
  use178CharactersOrLessForBestDisplay: "Usa 178 caracteres o menos para mejor visualización",
  smsCharacterLimitHint: "Los mensajes SMS de más de 168 caracteres se dividirán en múltiples mensajes",
  selectATemplate: "Seleccionar una plantilla",
  addSMSTemplate: "Agregar plantilla SMS",
  editSMSTemplate: "Editar plantilla SMS",
  viewSMSTemplate: "Ver plantilla SMS",
  quoteCreation: "Creación de cotización",
  quoteApproval: "Aprobación de cotización",
  quoteDecline: "Rechazo de cotización",
  ordersCreation: "Creación de pedidos",
  orderDelivered: "Pedido entregado",
  orderCancelled: "Pedido cancelado",
  createNewDocument: "Crear nuevo documento",
  documentGenerated: "Documento generado",
  resendInvite: "Reenviar invitación",
  downloadBookingFile: "Descargar archivo de reserva",
  createAndBook: "Crear y reservar",
  saveAndBook: "Guardar y reservar",
  editBooking: "Editar reserva",
  viewBooking: "Ver reserva",
  liveAnimalsAndFish: "Animales vivos y peces",
  cerealGrains: "Granos de cereales",
  otherAgriculturalProducts: "Otros productos agrícolas",
  feedAndProductsOfAnimalOrigin: "Piensos y productos de origen animal",
  meatAndSeafood: "Carne y mariscos",
  milledGrainProducts: "Productos de granos molidos",
  otherPreparedFoodstuffs: "Otros alimentos preparados",
  alcoholicBeverages: "Bebidas alcohólicas",
  tobaccoProducts: "Productos de tabaco",
  buildingStone: "Piedra de construcción",
  naturalSands: "Arenas naturales",
  gravelAndCrushedStone: "Grava y piedra triturada",
  otherNonmetallicMinerals: "Otros minerales no metálicos",
  metallicOres: "Menas metálicas",
  coal: "Carbón",
  crudePetroleum: "Petróleo crudo",
  gasolineKeroseneAndEthanol: "Gasolina, queroseno y etanol",
  dieselAndOtherFuelOils: "Diésel y otros aceites combustibles",
  otherFossilFuelProducts: "Otros productos de combustibles fósiles",
  basicChemicals: "Productos químicos básicos",
  pharmaceuticalProducts: "Productos farmacéuticos",
  fertilizers: "Fertilizantes",
  chemicalProductsAndPreparations: "Productos y preparados químicos",
  plasticsAndRubber: "Plásticos y caucho",
  logsAndWoodInTheRough: "Troncos y madera en bruto",
  woodProducts: "Productos de madera",
  pulpPaperAndPaperboard: "Pulpa, papel y cartón",
  paperOrPaperboardArticles: "Artículos de papel o cartón",
  printedProducts: "Productos impresos",
  textilesAndLeather: "Textiles y cuero",
  nonmetallicMineralProducts: "Productos minerales no metálicos",
  metalInBasicShapes: "Metal en formas básicas",
  articlesOfMetal: "Artículos de metal",
  machinery: "Maquinaria",
  electronics: "Electrónica",
  motorizedAndOtherVehicles: "Vehículos motorizados y otros vehículos",
  otherTransportationEquipment: "Otros equipos de transporte",
  precisionInstruments: "Instrumentos de precisión",
  furniture: "Muebles",
  miscellaneousManufacturedProducts: "Productos manufacturados varios",
  wasteAndScrap: "Residuos y chatarra",
  mixedFreight: "Carga mixta",
  commodity: "Mercancía",
  fillThisFieldBeforeAddingAnotherContainer: "Completa este campo antes de agregar otro contenedor",
  youShouldHaveAtLeastOneProductInsideAnSSCCToCloseIt: "Debes tener al menos un producto dentro de un SSCC para cerrarlo",
  thisSupplierIsPartOfShipeezi: "Este proveedor es parte de Shipeezi",
  supplierNotFound: "Proveedor no encontrado",
  thisSupplierNotHaveNameToSendInvitation: "Este proveedor no tiene nombre para enviar invitación",
  thisSupplierDoesNotHaveAnEmailToSendInvitation: "Este proveedor no tiene correo electrónico para enviar invitación",
  emails: "correos electrónicos",
  youCannotInviteInactiveSuppliers: "No puedes invitar proveedores inactivos",
  financials: "Finanzas",
  communicationCentre: "Centro de Comunicación",
  communication_centre: "Centro de comunicación",
  notificationTemplates: "Plantillas de notificación",
  communicationCentreDescription: "Gestiona tus plantillas de comunicación, notificaciones y configuraciones",
  templateCreatedSuccessfully: "Plantilla creada exitosamente",
  templateUpdatedSuccessfully: "Plantilla actualizada exitosamente",
  templateDuplicatedSuccessfully: "Plantilla duplicada exitosamente",
  errorCreatingTemplate: "Error al crear plantilla",
  duplicateTemplate: "Duplicar plantilla",
  editTemplate: "Editar plantilla",
  preFilled: "Pre-rellenado",
  emailTemplates: "Plantillas de correo",
  emailTemplate: "Plantilla de correo",
  manageEmailTemplatesDescription: "Crea y gestiona plantillas de correo para diversas necesidades de comunicación",
  smsTemplates: "Plantillas SMS",
  smsTemplate: "Plantilla SMS",
  pushContentCannotExceed: "El contenido de la notificación push no puede superar 178 caracteres",
  smsContentCannotExceed: "El contenido del SMS no puede superar 168 caracteres",
  manageSmsTemplatesDescription: "Crea y gestiona plantillas SMS para notificaciones rápidas.",
  manageNotificationsDescription: "Configura preferencias y configuraciones de notificación.",
  communicationSettings: "Configuración de comunicación",
  configureCommunicationSettingsDescription: "Configura las preferencias de comunicación y las opciones de entrega.",
  clickToManage: "Haz clic para gestionar",
  searchTemplates: "Buscar plantillas...",
  noTemplatesFound: "No se encontraron plantillas",
  content: "Contenido",
  availableIn: "Disponible en",
  areYouSureYouWantToChangeTheStatus: "¿Estás seguro de que deseas cambiar el estado?",
  beneficiaryDetails: "Detalles del beneficiario",
  beneficiaryBank: "Banco beneficiario",
  accountNumber: "Número de cuenta",
  invoiceNumber: "Número de Factura",
  invoiceNo: "N.º de factura",
  ciDate: "Fecha CI",
  financialsUpdatedSuccessfully: "Finanzas actualizadas exitosamente",
  yourShipmentInformationIsLoading: "La información de tu envío está cargando",
  conditionAddedSuccessfully: "Condición agregada exitosamente",
  atDestination: "En destino",
  someSelectedSupplierHasNoName: "Algún proveedor seleccionado no tiene nombre",
  someSelectedSupplierDoesNotHaveAnEmail: "Algún proveedor seleccionado no tiene correo electrónico",
  allSelectedSuppliersMustHaveNameEmailAndNotYetBelongToShipeezi: "Todos los proveedores seleccionados deben tener nombre, correo y no pertenecer aún a Shipeezi",
  photoAddedSuccessfully: "Foto agregada exitosamente",
  generalSettings: "Configuración general",
  invalidTag: "Etiqueta inválida",
  removeOrder: "Eliminar pedido",
  houseAirWaybill: "Guía aérea de la casa",
  removeSelected: "Eliminar seleccionados",
  createWarehouse: "Crear Almacén",
  noWarehousesToShow: "No hay almacenes para mostrar",
  statusUpdatedSuccessfully: "Estado actualizado exitosamente",
  supplierPortal: "Portal de proveedores",
  youreReadyToGo: "¡Estás listo para comenzar!",
  goToLoginPage: "Ir a la página de inicio de sesión",
  onUploadedCsvWeHaveFoundSomeErrors: "En el CSV subido, hemos encontrado algunos errores",
  youShouldAdjustThoseLinesToproceed: "Debes ajustar esas líneas para continuar",
  youreNowPartOfOurPortal: "¡Ahora eres parte de nuestro portal!",
  ssccGeneration: "Generación de SSCC",
  mustHave: "Debe tener",
  digit: "dígito",
  digits: "dígitos",
  extensionDigit: "Dígito de extensión",
  gs1CompanyCode: "Código de empresa GS1",
  checkDigit: "Dígito de verificación",
  columnMustBeFilled: "la columna debe ser rellenada",
  notFound: "no encontrado",
  isNotValid: "no es válido",
  carton: "Caja",
  alreadyHasTheLimitOfProductsInside: "ya tiene el límite de productos dentro",
  thereAreNoRecordsInThisFile: "No hay registros en este archivo",
  importance: "Importancia",
  important: "Importante",
  notImportant: "No importante",
  markAsUnread: "Marcar como no leído",
  markAsRead: "Marcar como leído",
  markAsImportant: "Marcar como importante",
  unmarkAsImportant: "Desmarcar como importante",
  importantNotifications: "Notificaciones importantes",
  markAllAsRead: "Marcar todo como leído",
  seeAllNotifications: "Ver todas las notificaciones",
  ssccOpen: "SSCC abierto",
  contactVia: "Contactar vía",
  orderedQuantity: "Cantidad ordenada",
  percentage: "Porcentaje",
  areYouSureYouWantToConfirmThisBooking: "¿Estás seguro de que deseas confirmar esta reserva?",
  onceConfirmedThisWillBeSentTo: "Una vez confirmado, esto se enviará a",
  youAreNotAbleToMakeAnyAdditionalChanges: "no podrás realizar cambios adicionales",
  valueShouldBeBetween: "El valor debe estar entre",
  valueShouldBe: "El valor debe ser",
  someQuantitiesFulilledAreWrongPleaseReviewAndChangeValues: "Algunas cantidades cumplidas son incorrectas. Por favor, revisa y cambia los valores",
  areYouSureYouWantToDeleteThisShipment: "¿Estás seguro de que deseas eliminar este envío?",
  yesDeleteShipment: "Sí, eliminar este envío",
  editWaybill: "Editar guía de transporte",
  createWaybill: "Crear guía de transporte",
  youCannotAddTheSameAgent: "No puedes agregar el mismo agente",
  saveAndSubscribe: "Guardar y suscribirse",
  theProductsMustBelongToTheSameOrder: "Los productos deben pertenecer al mismo pedido",
  youShouldSelectTheProducts: "Debes seleccionar los productos",
  haveProductsFromMultipleOrders: "Tienen productos de múltiples pedidos",
  portOfLoading: "Puerto de Carga",
  portOfDischarge: "Puerto de Descarga",
  placeOfReceipt: "Lugar de Recepción",
  shipperDischargeAirport: "Aeropuerto de descarga del remitente",
  shipperReceiptAirport: "Aeropuerto de recepción del remitente",
  cargoReadyDate: "Fecha de carga lista",
  hasAlreadyBeenAssigned: "ya ha sido asignado",
  isMissingShipByDate: "le falta fecha de envío",
  shipByDateIsToEarlyForBooking: "La fecha de envío es demasiado temprana para la reserva",
  shipByDateIsToLateForBooking: "La fecha de envío es demasiado tarde para la reserva",
  office: "Oficina",
  offices: "Oficinas",
  notifyParty: "Parte notificada",
  youMustSelectABookingModeFirst: "Debes seleccionar un modo de reserva primero",
  isDifferentFromBooking: "es diferente de la reserva",
  youMustSelectABookingLoadingPortFirst: "Debes seleccionar un puerto de carga de reserva primero",
  youMustSelectABookingDestinationPortFirst: "Debes seleccionar un puerto de destino de reserva primero",
  orderAssociated: "Pedido asociado",
  selectOrder: "Seleccionar pedido",
  youMustSelectABookingDischargePortFirst: "Debes seleccionar un puerto de descarga de reserva primero",
  youMustSelectedABookingCargoReadyDateFirst: "Debes seleccionar una fecha de carga lista de reserva primero",
  mustHaveFourteenDifferenceAtMaxFromCargoReadyDate: "debe tener como máximo 14 días de diferencia con la fecha de carga lista",
  theLimitOfProductsInsideACartonIs: "El límite de productos dentro de una caja es",
  tolerancePercentage: "Porcentaje de tolerancia",
  activatingThisWillControlTheTolerancePercentageOfProductsInsideABookingToTheDefinedValue: "Activar esto controlará el porcentaje de tolerancia de productos dentro de una reserva al valor definido",
  theInputValueWillBeConvertedIntoAPercentage: "El valor ingresado se convertirá en un porcentaje",
  youNeedToMatchTheToleranceOfTheRequestedQuantities: "Debes coincidir con la tolerancia de las cantidades solicitadas",
  atLeastOneCartonIsRequiredToCarryOutTheBooking: "Se requiere al menos una caja para realizar la reserva",
  allCartonsMustContainAtLeastOneProduct: "Todas las cajas deben contener al menos un producto",
  valueMustBeGreaterThanZero: "*El valor debe ser mayor que cero",
  allSelectedProductsMustMeetTheCriteria: "Todos los productos seleccionados deben cumplir los criterios",
  thisValueMustBeAnInteger: "*Este valor debe ser un entero",
  shipByDate: "Fecha de envío",
  bookedVolume: "Volumen reservado",
  receivedVolume: "Volumen recibido",
  bookedWeight: "Peso reservado",
  receivedWeight: "Peso recibido",
  ssccQuantityBooked: "Cantidad SSCC reservada",
  ssccQuantityReceived: "Cantidad SSCC recibida",
  theValuesWereTheSame: "Los valores eran iguales",
  lessThanBooked: "menor que lo reservado",
  moreThanBooked: "mayor que lo reservado",
  volumeAndWeight: "Volumen y peso",
  insertTotalValue: "Insertar valor total",
  insertValuesOf: "Insertar valores de",
  defineTotalValueOfSSCCs: "Definir valor total de los SSCC",
  defineValuesOfOneSSCC: "Definir valores de un SSCC",
  SSCCCBM: "SSCC CBM",
  SSCCWeight: "Peso del SSCC",
  valueMustBeWithin10OfSupplierValue: "* ¡El valor debe estar dentro del -/+ 10% del valor del proveedor!",
  notReceived: "No recibido",
  receiveSSCC: "Recibir SSCC",
  changeIt: "Cambiarlo",
  theBookingWillBeSentBackToTheSupplier: "La reserva será enviada de vuelta al proveedor",
  areYouSureYouWantToChangeThisBookingStatusTo: "¿Estás seguro de que deseas cambiar el estado de esta reserva a",
  receiveAllSSCC: "Recibir todos los SSCC",
  closeIt: "Cerrarlo",
  areYouSureYouWantToMarkThisSSCCAsReceived: "¿Estás seguro de que deseas marcar este SSCC como recibido?",
  youAreAboutMarkAllSSCCAsReceived: "Estás a punto de marcar todos los SSCC como recibidos",
  areYouSure: "¿Estás seguro?",
  thisActionCannotbeUndone: "Esta acción no se puede deshacer",
  yesReceiveAll: "Sí, recibir todos",
  yesReceiveSSCC: "Sí, recibir SSCC",
  allCartonsHaveAlreadyBeenMarkedAsReceived: "Todas las cajas ya han sido marcadas como recibidas",
  bookingSummary: "Resumen de reserva",
  downloadBookingData: "Descargar datos de reserva",
  downloadReport: "Descargar informe",
  manageSSCC: "Gestionar SSCC",
  closeSSCCs: "Cerrar SSCC",
  areYouSureYouWantToClosethese: "¿Estás seguro de que deseas cerrar estos",
  thisActionCannotBeUndoneAndIfYouWantToModifyTheseSSCCsYouMustDeleteItAndCreateNewOnes: "Esta acción no se puede deshacer. Si deseas modificar estos SSCC, debes eliminarlos y crear nuevos",
  allSSCCsMustBeReceived: "Todos los SSCC deben estar recibidos",
  planned: "Planificado",
  allCartonsShouldBeClosedToCarryOutTheBooking: "Todas las cajas deben estar cerradas para realizar la reserva",
  unavailableNotification: "Notificación no disponible",
  shipeeziPredicts: "Shipeezi Predice",
  carrierShipeeziPredicts: "Transportista Shipeezi Predice",
  allSSCCMustHaveProductsInsideThemToBeClosed: "Todos los SSCC deben tener productos dentro para poder cerrarse",
  photosOf: "Fotos de ",
  generalComments: "Comentarios generales",
  valueMustBeEqualToTheSupplierValue: "El valor debe ser igual al valor del proveedor",
  beCode: "Código BE",
  pleaseEnteraValidBecode: "Por favor, ingresa un código BE válido",
  sendTaskToSistrs: "Enviar tarea a SISTRS",
  beCodeSupplierExample: "AUDASHING3 VDR",
  beCodeCustomerExample: " AUTHECOTT4 HQ",
  totalSSCC: "Total SSCC",
  markBookingAs: "Marcar reserva como",
  selectATriggerFirst: "Selecciona un disparador primero",
  default: "Predeterminado",
  commercialInvoice: "Factura Comercial",
  beneficiaryName: "Nombre del beneficiario",
  beneficiaryAddress: "Dirección del beneficiario",
  vatNumber: "Número de IVA",
  eori: "EORI -",
  fiscalAgentDetails: "Detalles del agente fiscal",
  salesContractNumber: "Número de contrato de venta",
  salesContractDate: "Fecha del contrato de venta",
  expNumber: "Número EXP",
  bankName: "Nombre del banco",
  bankAddress: "Dirección del banco",
  swiftCode: "Código SWIFT",
  paymentTerms: "Términos de Pago",
  termsOfDelivery: "Términos de entrega",
  udNumber: "Número UD",
  ercNumber: "Número ERC",
  rexNumber: "Número REX",
  commercialInvoiceDetails: "Detalles de la factura comercial",
  cfsReview: "Revisión CFS",
  receivedByCFS: "Recibido por CFS",
  lining: "Forro",
  construction: "Construcción",
  category: "Categoría",
  fabric: "Tela",
  styleCode: "Código de estilo",
  brand: "Marca",
  manufacturerDetails: "Detalles del fabricante",
  composition: "Composición",
  downloadAllFiles: "Descargar todos los archivos",
  areYouSureYouWantToRemoveThe: "¿Estás seguro de que deseas eliminar el",
  fromThisBooking: "de esta reserva",
  removePurchaseOrder: "Eliminar orden de compra",
  allSSCCsInsideThePurchaseOrderWillAlsoBeRemoved: "Todos los SSCC dentro de la orden de compra también serán eliminados",
  yesRemoveIt: "Sí, eliminarlo",
  markAndNumbers: "Marcas y números",
  limited: "Limitado",
  characters: "caracteres",
  saveEdit: "Guardar edición",
  cancelEdit: "Cancelar edición",
  purchaseOrderNumber: "Número de orden de compra",
  cartonName: "Nombre de caja",
  quotesStatus: "Estado de cotizaciones",
  someInformationOfThisSkuAreMissing: "Falta información de este SKU",
  writeHere: "Escribe aquí",
  createNewRow: "Crear nueva fila",
  noRowsCreatedYet: "Aún no se han creado filas",
  noData: "Sin datos",
  estimatedQuote: "Cotización estimada",
  yourEstimateQuoteInformationIsLoading: "La información de tu cotización estimada está cargando...",
  youAreAboutToApproveThisEstimateAreYouSure: "Estás a punto de aprobar esta estimación. ¿Estás seguro?",
  reasonForDeclining: "Razón para rechazar",
  reasonForReview: "Razón para revisión",
  estimateQuoteHasBeenApproved: "La cotización estimada ha sido aprobada",
  thankYouSoMuchForApprovingTheEstimateWithUs: "Muchas gracias por aprobar la estimación con nosotros",
  cantDeliverOrderWithBookedStatus: "No se pueden entregar pedidos con estado Reservado",
  selectedPrice: "Precio seleccionado: ",
  estimateQuoteHasBeenDeclined: "La cotización estimada ha sido rechazada",
  thisEstimateQuoteHasBeenSentToReview: "Esta cotización estimada ha sido enviada a revisión",
  weAreVerySorryThatTheQuoteWasNotAsExpectedWeHopeYouCanTryAgainAndEverythingGoesWell: "Lo sentimos mucho si la estimación no fue como se esperaba. Esperamos que puedas intentarlo de nuevo y que todo salga bien",
  shipeeziWillAlwaysBeHereWithYou: "Shipeezi siempre estará aquí contigo",
  weHaveAlreadyNotifiedTheResponsibleCompanyThatThereAreRevisionsToBeMadeAndIfEverythingGoesCorrectlyYouWillReceiveAReturnShortly: "Ya hemos notificado a la empresa responsable que hay revisiones a realizar. Si todo va bien, recibirás una respuesta pronto",
  saveAndSendToCustomer: "Guardar y enviar al cliente",
  youHaveToChooseAPriceInTheQuoteTab: "Debes elegir un precio en la pestaña Cotización",
  youHaveToChooseAPaymentMethodInTheQuoteTab: "Debes elegir un método de pago en la pestaña Cotización",
  noItems: "Sin artículos",
  theFieldIsEmpty: "El campo está vacío",
  addNewMaterial: "Agregar nuevo material",
  destinations: "Destinos",
  show: "Mostrar",
  taskAdded: "Tarea agregada",
  documentCreatedSuccessfully: "Documento creado exitosamente",
  documentsUploadedSuccessfully: "Documentos subidos exitosamente",
  noCommunicationOptionSelected: "Ninguna opción de comunicación seleccionada",
  notificationSent: "Notificación enviada",
  searchForLocation: "Buscar ubicación",
  noNotificationsForNow: "Sin notificaciones por ahora",
  notificationsWillAppearHereWhenThereAreAnyUpdatesToTheTasksYouAreInvolvedIn: "Las notificaciones aparecerán aquí cuando haya actualizaciones en las tareas en las que estás involucrado",
  markAndNumbersShouldHaveAtLeastOneFilledLine: "Marcas y números deben tener al menos una línea rellenada",
  theEstimatedQuoteWasSuccessfullyShared: "La cotización estimada fue compartida exitosamente",
  noItemsInQuotedInventory: "Sin artículos en el inventario cotizado",
  of: "de",
  reportsTo: "Reporta a",
  changeStatusesTo: "Cambiar estados a",
  onlyBookingsWithReceivedByCFSCanChangeToReceivedStatus: "Solo las reservas con estado Recibido por CFS pueden cambiar a estado Recibido",
  theLinkHasExpired: "El enlace ha expirado",
  theEstimatedQuoteLinkHasExpired: "El enlace de la cotización estimada ha expirado.",
  youCanRequestANewOneByClickingOnTheButtonBellow: "Puedes solicitar uno nuevo haciendo clic en el botón de abajo.",
  requestNewLink: "Solicitar nuevo enlace",
  requestedNewLinkSuccessfully: "Nuevo enlace solicitado exitosamente",
  whatDoYouWantToSendToCustomer: "¿Qué deseas enviar al cliente?",
  shareViaVideoSurveyInvite: "Compartir vía invitación a encuesta de video",
  sendANewInvitationToTheScheduledVideoSurvey: "Enviar una nueva invitación a la encuesta de video programada",
  shareViaEstimatedQuoteLink: "Compartir vía enlace de cotización estimada",
  sendTheExternalLinkOfEstimatedQuote: "Enviar el enlace externo de la cotización estimada",
  thisQuoteDoesNotHaveAValidVideoSurveyTask: "Esta cotización no tiene una tarea de encuesta de video válida",
  thisQuoteDoesNotHaveAnEstimate: "Esta cotización no tiene una estimación",
  createNewOffice: "Crear nueva oficina",
  editOffice: "Editar oficina",
  officeStatus: "Estado de la oficina",
  selectAtLeastOnePort: "Seleccionar al menos un puerto",
  city: "Ciudad",
  viewPort: "Ver puerto",
  siteCode: "Código del sitio",
  locationName: "Nombre de la ubicación",
  portStatus: "Estado del puerto",
  site: "Sitio",
  cityCode: "Código de ciudad",
  bookings: "Reservas",
  theInvitationWasSuccessfullySent: "La invitación fue enviada exitosamente",
  youMustBeLoggedInToSeeTheInvitation: "¡Debes estar conectado para ver la invitación!",
  youHaveReachedTheEndOfNotifications: "Has llegado al final de las notificaciones",
  youHaventAddedAnyPriceYet: "Aún no has agregado ningún precio.",
  automaticallyApprove: "Aprobar automáticamente",
  addSignatureForEveryPage: "Agregar firma en cada página",
  addSignatureForOwnerAndLeaderForEveryPageOfReportsInsteadOfTheLastOne: "Agregar firma para propietario y líder en cada página de informes en lugar de la última",
  whenTheUserApprovesHisQuoteThisWillAutomaticallyUpdateTheQuoteOnTheSystem: "Cuando el usuario apruebe su cotización, esto actualizará automáticamente la cotización en el sistema",
  salesAndOPS: "Ventas y OPS",
  sales: "Ventas",
  ops: "OPS",
  onFieldStaff: "Personal en campo",
  theCartonCanOnlyContainProductsOfTheSameTypeAndColor: "La caja solo puede contener productos del mismo tipo y color",
  yourCompanyLogoAndIconRepresentYourBrandIdentityAndValuesThisWillBeUsedInAllCommunicationsAndDocumentsSoItWouldBeGoodToUpload: "El logo y el ícono de tu empresa representan la identidad y los valores de tu marca. Se usarán en todas las comunicaciones y documentos",
  downloadOurCsvTemplate: "Descarga nuestra plantilla CSV",
  csvActions: "Acciones CSV",
  leavingOnboarding: "Saliendo de la configuración inicial",
  youAreAboutToExitTheOnboardingProcessAreYouSureYouWantToDoThis: "Estás a punto de salir del proceso de configuración inicial. ¿Estás seguro de que deseas hacerlo?",
  rememberThatYouWillOnlyBeAbleToUseTheSystemAfterCompletingThisProcess: "Recuerda que solo podrás usar el sistema después de completar este proceso",
  branchName: "Nombre de la Sucursal",
  branchAddedSuccessfully: "¡Sucursal agregada exitosamente!",
  viewBranches: "Ver sucursales",
  inShipeeziYouCanManageBranchesPhysicalLocationsOfYourBusinessAMinimumOf: "En Shipeezi puedes gestionar sucursales (ubicaciones físicas de tu empresa), con un mínimo de",
  oneBranch: "1 sucursal",
  mustBeRecorded: "debe ser registrado.",
  resubmitToMODS: "Reenviar a MODS",
  cantSubmitCancelledBookings: "No se pueden enviar reservas canceladas",
  cantDownloadCancelledBookings: "No se pueden descargar reservas canceladas",
  bookingsSubmittedSuccessfully: "Reserva(s) enviada(s) exitosamente",
  areYouSureYouWantToReSubmitTheSelectedBookings: "¿Estás seguro de que deseas reenviar la(s) reserva(s) seleccionada(s)?",
  theBookingFileWillBeSentWithAUpdateStatus: "El archivo de reserva será enviado con un estado de actualización",
  submit: "Enviar",
  addShipment: "Agregar envío",
  noShipmentAssociatedYet: "Aún no hay envío asociado",
  addShipmentToOrder: "Agregar envío al pedido",
  removed: "Eliminado",
  thisProductWasRemovedFromTheOrder: "Este producto fue eliminado del pedido",
  networkVisible: "Red visible",
  partner: "Socio",
  uploadImage: "Subir Imagen",
  thisImageWillBeUsedWhenGeneratingCommercialInvoiceAndPackingListDocumentsBeingUsedAsAnEsignature: "Esta imagen se usará al generar documentos de Factura Comercial y Lista de empaque, como firma electrónica",
  hereYouCanChooseWheterToSeeTheNetworkAndHaveTheOptionToSelectAndAgent: "Aquí puedes elegir si ver la Red y tener la opción de seleccionar un agente",
  doYouHaveAgentShipeeziNetworkKey: "¿Tienes la clave de red de Shipeezi del agente?",
  agentShipeeziNetworkToken: "Token de red de Shipeezi del agente",
  thisShipmentHasAPartner: "Este envío tiene un socio",
  myAccount: "Mi cuenta",
  orderCancelledSuccessfully: "Pedido cancelado exitosamente",
  prime: "Prime",
  managePlan: "Gestionar plan",
  lastInvoice: "Última factura",
  seeInvoiceHistory: "Ver historial de facturas",
  invoiceAmount: "Importe de la factura",
  amountOwing: "Importe adeudado",
  billingDate: "Fecha de facturación",
  manage: "Gestionar",
  userType: "Tipo de usuario",
  deductibleQty: "Cantidad deducible",
  extraQty: "Cantidad extra",
  quantityUsed: "Cantidad utilizada",
  costPerExtraUnit: "Costo por unidad extra",
  totalValue: "Valor total",
  addons: "Complementos",
  addOn: "Complemento",
  dueDate: "Fecha de Vencimiento",
  amount: "Monto",
  currentAccountAmountOwing: "Importe adeudado de la cuenta actual",
  nextBillingDate: "Próxima fecha de facturación",
  billingCountry: "País de facturación",
  needToCancelYourSubscription: "¿Necesitas cancelar tu suscripción?",
  cancelSubscription: "Cancelar suscripción",
  pleaseNotThatOurPricesAreGSTExclusiveGSTWillBeBilledToAustraliaCustomers: "Ten en cuenta que nuestros precios no incluyen GST. El GST se facturará a los clientes de Australia",
  weKnowCircumstancesCanStometimesChange: "Sabemos que las circunstancias a veces pueden cambiar",
  butBeforeYouGoHaveYouTriedOur: "Pero antes de irte, ¿has probado nuestro",
  forTechnicalFAQ: "para preguntas frecuentes técnicas",
  knowledgeBase: "Base de conocimiento",
  invoiceHistory: "Historial de facturas",
  invoiceID: "ID de factura",
  seeInvoice: "Ver factura",
  noKeepSubscription: "No, mantener suscripción",
  areYouSureYouWantToCancelYourSubscription: "¿Estás seguro de que deseas cancelar tu suscripción?",
  ifYouAreInDoubtWeOfferOtherPlansAsWell: "Si tienes dudas, también ofrecemos otros planes",
  byChoosingToCancelARequestWillBeSentToTeamAndThe: "Al elegir cancelar, se enviará una solicitud al equipo y",
  weAreSorryToSeeYouGo: "¡Lamentamos verte ir!",
  aCancellationRequestHasBeenSentToTheTeamAndWeWillContactYouShortlyToContinueTheOffBoardProcedure: "Se ha enviado una solicitud de cancelación al equipo y nos pondremos en contacto contigo pronto",
  youCanLogoutNow: "Ahora puedes cerrar sesión",
  paid: "Pagado",
  uncollectible: "Incobrable",
  waitingForPayment: "Esperando pago",
  planSummary: "Resumen del plan",
  wantToChangeYourPlan: "¿Quieres cambiar tu plan?",
  contactSales: "contactar ventas",
  contactSupport: "Contactar soporte",
  ifYouWantToUpgradeOrDowngradeYourPlanPlease: "Si deseas actualizar o degradar tu plan, por favor",
  youDontHaveAnyInvoicesYetWhenAnInvoiceIsGeneratedYoullSeeItHere: "Aún no tienes facturas. Cuando se genere una factura, la verás aquí",
  thisShipmentHasAnAgent: "Este envío tiene un agente",
  containerSizeType: "Tamaño y tipo de contenedor",
  addOrderToShipment: "Agregar pedido al envío",
  uploadYourFile: "Sube tu archivo",
  maxImageSize: "Tamaño máximo de imagen",
  changePicture: "Cambiar imagen",
  ExporterInformationIsDifferentFromTheVendor: "La información del exportador es diferente del proveedor",
  exporterName: "Nombre del exportador",
  exporterContactDetails: "Detalles de contacto del exportador",
  canBeJust: "puede ser solo ",
  or: "o",
  companies: "Empresas",
  ThisProcessIsRecommendedForCompaniesThatHave10OrMoreUsersButOnlyAdminAndGeneralRolesAreAvailableInThisStep: "Este proceso es recomendado para empresas con 10 o más usuarios, pero solo los roles de Administrador y General están disponibles en este paso",
  introduction: "Introducción",
  welcomeToShipeezi: "¡Bienvenido a Shipeezi!",
  unleashThePowerOfYourNewSoftware: "¡Desata el poder de tu nuevo software - a solo unos pasos!",
  wereConfidentThatYoullFindOurPlatformToBeAnInvaluableTool: "Estamos seguros de que encontrarás nuestra plataforma como una herramienta invaluable",
  firstlyLetsAddYourCompanyDetailsToYourAccountIncludingBusinessAddress: "Primero, agreguemos los detalles de tu empresa a tu cuenta, incluyendo la dirección comercial",
  nextWellSetUpYourCompanyUsersAndDefineTheirPermissionsAndAccessLevels: "Luego, configuraremos los usuarios de tu empresa y definiremos sus permisos y niveles de acceso",
  finallyWellAskYouToUploadPreliminaryInformationToAssistOurTeamWithConnectingYourDataStreams: "Finalmente, te pediremos que subas información preliminar para ayudar a nuestro equipo a conectar tus flujos de datos",
  deleteComment: "Eliminar comentario",
  areYouSureYouWantToDeleteThisComment: "¿Estás seguro de que deseas eliminar este comentario?",
  itLooksLikeTheresNoCommentsYet: "Parece que aún no hay comentarios",
  feelFreeToAddAnyCommentsYouFeelNecessary: "Siéntete libre de agregar los comentarios que consideres necesarios",
  typeHereYourNote: "Escribe aquí tu nota...",
  notifyPartyStatus: "Estado de parte notificada",
  editNotifyParty: "Editar parte notificada",
  viewNotifyParty: "Ver parte notificada",
  createNotifyParty: "Crear parte notificada",
  searchForAgent: "Buscar agente",
  bodyOfEmail: "Cuerpo del correo",
  bodyOfSMS: "Cuerpo del SMS",
  cartons: "Cajas",
  custom: "Personalizado",
  customTime: "Hora personalizada",
  shipeeziBilling: "Facturación de Shipeezi",
  theExtraQuantityIsTheDifferenceBetweenTheQuantityUsedAndDeductibleQty: "The extra quantity is the difference between the \"Quantity used\" and \"Deductible qty”",
  templateDetails: "Detalles de la plantilla",
  youCannotCreateATemplateWithABrokenTag: "No puedes crear una plantilla con una etiqueta rota",
  receiveUsingCSV: "Recibir usando CSV",
  couldNotFoundSSCC: "No se pudo encontrar el SSCC",
  searchForAContact: "Buscar un contacto",
  setTemplateAsDefault: "Establecer plantilla como predeterminada",
  ssccNotFound: "SSCC no encontrado",
  ssccFound: "SSCC encontrado",
  setAsDefault: "Establecer como predeterminado",
  yesChangeIt: "Sí, cambiarlo",
  changeDefault: "Cambiar predeterminado",
  doYouWantToMakeTheSelectedTemplateTheDefault: "¿Deseas establecer la plantilla seleccionada como predeterminada?",
  theCurrentDefaultForThisTypeWillBeReplaced: "El predeterminado actual para este tipo será reemplazado.",
  youCanChangeItBackLaterIfYouWant: "Puedes cambiarlo de nuevo más tarde si lo deseas.",
  cartonStatus: "Estado de caja",
  weightAndCBMOfThisBookingMustBeConfirmedBeforeThisCanBeDone: "El peso y CBM de esta reserva deben ser confirmados antes de hacer esto",
  allSSCCMustBeReceived: "Todos los SSCC deben estar recibidos",
  confirmAndReceive: "Confirmar y recibir",
  allSSCCsFromCsvWereMarkedAsReceived: "Todos los SSCC del CSV fueron marcados como recibidos",
  boxesCouldntBeMarkedAsReceivedPleaseCheckAllErrorsOnWarehouseScanDataDocumentAndTryAgain: "las cajas no pudieron ser marcadas como recibidas. Por favor, verifica todos los errores en el documento de datos de escaneo del almacén e intenta de nuevo",
  NoneSSCCsCouldBeMarkedAsReceivedPleaseCheckAllErrorsOnWarehouseScanDataDocumentAndTryAgain: "Ningún SSCC pudo ser marcado como recibido. Por favor, verifica todos los errores en el documento de datos de escaneo del almacén e intenta de nuevo",
  attention: "Atención",
  containerNumberIsRequired: "El número de contenedor es obligatorio",
  youShouldAddAtLeastOneOrderToTheShipment: "Debes agregar al menos un pedido al envío",
  thisFieldMustBeGreaterThanOrEqualTo0: "*Este campo debe ser mayor o igual a 0",
  dcCode: "Código DC",
  thisIsADeliveryLocation: "Esta es una ubicación de entrega",
  stayLoggedIn: "Mantener sesión iniciada",
  aSubscribedShipmentWasUnselectedAndCannotBeRemoved: "¡Un envío suscrito fue deseleccionado y no puede ser eliminado!",
  saveAsDraft: "Guardar como borrador",
  tracking: "Seguimiento",
  thereWasAProblemTryingToImportTheFilePleaseRefreshThePage: "Hubo un problema al intentar importar el archivo. Por favor, recarga la página",
  theFileWasSentToImport: "El archivo fue enviado para importar",
  vesselPositionUpdateDailyAt5pmUTC: "Las posiciones de los buques se actualizan diariamente a las 5pm UTC",
  locationIndicatedAboveIsMoreAccurateIfItDiffersFromMapDisplay: "La ubicación indicada arriba es más precisa si difiere de la visualización del mapa",
  unableToExportCSVFile: "No se puede exportar el archivo CSV",
  analytics: "Analítica",
  uploadDateAndTime: "Fecha y hora de carga",
  exporter: "Exportador",
  shipmentNumber: "Número de Envío",
  postCode: "Código postal",
  itemType: "Tipo de artículo",
  consignmentNumber: "Número de consignación",
  pieces: "Piezas",
  stocksToDespatch: "Stocks a despachar",
  palletsToDespatch: "Paletas a despachar",
  deliveryWindowOpen: "Apertura de ventana de entrega",
  deliveryWindowClose: "Cierre de ventana de entrega",
  shippingItems: "Artículos de envío",
  truck: "Camión",
  addExistingAddress: "Agregar dirección existente",
  newAddress: "Nueva dirección",
  noDeliveryAddressAddedYet: "Aún no se ha agregado una dirección de entrega",
  noPickupAddressAddedYet: "Aún no se ha agregado una dirección de recogida",
  addresses: "Direcciones",
  createDespatch: "Crear despacho",
  editDespatch: "Editar despacho",
  staged: "Preparado",
  inTransit: "En tránsito",
  newPickUpAddress: "Nueva dirección de recogida",
  newDeliveryAddress: "Nueva dirección de entrega",
  editPickUpAddress: "Editar dirección de recogida",
  editDeliveryAddress: "Editar dirección de entrega",
  labelAddress: "Dirección de etiqueta",
  pickUpAddress: "Dirección de recogida",
  addAddresses: "Agregar direcciones",
  palletsPerTrucks: "Paletas por camión",
  newShippingItem: "Nuevo artículo de envío",
  editShippingItem: "Editar artículo de envío",
  itLooksLikeThereSNoDataYet: "Parece que aún no hay datos",
  youWillBeAbleToSeeAllTheInformationAboutThe: "Podrás ver toda la información sobre el",
  associatedWithTheDespatchWhenYouAddThem: "asociado al despacho cuando los agregues",
  addShippingItems: "Agregar artículos de envío",
  editTruck: "Editar camión",
  newTruck: "Nuevo camión",
  quantityOnHand: "Cantidad disponible",
  allDespatched: "Todo despachado",
  available: "Disponible",
  youCanStartByCreatingANew: "Puedes comenzar creando un nuevo",
  passwordsDoNotMatch: "Las contraseñas no coinciden.",
  theresNoEstimatesAvailableToView: "No hay estimaciones disponibles para ver",
  userHasAccessTo: "El usuario tiene acceso a...",
  poConfirmedVsPOReceived: "OP Confirmada vs OP Recibida",
  poPastShipByDate: "OP pasada la fecha de envío",
  pastShipByDate: "Pasada la fecha de envío",
  pendingPurchaseOrders: "Órdenes de compra pendientes",
  printReport: "Imprimir informe",
  addTruck: "Agregar camión",
  maxValueAccepted: "Valor máximo aceptado",
  averageMonthlyCost: "Costo mensual promedio",
  averageOverTheLast12MonthsExcludingTaxes: "Promedio de los últimos 12 meses excluyendo impuestos",
  templates: "Plantillas",
  youShouldAddAtLeastOnePickUpAddress: "Debes agregar al menos una dirección de recogida",
  youShouldAddAtLeastOneDeliveryAddress: "Debes agregar al menos una dirección de entrega",
  youShouldAddAtLeastOneProduct: "Debes agregar al menos un producto",
  ayrtonSenna: "Ayrton Senna",
  positionInManufacturingCompany: "Cargo en empresa manufacturera",
  nameOfManufacturingCompany: "Nombre de la empresa manufacturera",
  egSupplier: "Ej. proveedor",
  egShipeezi: "Ej. shipeezi",
  searchByCountry: "Buscar por país",
  vendorId: "ID del proveedor",
  countryOfOrigin: "País de Origen",
  accessIntructions: "Instrucciones de acceso",
  generateInvoice: "Generar factura",
  schedule: "Programar",
  associatedWithTheInvoicesWhenYouAddThem: "asociado con las facturas cuando los agregues",
  loadingInvoices: "Cargando facturas",
  consol: "Consolidado",
  etaMonth: "Mes ETA",
  actualDelivery: "Entrega real",
  commInvNo: "N.º Fact. Com.",
  commInvDate: "Fecha Fact. Com.",
  partNumber: "Número de parte",
  receivedLinePrice: "Precio de línea recibida",
  invoiceExchangeRate: "Tipo de cambio de factura",
  audValue: "Valor AUD",
  duty: "arancel",
  lineDutyAmount: "Importe de arancel por línea",
  kewill: "Kewill",
  cblNo: "N.º CBL",
  mawbNo: "N.º MAWB",
  originCharges: "Cargos de origen",
  internationalFreight: "Flete internacional",
  destinationCharges: "Cargos de destino",
  totalFreightAUD: "Flete total AUD",
  unitFob: "FOB unitario",
  freightCPU: "Flete CPU",
  freightasFOB: "Flete como FOB",
  deleteInvoice: "Eliminar factura",
  areYouSureYouWantToDeleteTheInvoice: "¿Estás seguro de que deseas eliminar la factura?",
  invoiceQuantity: "Cantidad de factura",
  houseBill: "Guía de casa",
  masterBill: "Guía maestra",
  hblCountMode: "Modo de conteo HBL",
  chargeCode: "Código de cargo",
  overseasAmount: "Importe en el extranjero",
  exchangeRateCurrency: "Moneda del tipo de cambio",
  exchangeRate: "Tipo de cambio",
  invoicedLocalAmount: "Importe local facturado",
  gstAmount: "Importe GST",
  invoiceDate: "Fecha de Factura",
  invoiceDueDate: "Fecha de vencimiento de factura",
  autoRate: "Tarifa automática",
  cottonOnAdultsApportionment: "Prorrateo Cotton On adultos",
  cottonOnAdultsLocalAmount: "Importe local Cotton On adultos",
  ceresLifeApportionment: "Prorrateo Ceres Life",
  ceresLifeLocalAmount: "Importe local Ceres Life",
  bodyApportionment: "Prorrateo Body",
  bodyLocalAmount: "Importe local Body",
  factorieApportionment: "Prorrateo Factorie",
  factorieLocalAmount: "Importe local Factorie",
  kidsApportionment: "Prorrateo Kids",
  kidsLocalAmount: "Importe local Kids",
  rubiApportionment: "Prorrateo Rubi",
  rubiLocalAmount: "Importe local Rubi",
  foundationApportionment: "Prorrateo Foundation",
  foundationLocalAmount: "Importe local Foundation",
  typoApportionment: "Prorrateo Typo",
  typoLocalAmount: "Importe local Typo",
  gamedayApportionment: "Prorrateo Gameday",
  gamedayLocalAmount: "Importe local Gameday",
  supreApportionment: "Prorrateo Supre",
  supreLocalAmount: "Importe local Supre",
  fixturesApportionment: "Prorrateo Fixtures",
  fixturesLocalAmount: "Importe local Fixtures",
  consumablesApportionment: "Prorrateo Consumables",
  consumablesLocalAmount: "Importe local Consumables",
  otherApportionment: "Prorrateo Otros",
  otherLocalAmount: "Importe local Otros",
  dateType: "Tipo de fecha",
  searchBy: "Buscar por",
  sendReportByEmail: "Enviar informe por correo",
  originCountry: "País de origen",
  part: "Parte",
  id: "Id",
  createSendRecurrence: "Crear recurrencia de envío",
  daily: "Diario",
  weekly: "Semanal",
  monthly: "Mensual",
  frequency: "Frecuencia",
  isNotAValidEmail: "no es un correo electrónico válido",
  emailScheduled: "Correo programado",
  emailSent: "Correo enviado",
  storageStatus: "Estado de almacenamiento",
  newStorageBox: "Nueva caja de almacenamiento",
  editStorageBox: "Editar caja de almacenamiento",
  newStorageBoxType: "Nuevo tipo de caja de almacenamiento",
  editStorageBoxType: "Editar tipo de caja de almacenamiento",
  typeNumber: "Número de tipo",
  depth: "Profundidad",
  deleteStorageBox: "Eliminar caja de almacenamiento",
  deleteStorageBoxType: "Eliminar tipo de caja de almacenamiento",
  areYouSureYouWantToDeleteThisStorageBox: "¿Estás seguro de que deseas eliminar esta caja de almacenamiento?",
  areYouSureYouWantToDeleteThisStorageBoxType: "¿Estás seguro de que deseas eliminar este tipo de caja de almacenamiento?",
  createSmsTemplate: "Crear plantilla SMS",
  notBeingUsed: "Sin uso",
  inUse: "En uso",
  template: "Plantilla",
  hideCc: "Ocultar CC",
  hideBcc: "Ocultar CCO",
  showCc: "Mostrar CC",
  showBcc: "Mostrar CCO",
  sendEstimateToCustomer: "Enviar estimación al cliente",
  writeYourOwnOrChooseFromPreSetTemplates: "Escribe el tuyo o elige entre las plantillas preestablecidas",
  storageBoxesAndUnits: "Cajas y Unidades de Almacenamiento",
  writeYourOwnOrChooseFromTemplates: "Escribe el tuyo o elige entre las plantillas",
  movement: "Movimiento",
  movements: "Movimientos",
  objectToMove: "Objeto a mover",
  storageBox: "Caja de almacenamiento",
  looseItem: "Artículo suelto",
  typeOfObject: "Tipo de objeto",
  seeObjectActivity: "Ver actividad del objeto",
  moveTo: "Mover a",
  object: "Objeto",
  moveToLocation: "Mover a la ubicación",
  move: "Mover",
  someObjectDetailsWillBeDisplayedWhenYouSelectIt: "Algunos detalles del objeto se mostrarán aquí cuando lo selecciones",
  noObjectSelected: "Ningún objeto seleccionado",
  insideAStorageBox: "Dentro de una caja de almacenamiento",
  seeFullDetails: "Ver detalles completos",
  section: "Sección",
  storageBoxDetails: "Detalles de la caja de almacenamiento",
  dateIntoStorage: "Fecha de entrada al almacenamiento",
  lastMoved: "Último movimiento",
  isLocatedInTheCellYouAreGoingToMoveDoYouWantToContinue: "está ubicado en la celda a la que vas a mover. ¿Deseas continuar?",
  isPlacedInThisLocationRightNowWouldYouLikeToMoveItToAnUnknowLocationForNow: "está ubicado en esta ubicación ahora mismo. ¿Deseas moverlo a una ubicación desconocida por ahora?",
  the: "El",
  locationIsFull: "La ubicación está llena",
  accessTo: "Acceso a",
  rows: "Filas",
  columns: "Columnas",
  levels: "Niveles",
  createMap: "Crear mapa",
  editMap: "Editar mapa",
  input: "Entrada",
  columnsQuantity: "Cantidad de columnas",
  characterUsed: "Carácter usado",
  initial: "Inicial",
  suffix: "Sufijo",
  rowsQuantity: "Cantidad de filas",
  levelsQuantity: "Cantidad de niveles",
  buildMap: "Construir mapa",
  numbers: "Números",
  alphabetical: "Alfabético",
  ascendant: "Ascendente",
  descendant: "Descendente",
  deleteMap: "Eliminar mapa",
  viewMap: "Ver mapa",
  areYouSureYouWantToDeleteThisMap: "¿Estás seguro de que deseas eliminar este mapa?",
  thisFieldMustBeGreaterThanZero: "Este campo debe ser mayor que cero",
  mapGenerated: "Mapa generado",
  topView: "Vista superior",
  applySearch: "Aplicar búsqueda",
  cartonCondition: "Condición de caja",
  eventDate: "Fecha del evento",
  deliveryStore: "Tienda de entrega",
  storeNumber: "Número de tienda",
  estimateArriveWH: "Estimación de llegada al almacén",
  arrivalFinalPort: "Llegada al puerto final",
  meChecklist: "Lista M&E",
  haveYouDoneTheMEChecklistOnThisItem: "¿Has realizado la lista M&E en este artículo?",
  meChecklistDone: "Lista M&E completada",
  unsetAsDefault: "Desmarcar como predeterminado",
  storageAccounts: "Cuentas de almacenamiento",
  period: "Período",
  nextBilling: "Próxima facturación",
  createNew: "Crear nuevo",
  settlement: "Liquidación",
  createNewStorageAccount: "Crear nueva cuenta de almacenamiento",
  storageAccountOrder: "Pedido de cuenta de almacenamiento",
  pickedUp: "Recogido",
  assignLocation: "Asignar ubicación",
  assignStorageBox: "Asignar caja de almacenamiento",
  storageSpace: "Espacio de almacenamiento",
  unit: "Unidad",
  assignStorageBoxLocation: "Asignar ubicación de caja de almacenamiento",
  typeStorage: "Tipo de almacenamiento",
  storageFrom: "Almacenamiento desde",
  gracePeriodEnd: "Fin del período de gracia",
  storageEnd: "Fin del almacenamiento",
  selectAPaymentMethod: "Seleccionar un método de pago",
  plan: "Plan",
  totalGSTIncluded: "Total (GST incluido)",
  extraServices: "Servicios extra",
  grandTotal: "Total general",
  etaUnpackDate: "Fecha ETA de desembalaje",
  finalPortArrival: "Llegada al puerto final",
  all: "Todos",
  estimateArrivalWH: "Estimación de llegada al almacén",
  selectAtLeastOneProject: "Seleccionar al menos un proyecto",
  expectedQty: "Cantidad esperada",
  quantityReceived: "Cantidad recibida",
  dateReceived: "Fecha de recepción",
  selectBranch: "Seleccionar sucursal",
  selectGroup: "Seleccionar grupo",
  sections: "Secciones",
  createNewSection: "Crear nueva sección",
  contains: "contiene",
  storageBoxType: "Tipo de caja de almacenamiento",
  selectAtLeastOneWarehouseOrSku: "Seleccionar al menos un almacén o SKU",
  locationPreviewStatus: "Estado de vista previa de ubicación",
  selectNewLocation: "Seleccionar nueva ubicación",
  noMapSelected: "Ningún mapa seleccionado",
  aLittleMapPreviewWillAppearHereWhenYouSelectTheSectionInTheObjectThatShouldBeMoved: "Aparecerá una pequeña vista previa del mapa cuando selecciones la sección del objeto a mover",
  unload: "Descargar",
  uploadDate: "Fecha de carga",
  viewInWarehouseMap: "Ver en el mapa del almacén",
  changeLocation: "Cambiar ubicación",
  funcionalityUnderDevelopment: "Funcionalidad en desarrollo",
  selectWhichOrderToUnload: "Seleccionar qué pedido descargar",
  pleasePayAttention: "¡Por favor, presta atención!",
  onceTheOrderIsUnloadedItCannotChangeStatusAgain: "Una vez descargado el pedido, no puede cambiar de estado nuevamente.",
  full: "Lleno",
  unusable: "Inutilizable",
  couldNotFound: "No se pudo encontrar",
  selectAtLeastOneContainer: "Seleccionar al menos un contenedor",
  receivedExpected: "Recibido - Esperado",
  receivedUnexpected: "Recibido - No esperado",
  notReceivedExpected: "No recibido - Esperado",
  clear: "Limpiar",
  clearFields: "Limpiar campos",
  palletDimensions: "Dimensiones de paleta",
  cartonDimensions: "Dimensiones de caja",
  minimumValue: "Valor mínimo",
  newMap: "Nuevo mapa",
  theFollowingStorageBoxesAreLoadedAndCanNotChangeStatus: "Las siguientes cajas de almacenamiento están cargadas y no pueden cambiar de estado:",
  theFollowingMapsHaveLoadedLocationsAndCanNotChangeStatus: "Los siguientes mapas tienen ubicaciones cargadas y no pueden cambiar de estado",
  theFollowingWarehousesHaveSectionsWithMapsInUseAndCanNotChangeStatus: "Los siguientes almacenes tienen secciones con mapas en uso y no pueden cambiar de estado",
  selectAStartDate: "Seleccionar una fecha de inicio",
  enterAtLeast: "Ingresar al menos",
  ordersHaveDifferent: "Los pedidos tienen diferente",
  jobNumber: "Número del Trabajo",
  commercialInvoiceNumber: "Número de factura comercial",
  commercialInvoiceDate: "Fecha de factura comercial",
  lineDutyPercent: "Porcentaje de arancel por línea",
  nonAUEntryFees: "Tarifas de entrada no australianas",
  totalUnitCosts: "Costos unitarios totales",
  freightAUD: "Flete AUD",
  freightFob: "Flete FOB",
  new: "Nuevo",
  shareable: "Compartible",
  routePlanner: "Planificador de rutas",
  mapSettings: "Configuración del mapa",
  clearLocation: "Limpiar ubicación",
  routing: "Enrutamiento",
  sharedWith: "Compartido con",
  belongsTo: "Pertenece a",
  hasNoWarehouses: "no tiene almacenes",
  belongsToWarehouse: "Pertenece al almacén",
  sharedWarehouses: "Almacenes compartidos",
  isNotShareable: "No es compartible",
  cartonsPerPallet: "Cajas por paleta",
  allIncluded: "todo incluido",
  exampleOfTiHi: "Ejemplo de Ti-Hi",
  manufacture: "Fabricación",
  deleteProduct: "Eliminar producto",
  unitsInTransit: "Unidades en tránsito",
  originShipments: "Envíos de origen",
  cartonsToDespatch: "Cajas a despachar",
  companyCurrentStock: "Stock actual de la empresa",
  mainSupplier: "Proveedor principal",
  stock: "Stock",
  cartonWeight: "Peso de caja",
  createProduct: "Crear producto",
  byWho: "Por quién",
  objectNumber: "Número de objeto",
  newMovement: "Nuevo movimiento",
  none: "Ninguno",
  ordersQuantity: "Cantidad de pedidos",
  itemsInsideThisStorageBox: "Artículos dentro de esta caja de almacenamiento",
  bookingNumber: "Número de reserva",
  noLocation: "Sin ubicación",
  typeInLocation: "Escribir ubicación",
  startWarehouse: "Almacén de inicio",
  endWarehouse: "Almacén de fin",
  rta: "RTA",
  addToRoutePlanner: "Agregar al planificador de rutas",
  removingFromRoutePlanner: "Eliminando del planificador de rutas",
  removeFromRoutePlanner: "Eliminar del planificador de rutas",
  removedFromRoutePlanner: "Eliminado del planificador de rutas",
  addingToRoutePlanner: "Agregando al planificador de rutas",
  addedToRoutePlanner: "Agregado al planificador de rutas",
  couldNotAddToRoutePlanner: "No se pudo agregar al planificador de rutas",
  couldNotRemoveFromRoutePlanner: "No se pudo eliminar del planificador de rutas",
  updatingInRoutePlanner: "Actualizando en el planificador de rutas",
  updatedInRoutePlanner: "Actualizado en el planificador de rutas",
  couldNotUpdateInRoutePlanner: "No se pudo actualizar en el planificador de rutas",
  addToRoutePlannerQuestionMark: "¿Agregar al planificador de rutas?",
  addAShift: "Agregar un turno",
  shiftTime: "Hora del turno",
  shiftTimes: "Horarios del turno",
  addASecondShiftDuration: "Agregar una segunda duración de turno",
  scacCode: "Código SCAC",
  carrierName: "Nombre del transportista",
  carrierNameAbbreviation: "Nombre del transportista (Abr.)",
  editCarrier: "Editar transportista",
  createNewCarrier: "Crear nuevo transportista",
  trackableBy: "Rastreable por",
  areYouSureYouWantToDeleteThisCarrier: "¿Estás seguro de que deseas eliminar este transportista?",
  deleteCarrier: "Eliminar transportista",
  transshipment: "Transbordo",
  dueDateBy: "Fecha límite por",
  requestedBy: "Solicitado por",
  assignedTo: "Asignado a",
  newTransshipment: "Nuevo transbordo",
  showTodaysTransshipments: "Mostrar transbordos de hoy",
  generalDetails: "Detalles generales",
  whatToDo: "Qué hacer",
  team: "Equipo",
  saveAndPublish: "Guardar y publicar",
  markItemsYouWantToMove: "Marca los artículos que deseas mover",
  perItem: "Por artículo",
  bingoSheet: "Hoja de bingo",
  transshiping: "Transbordando",
  thisFieldShouldHaveAlphaNumericCharactersOnly: "Este campo debe tener solo caracteres alfanuméricos",
  bookingReference: "Referencia de reserva",
  showAllStorageBoxes: "Mostrar todas las cajas de almacenamiento",
  addStorageBox: "Agregar caja de almacenamiento",
  createASingleUseBox: "Crear una caja de uso único",
  storageBoxNumber: "Número de caja de almacenamiento",
  volumeAvailable: "Volumen disponible",
  theStorageBoxHasBeenAddedSuccessfully: "La caja de almacenamiento fue agregada exitosamente",
  itLooksLikeTheresNoDataYet: "Parece que aún no hay datos",
  startSearchingForAStorageBoxOrCreateASingleUseBox: "Empieza buscando una caja de almacenamiento o crea una de uso único.",
  system: "Sistema",
  editTransshipment: "Editar transbordo",
  any: "Cualquiera",
  pickUpTime: "Hora de recogida",
  deliveryTime: "Hora de entrega",
  addDespatchesToRoute: "Agregar despachos a la ruta",
  removeDespatchesToRoute: "Eliminar despachos de la ruta",
  added: "Agregado",
  searchForStorageBox: "Buscar caja de almacenamiento",
  noItemsToAddToTransshipment: "No hay artículos para agregar al transbordo",
  showTodayTransshipments: "Mostrar transbordos de hoy",
  showing: "Mostrando",
  theOrderHasAlreadyBeenAdded: "El pedido ya ha sido agregado",
  publish: "Publicar",
  editProject: "Editar proyecto",
  newProject: "Nuevo proyecto",
  fileName: "Nombre del archivo",
  dateUploaded: "Fecha de carga",
  ofRows: "de filas",
  addFile: "Agregar archivo",
  whenYouAddThem: "cuando los agregues",
  youWillBeAbleToSeeAllThe: "Podrás ver todos los",
  detailsHereWhenYouUploadAtLeastOne: "detalles aquí cuando subas al menos uno",
  createProject: "Crear proyecto",
  uploadAFile: "Subir un archivo",
  willBeRemoveAllOfTheItemsWillUnloadFromIt: "Se eliminará. Todos los artículos serán descargados de él.",
  areYouSureYouWantToContinue: "¿Estás seguro de que deseas continuar?",
  removeStorageBox: "Eliminar caja de almacenamiento",
  cellInUse: "Celda en uso",
  allWarehouses: "Todos los almacenes",
  yourStorageBoxesAreBeingUploaded: "Tus cajas de almacenamiento se están subiendo",
  automate: "Automatizar",
  sentToEmail: "Enviado por correo",
  editAutomation: "Editar automatización",
  deletedSuccessfully: "Eliminado exitosamente",
  deleteAutomation: "Eliminar automatización",
  doYouReallyWantToDeleteTheAutomation: "¿Realmente deseas eliminar la automatización?",
  createOrder: "Crear pedido",
  addNewproducts: "Agregar nuevos productos",
  manual: "Manual",
  paragraph: "Párrafo",
  options: "Opciones",
  addOption: "Agregar opción",
  youNeedToLogOutAndLogBackInForSomeChangesToBeApplied: "Necesitas cerrar sesión e iniciar sesión nuevamente para que algunos cambios sean aplicados",
  someChangesWereNotApplied: "Algunos cambios no fueron aplicados",
  enableAsAStorageBox: "Habilitar como caja de almacenamiento",
  enablingThisAllowsTheUserToChooseTheVehicleForStorageMovementOrTransshipmentAndIndicateWhenItemsArePlacedInsideLikeAStorageBox: "Habilitar esto permite al usuario elegir el vehículo para movimiento de almacenamiento o transbordo e indicar cuando los artículos están dentro",
  projectUpdatedWithSuccess: "Proyecto actualizado con éxito",
  deleteBrandName: "Eliminar nombre de marca",
  deleteBrandNames: "Eliminar nombres de marca",
  areYouSureYouWantToDeleteTheBrandName: "¿Estás seguro de que deseas eliminar el nombre de marca?",
  areYouSureYouWantToDeleteThese: "¿Estás seguro de que deseas eliminar estos?",
  brandName: "Nombre de marca",
  brandNames: "Nombres de marca",
  brandCode: "Código de marca",
  addNewBrandName: "Agregar nuevo nombre de marca",
  youCanStartByAddingANewBrandName: "Puedes comenzar agregando un nuevo nombre de marca",
  loadingBrands: "Cargando marcas",
  newBrand: "Nueva marca",
  logo: "Logo",
  editBrand: "Editar marca",
  viewBrand: "Ver marca",
  deleteBrands: "Eliminar marcas",
  previewOnSSCCLabel: "Vista previa en etiqueta SSCC",
  noPdfFileSpecified: "No se especificó archivo PDF",
  loadType: "Tipo de carga",
  groupageVanline: "Grupaje/Vanline",
  otherEnterDims: "Otro (ingresar dims)",
  parties: "Partes",
  rail: "Ferroviario",
  itemIsAHardwareBox: "El artículo es una caja de hardware",
  youCanSeeTheReportsAfterSelectingTheFollowingFilters: "Puedes ver los informes después de seleccionar los siguientes filtros",
  selectAProject: "Seleccionar un proyecto",
  selectAWarehouse: "Seleccionar un almacén",
  selectASKU: "Seleccionar un SKU",
  selectAContainer: "Seleccionar un contenedor",
  brands: "Marcas",
  repeat: "Repetir",
  weAreCheckingIfALinkIsAvailable: "Estamos verificando si hay un enlace disponible",
  pleaseSelectAOrderType: "Por favor, selecciona un tipo de pedido",
  etaDestination: "ETA destino",
  etaDespatch: "ETA despacho",
  trackable: "Rastreable",
  downloadShipmentInformations: "Descargar información del envío",
  boxContents: "Contenido de la caja",
  packedInto: "Embalado en",
  indicateLiftvanOrSectionTheItemCanBeFound: "Indica el liftvan o sección donde se puede encontrar el artículo",
  values: "Valores",
  automaticallyCreateOneHardwareBoxInEveryInventory: "Crear automáticamente una caja de hardware en cada inventario",
  needsAtLeastOneActiveHardwareBoxItemToBeEnabled: "Necesita al menos un artículo activo de caja de hardware para habilitarse.",
  carrierScac: "SCAC del transportista",
  fieldsAreRequired: "Se requieren número de contenedor, referencia de reserva o conocimiento de embarque",
  theFleetNameIsUsedAsTheSystemDefault: "El nombre de la flota se usa como predeterminado del sistema",
  isBox: "Es caja",
  isBoxInterrogation: "¿Es caja?",
  isThisTypeOfPackagingABox: "¿Este tipo de embalaje es una caja?",
  hardwareBox: "Caja de hardware",
  itemIsHighRiskOrHighValue: "El artículo es de alto riesgo/alto valor",
  thisCarrierAllowsShipmentTrackingBy: "Este transportista permite el seguimiento de envíos por",
  meChecklistIsmandatoryForThisItemPleaseAnswerIt: "La lista M&E es obligatoria para este artículo, por favor respóndela",
  enableEstimateEditing: "Habilitar edición de estimación",
  enable: "Habilitar",
  areYouSureYouWantToEnableEditingEstimateForThisQuote: "¿Estás seguro de que deseas habilitar la edición de estimación para esta cotización?",
  changesMadeToThisQuoteMayAlsoAffectOrder: "Los cambios realizados en esta cotización también pueden afectar al pedido.",
  measurementPreview: "Vista previa de medidas",
  me: "M&E",
  highRiskHighValue: "Alto riesgo / Alto valor",
  proGear: "Pro-Gear",
  itemIsAME: "El artículo es M&E",
  youCanSeeTheReportsAfterSelectingAtLeast: "Puedes ver los informes después de seleccionar al menos",
  warehouseCodeAlreadyExistsPleaseAssignANewCode: "El código de almacén ya existe. Por favor, asigna un nuevo código.",
  enterTheBoxNumberToSearch: "Ingresa el número de caja para buscar.",
  enterTheOrderToSearch: "Ingresa el pedido para buscar.",
  noResults: "Sin resultados",
  etdOrigin: "ETD origen",
  etaPlanned: "ETA planificado",
  addNewShipment: "Agregar Nuevo Envío",
  basedOnABooking: "Basado en una reserva",
  box: "Caja",
  case: "Estuche",
  pallet: "Paleta",
  ftl: "FTL",
  ltl: "LTL",
  fcl: "FCL",
  lcl: "LCL",
  groupage: "Grupaje",
  roro: "RORO",
  bulk: "Granel",
  commodityHSCode: "Código HS de mercancía",
  enterTheLocationToSearch: "Ingresa la ubicación para buscar.",
  productPhoto: "Foto del producto",
  masterbillOfLanding: "Conocimiento de embarque maestro",
  housebillOfLanding: "Conocimiento de embarque de la casa",
  shipmentDetails: "Detalles del envío",
  placeOfOrigin: "Lugar de origen",
  shipperCode: "Código del remitente",
  addAnotherContainer: "Agregar otro contenedor",
  volumetricWeight: "Peso volumétrico",
  grossVolume: "Volumen bruto",
  tareWeight: "Peso tara",
  netWeight: "Peso Neto",
  verifiedGrossWeight: "Peso bruto verificado",
  selectABooking: "Seleccionar una reserva",
  noSubscriberAdded: "Sin suscriptor agregado",
  selectABookingBellowToStartAShipmentBasedOnIt: "Selecciona una reserva abajo para iniciar un envío basado en ella",
  selectJustOneBookingPerShipment: "Selecciona solo una reserva por envío",
  startByAddingASubscribertoShipment: "Comienza agregando un suscriptor al envío",
  youMustSelectAShipmentLoadingPortFirst: "Debes seleccionar un puerto de carga del envío primero",
  youMustSelectAShipmentDestinationFirst: "Debes seleccionar un destino del envío primero",
  youMustSelectAShipmentOriginFirst: "Debes seleccionar un origen del envío primero",
  youMustSelectAShipmentDischargePortFirst: "Debes seleccionar un puerto de descarga del envío primero",
  youMustSelectAShipmentModeFirst: "Debes seleccionar un modo del envío primero",
  youMustSelectAShipmentIncotermFirst: "Debes seleccionar un incoterm del envío primero",
  variance: "Varianza",
  youCanStartByAddingAnOrder: "Puedes comenzar agregando un pedido",
  editSubscriber: "Editar suscriptor",
  fromThisShipment: "de este envío",
  regularCargo: "Carga regular",
  hazardousCargo: "Carga peligrosa",
  foodGradeCargo: "Carga de grado alimentario",
  rareCargo: "Carga rara",
  reeferCargoRefrigerated: "Carga refrigerada (Reefer)",
  addInAContainer: "Agregar en un contenedor",
  chooseAContainerToAddTheSsccInto: "Elige un contenedor para agregar el SSCC",
  choose: "Elegir",
  distanceTravelled: "Distancia recorrida",
  distanceToGo: "Distancia por recorrer",
  route: "Ruta",
  shipeeziPredictsETA: "Shipeezi Predice ETA",
  plannedETA: "ETA planificado",
  theCarrierProvidesDateTimesBelowAndMayNotMatchObservationsAndPredictionsInOtherSections: "El transportista proporciona fechas y horas a continuación que pueden no coincidir con observaciones y predicciones en otras secciones",
  events: "Eventos",
  notEventsToShowAtTheMoment: "No hay eventos para mostrar en este momento",
  dayDelay: "Día de retraso",
  daysDelay: "Días de retraso",
  invalidNumber: "Número inválido",
  trackingNotFound: "Seguimiento no encontrado",
  shipmentCreated: "Envío creado",
  checkTheInformationYouHaveFilledInUpdateItAndSaveItWellValidateItAgainInAFewMinutes: "Verifica la información que has completado, actualízala y guárdala. La validaremos de nuevo en unos minutos",
  weReStillValidatingInformationToSeeIfThisShipmentIsTrackableRefreshThisPageInAFewMinutes: "Todavía estamos validando información para ver si este envío es rastreable. Actualiza esta página en unos minutos",
  thereIsNoTrackingAvailableForThisShipment: "No hay seguimiento disponible para este envío.",
  yourShipmentWasSuccesfullyCreatedAndWereNowValidatingTheInformationToSeeIfItsTrackable: "Tu envío fue creado exitosamente y ahora estamos validando la información para ver si es rastreable",
  inAFewMinutesYouCanConsultTheTrackingInfoByClickingTheViewOrEditIconButtonInTheActionsColumnOnTheGrid: "En unos minutos puedes consultar la información de seguimiento haciendo clic en el ícono de ver o editar en la columna de acciones",
  whatDoYouWantToSend: "¿Qué deseas enviar?",
  sendTrackingViaSMSOrEmail: "Enviar seguimiento por SMS o correo",
  sendShipmentTrackingViaSMSOrEmailToTheCustomerOrSomeoneElse: "Enviar seguimiento del envío por SMS o correo al cliente o a alguien más",
  writeAnEmailOrUseATemplate: "Escribe un correo o usa una plantilla",
  writeASMSOrUseATemplate: "Escribe un SMS o usa una plantilla",
  writeAPushNotificationOrUseATemplate: "Escribe una notificación push o usa una plantilla",
  sendJSONFile: "Enviar archivo JSON",
  sendOnlyTheJSONFileToCustomer: "Enviar solo el archivo JSON al cliente",
  trackingNotAvailable: "Seguimiento no disponible",
  doYouAlsoWantToCancelTheLinkedOrder: "¿También deseas cancelar el pedido vinculado?",
  areYouSureYouWantToDeleteThisProduct: "¿Estás seguro de que deseas eliminar este producto?",
  createSingleUseBox: "Crear una caja de uso único",
  newSingleUseBox: "Nueva caja de almacenamiento de uso único",
  createAnotherSingleUseBox: "Crear otra caja de uso único",
  searchByContactNameMobilePhoneOrEmailAddress: "Buscar por nombre de contacto, teléfono móvil o correo",
  searchOrAddAContact: "Buscar o agregar un contacto",
  howMany: "¿Cuántos?",
  autoNumberThem: "Numerarlos automáticamente",
  typePrefix: "Escribir prefijo",
  singleUse: "Uso único",
  noWarehouses: "Sin almacenes",
  byWhom: "Por quién",
  enterTheObjectToSearch: "Ingresa el objeto para buscar.",
  orderOrCustomer: "Pedido o Cliente",
  salutation: "Saludo",
  allowance: "Asignación",
  secondReference: "2.ª Referencia",
  editLiftvans: "Editar liftvans",
  addLiftvans: "Agregar liftvans",
  areYouSureYouWantToCancelTheTransshipment: "¿Estás seguro de que deseas cancelar el transbordo?",
  yesCancelTransshipment: "Sí, cancelar transbordo",
  cancelTransshipment: "Cancelar transbordo",
  sendTheShipmentTrackingViaSMSToTheCustomerOrAnotherPerson: "Enviar el seguimiento del envío por SMS al cliente o a otra persona",
  sendTrackingViaSMS: "Enviar seguimiento por SMS",
  createdOn: "Creado el",
  sendTheShipmentTrackingViaSMSOrEmailToTheCustomerOrSomeoneElse: "Enviar el seguimiento del envío por SMS o correo al cliente o a alguien más",
  sendTrackingViaSMSorEmail: "Enviar seguimiento por SMS o correo",
  weightAndMeasurements: "Peso y medidas",
  storageBoxAdded: "Caja de almacenamiento agregada",
  storageBoxRemoved: "Caja de almacenamiento eliminada",
  generateCsv: "Generar CSV",
  revokeInvite: "Revocar invitación",
  yesRevoke: "Sí, revocar",
  revokeInvitation: "Revocar invitación",
  doYouWantToRevokeTheInvitationSentTheUserWillNoLonge: "¿Deseas revocar la invitación enviada? El usuario ya no podrá",
  youCanAlwaysInviteThemAgain: "Siempre puedes invitarlos de nuevo.",
  cancelInvite: "Cancelar invitación",
  thisInviteWasRevoked: "Esta invitación fue revocada",
  oopsItLooksLikeThisInvitationHasBeenRevoked: "Ups, parece que esta invitación ha sido revocada y ya no es válida",
  ifYouThinkThisIsAnErrorPleaseContactTheCompanyResponsibleToBetter: "Si crees que esto es un error, contacta a la empresa responsable",
  unlinkInventory: "Desvincular inventario",
  yesUnlink: "Sí, desvincular",
  doYouWantToUnlinkTheInventory: "¿Deseas desvincular el inventario?",
  inventoryLinked: "Inventario vinculado",
  inventoryUnlinked: "Inventario desvinculado",
  inventoryLinkedSuccessfully: "Inventario vinculado exitosamente",
  inventoryUnlinkedSuccessfully: "Inventario desvinculado exitosamente",
  relinkInventory: "Revincular inventario",
  yesRelink: "Sí, revincular",
  doYouWantToRelink: "¿Deseas revincular?",
  thisActionWillReplaceTheValuesYouveSetWithTheValuesFromYourActualInventory: "Esta acción reemplazará los valores que has establecido con los valores de tu inventario real",
  whenYouUnlinkTheInventoryYouCanEditTheTotalValuesThisMeansThatAnyFutureChangesYouMakeToTheInventoryWillNotBeReflectedInTheseMeasurements: "Cuando desvinculás el inventario, puedes editar los valores totales. Esto significa que los cambios futuros en el inventario no se reflejarán en estas medidas",
  inventoriesSummary: "Resumen de inventarios",
  itemIsProGear: "El artículo es Pro-Gear",
  apps: "Aplicaciones",
  thisStorageBoxTypeIsCurrentlyInUseAndItsStatusCantBeChanged: "Este tipo de caja de almacenamiento está en uso actualmente y su estado no puede cambiarse",
  allowItemPhotosToBeUploadedFromTheDevicesImageGallery: "Permitir que las fotos de artículos se suban desde la galería de imágenes del dispositivo",
  thisSettingsEnablesMobileAppUsersToUploadImagesFromTheirDevicesGallery: "Esta configuración permite a los usuarios de la app móvil subir imágenes desde la galería de su dispositivo",
  thisMayCauseADataSecurityRiskAsItCanEncourageTheStoringOfCustomerItemPhotosOnPersonalDevices: "Esto puede causar un riesgo de seguridad de datos, ya que puede fomentar el almacenamiento de fotos de artículos de clientes en dispositivos personales",
  allowUseOfDeviceGallery: "Permitir uso de la galería del dispositivo",
  galleryUsePermission: "Permiso de uso de galería",
  enablesUsersToUploadItemImagesFromTheirDevicesGallery: "Permite a los usuarios subir imágenes de artículos desde la galería de su dispositivo",
  note: "Nota",
  thisMayCauseAPersonalInformationSecurityRisksAsItCanEncourageTheStoringOfCustomerItemPhotosOnPersonalDevices: "Esto puede causar riesgos de seguridad de información personal ya que puede fomentar el almacenamiento de fotos de artículos de clientes en dispositivos personales",
  typeHere: "Escribe aquí...",
  hideCC: "Ocultar CC",
  hideBCC: "Ocultar CCO",
  cc: "Cc",
  linkedTo: "Vinculado a",
  linkedMaterials: "Materiales vinculados",
  selectAMaterial: "Seleccionar un material",
  addAnExistingGroup: "Agregar un grupo existente",
  newBlankGroup: "Nuevo grupo en blanco",
  selectOneOrMoreGroups: "Seleccionar uno o más grupos",
  addGroup: "Agregar grupo",
  showCC: "Mostrar CC",
  showBCC: "Mostrar CCO",
  asTheShipmentIdentificationIsUniqueYouCannotChangeItAfterCreation: "Como la identificación del envío es única, no puedes cambiarla después de la creación",
  generatePDFReport: "Generar informe PDF",
  reportLanguage: "Idioma del informe",
  taskReportType: "Tipo de informe de tarea",
  addedToContainer: "Agregado al contenedor",
  ssccs: "SSCC",
  typeAComment: "Escribir un comentario",
  addAComment: "Agregar un comentario",
  commentsHistory: "Historial de comentarios",
  addedOn: "Agregado el",
  youCanStartByCreatingASscc: "Puedes comenzar creando un SSCC",
  hereIsYourShipmentInfo: "Aquí está la información de tu envío",
  yourShipmentHasArrivedAt: "Tu envío ha llegado a",
  commentSpecialInstruction: "Comentario/Instrucción especial",
  hsCode: "Código HS",
  typeInAConsignee: "Escribir un consignatario",
  typeInACustomer: "Escribir un cliente",
  typeInOtherParty: "Escribir otra parte",
  otherAdditionalParty: "Otra parte adicional",
  byFillingInOneOrMoreOfTheseFieldsYourShipmentWillBeTracked: "Al completar uno o más de estos campos, tu envío será rastreado",
  moreContainerType: "Más tipos de contenedor",
  sendCustomerPortalLink: "Enviar enlace del portal del cliente",
  typeInToSearch: "Escribe para buscar",
  flight: "Vuelo",
  generatedBySystem: "Generado por el sistema",
  mandatory: "Obligatorio",
  newDocument: "Nuevo documento",
  clearFile: "Limpiar archivo",
  areYouSureYouWantToDelete: "¿Estás seguro de que deseas eliminar?",
  deleteDocument: "Eliminar documento",
  notAvailableYet: "Aún no disponible",
  documentsForThisShipment: "Documentos para este envío",
  shipmentMustBeConfirmed: "El envío debe ser confirmado",
  clearingFile: "Limpiando archivo",
  generatingFile: "Generando archivo",
  openingFile: "Abriendo archivo",
  shareCustomerPortalLink: "Compartir enlace del portal del cliente",
  sendTheCustomerPortalLinkWithAccessToTheOrderOnline: "Enviar el enlace del portal del cliente con acceso al pedido en línea",
  loading: "Cargando",
  escalation: "Escalación",
  escalationContactRaised: "Escalación/Contacto planteado",
  removeEscalationRequest: "Eliminar solicitud de escalación",
  noKeepIt: "No, mantenerlo",
  ohNoSomethingWentWrongPleaseTryAgain: "¡Oh no! Algo salió mal. Por favor, inténtalo de nuevo.",
  escalationRequestHasBeenRemoved: "La solicitud de escalación ha sido eliminada",
  removingThisEscalationChangeRequestWillClearAnyPendingRequests: "Eliminar esta solicitud de escalación/cambio limpiará cualquier solicitud pendiente",
  areYouSureYouWishToProceed: "¿Estás seguro de que deseas proceder?",
  yourEscalationRequestHasBeenSentSuccessfully: "Tu solicitud de escalación ha sido enviada exitosamente",
  inputComment: "Ingresar comentario",
  sendTo: "Enviar a",
  selectedPerson: "Persona seleccionada",
  selectWhoToNotify: "Seleccionar a quién notificar",
  theFollowingEmail: "El siguiente correo",
  notify: "Notificar",
  contactUs: "Contáctanos",
  packingItems: "Embalando artículos",
  closingTheBoxes: "Cerrando las cajas",
  listeningToBubbleWrapConfessions: "Escuchando confesiones del papel burbuja",
  parkingTheShip: "Estacionando el barco",
  talkingToTheFish: "Hablando con los peces",
  cartonContents: "Contenido de la caja",
  ata: "ATA",
  thereIsNoTrackingInformationAvailableForThisShipment: "No hay información de seguimiento disponible para este envío",
  thisTabWillShowSomeTrackingInformationIfAvailableAfterYouCreateTheShipment: "Esta pestaña mostrará información de seguimiento, si está disponible, después de crear el envío",
  theresNoTrackingInformationYet: "Aún no hay información de seguimiento",
  livePosition: "Posición en vivo",
  containerCase: "Contenedor / Estuche",
  containerCaseSize: "Tamaño de contenedor / Estuche",
  sealMarkings: "N.º de precinto / Marcas",
  selectALoadType: "Seleccionar un tipo de carga",
  selectAContainerCaseSize: "Seleccionar un tamaño de contenedor o estuche",
  typeAContainerCaseSize: "Escribir un tamaño de contenedor o estuche",
  dContainer: "Contenedor D",
  eContainer: "Contenedor E",
  ldnContainer: "Contenedor LDN",
  liftvan: "Liftvan",
  liftvans: "Liftvans",
  eur1Iso1Pallet: "Paleta EUR1/ISO1",
  eur2Iso2Pallet: "Paleta EUR2/ISO2",
  itLooksLikeThereNoDataYet: "Parece que aún no hay datos",
  startByAddingAnOrderToShipment: "Comienza agregando un pedido al envío",
  thisValueShouldBeAPositiveNumber: "Este valor debe ser un número positivo",
  selectTheLoadTypeFirst: "Selecciona el tipo de carga primero",
  hsCommodityCode: "Código HS / Mercancía",
  searchForAnAgent: "Buscar un agente",
  enterAValueGraterThanNetWeight: "Ingresa un valor mayor que el peso neto",
  enterAValueLowerThanGrossWeight: "Ingresa un valor menor que el peso bruto",
  youShouldAddAtLeastOneContainerToTheShipment: "Debes agregar al menos un contenedor al envío",
  thisRepresentsTheInitialEstimatedTimeOfArrivalProvidedByTheCarrier: "Esto representa la hora estimada de llegada inicial proporcionada por el transportista",
  thisIsYourShipmentInformation: "Esta es la información de tu envío",
  today: "Hoy",
  configure: "Configurar",
  last15Days: "Últimos 15 días",
  lastMonth: "Mes Pasado",
  monthToDate: "Mes hasta la fecha",
  lastYear: "Año Pasado",
  customDate: "Fecha personalizada",
  customPeriod: "Período personalizado",
  configureOverview: "Configurar resumen",
  adjustWidgetsAndViewAsYouWish: "Ajusta los widgets y la vista como desees",
  purchaseOrdersWidgets: "Widgets de órdenes de compra",
  poStatuses: "Estados de OP",
  lastReceivedOrders: "Últimos pedidos recibidos",
  poConfirmedVSPoReceived: "OP confirmada vs OP recibida",
  productsOrigin: "Origen de productos",
  mostRequestedProducts: "Productos más solicitados",
  productsRunningOutOfStock: "Productos con poco stock",
  containersByArrivalDate: "Contenedores por fecha de llegada",
  shipmentsPerTime: "Envíos por período",
  shipmentStatuses: "Estados de envíos",
  resetToDefault: "Restablecer a predeterminado",
  ofTotal: "Del total",
  inboundAtPortAtDC: "Entrante, en puerto y en DC",
  containersStatuses: "Estados de contenedores",
  amountOfSSCC: "Cantidad de SSCC",
  apply: "Aplicar",
  searchForAConsultant: "Buscar un consultor",
  enableQuoteEditing: "Habilitar edición de cotización",
  areYouSureYouWantToEnableEditingForThisQuote: "¿Estás seguro de que deseas habilitar la edición para esta cotización?",
  trackYourShipmentByFillingInEitherOrBothFields: "Rastrea tu envío ingresando el conocimiento de embarque (BOL), referencia de reserva o número de contenedor",
  pleaseFillInAtLeastOnField: "Por favor, completa al menos un campo.",
  dimensionalWeight: "Peso dimensional",
  airportOfOrigin: "Puerto de descarga (PoD)",
  airportOfDestination: "Aeropuerto de destino",
  arrivalAOfDestination: "Fecha de entrega",
  accounts: "Cuentas",
  ofUsers: "de usuarios",
  newAccount: "Nueva cuenta",
  companyAddress: "Dirección de la empresa",
  accountLogo: "Logo de la cuenta",
  notEnoughData: "Datos insuficientes",
  thereIsInsufficientDataToGenerateGraphicsForTheSelectedPeriod: "Hay datos insuficientes para generar gráficos para el período seleccionado",
  atDC: "En DC",
  incoterms: "Incoterms",
  uldContainers: "Contenedores ULD",
  uldPallets: "Paletas ULD",
  thisActionWillAlsoRemoveAnyFilesYouHaveUploadedInIt: "Esta acción también eliminará todos los archivos que hayas subido en él.",
  actualInventory: "Inventario real",
  checkAllSteps: "Verificar todos los pasos",
  milestones: "Hitos",
  checkYourMoveFileOnline: "Verifica tu archivo de mudanza en línea",
  logedInAs: "Conectado como",
  english: "Inglés",
  yourOrder: "Tu pedido",
  theTokenProvidedIsIncorrect: "El token proporcionado es incorrecto",
  nextStep: "Siguiente paso",
  survey: "Encuesta",
  typeYourCommentsHere: "Escribe tus comentarios aquí",
  agentContactDetails: "Detalles de contacto del agente",
  distanceToNextPort: "Distancia al próximo puerto",
  kg: "Kg",
  eventsUnavailable: "Eventos no disponibles",
  routeUnavailable: "Ruta no disponible",
  trackingInformationUnavailable: "Información de seguimiento no disponible en este momento.",
  nauticalMiles: "Millas náuticas",
  closeAllSSCCs: "Cerrar todos los SSCC",
  areYouSureYouWantToCloseAllSSCCs: "¿Estás seguro de que deseas cerrar todos los SSCC?",
  isItByDefaultAMilestone: "¿Es, por defecto, un hito?",
  newTask: "Nueva Tarea",
  addTask: "Agregar Tarea",
  tasksAndMilestones: "Tareas e hitos",
  milestonesFunctionallity: "Funcionalidad de hitos",
  aMilestoneIsAKeyDateThatShowsOnTheCustomerPortalMilestonesAreDisplayedAsAMoveFlowInAscendingOrderTasksAreSetByDefaultToBeConsideredAMilestoneOrNot: "Un hito es una fecha clave que aparece en el portal del cliente. Los hitos se muestran como un flujo de mudanza en orden ascendente. Las tareas se configuran por defecto para ser consideradas un hito o no.",
  youCanEditTheseDefaultsInSystemSettings: "Puedes editar estos valores predeterminados en la configuración del sistema.",
  youCanAlsoChooseToChangeThemAsNeededForThisFileOnly: "También puedes elegir cambiarlos según sea necesario solo para este archivo.",
  setAsMilestone: "Establecer como hito",
  removeAsMilestone: "Quitar como hito",
  youCanChooseFromTheListBelowWhichItemsYouWantToUpload: "Puedes elegir de la lista de abajo qué elementos deseas subir",
  downloadCSVTemplate: "Descargar plantilla CSV",
  theFilesWereUploadedAndUpdatedSuccesfully: "Los archivos fueron subidos y actualizados exitosamente",
  anErrorOccurredLoadingUploadCentreTryAgain: "Ocurrió un error al cargar el Centro de carga, inténtalo de nuevo",
  weHaveFoundSomeErros: "hemos encontrado algunos errores",
  branchCode: "Código de la Sucursal",
  warehouseCode: "Código del Almacén",
  branchCodeNotFound: "Código de sucursal no encontrado",
  warehouseCodeNotFound: "Código de almacén no encontrado",
  thisBranchIsNotRelatedToInformedWarehouse: "Esta sucursal no está relacionada con el almacén informado",
  serviceCodeAlreadyExistsPleaseAssignANewCode: "El código de servicio ya existe. Por favor, asigna un nuevo código.",
  materialCodeAlreadyExistsPleaseAssignANewCode: "El código de material ya existe. Por favor, asigna un nuevo código.",
  codeAlreadyExistsPleaseAssignANewCode: "El código ya existe. Por favor, asigna un nuevo código.",
  codeIsDuplicated: "El código está duplicado",
  codeNotFound: "Código no encontrado",
  anErrorOccurredOnTryAgain: "Ocurrió un error, intenta de nuevo",
  looseItems: "Artículos sueltos",
  thisFieldMustHaveAtLeastOneItem: "Este campo debe tener al menos un artículo",
  theOrderAlreadyIsInATransshipment: "El pedido ya está en un transbordo",
  publishTask: "Publicar tarea",
  unpublishTask: "Cancelar publicación de tarea",
  noCommentsAdded: "Sin comentarios agregados",
  actualAtDepartureDock: "Llegada en PoD",
  actualArrivalOfDestination: "Fecha de entrega",
  noRecord: "Sin registro",
  hwab: "HWAB",
  selectAPeriod: "Seleccionar un período",
  storageBoxSingleUseSelected: "Caja de almacenamiento de uso único seleccionada",
  youCanAddOnlyOneOrderToAStorageBoxSingleUse: "Solo puedes agregar un pedido a una caja de almacenamiento de uso único",
  createsANomenclatureBasedOnTheTransshipmentNumberAndTheQuantityOfLiftvans: "Crea una nomenclatura basada en el número de transbordo y la cantidad de liftvans",
  result: "Resultado",
  results: "Resultados",
  youCanOnlyUseOneStorageBoxSingleUsePerOrder: "Solo puedes usar una caja de almacenamiento de uso único por pedido",
  youCanOnlyUseStorageBoxSingleUseForJustOneOrder: "Solo puedes usar caja de almacenamiento de uso único para un solo pedido.",
  completed: "Completado",
  initialRequest: "Solicitud inicial",
  noStepsInformed: "Sin pasos informados",
  noTrackingAvailable: "No hay seguimiento disponible",
  dateNotInformed: "Fecha no informada",
  invoiceTotal: "Total de la Factura",
  receivedDate: "Fecha de recepción",
  error: "Error",
  waitingUpdate: "Esperando actualización",
  shipeeziDefault: "Predeterminado de Shipeezi",
  theFileToUploadMustBeInCSVFormat: "El archivo a subir debe estar en formato .csv",
  pleaseFillInTheRequiredFieldsBeforeSaving: "Por favor, completa los campos obligatorios antes de guardar.",
  changeAssignee: "Cambiar asignado",
  selectAPerson: "Seleccionar una persona",
  theAssignedPersonHasBeenChangedSuccessfully: "La persona asignada ha sido cambiada exitosamente",
  shipmentsPerDate: "Envíos por fecha",
  for: "para",
  chapter: "Capítulo",
  heading: "Encabezado",
  subHeading: "Subencabezado",
  statisticalClassification: "Clasificación estadística",
  applicableTo: "Aplicable a",
  inactivatingASectionChapterOrHeadingAllHSCommodityCodesRelatedWillBeInactivatedAsWell: "Al inactivar una sección, capítulo o encabezado, todos los códigos HS/mercancía relacionados también serán inactivados",
  doYouWantToInactivateAllOfThemAsWell: "¿Deseas inactivar todos ellos también?",
  activatingASectionChapterOrHeadingAllHSCommodityCodesRelatedWillBeActivatedAsWell: "Al activar una sección, capítulo o encabezado, todos los códigos HS/mercancía relacionados también serán activados",
  doYouWantToActivateAllOfThemAsWell: "¿Deseas activar todos ellos también?",
  inactivateCode: "Inactivar código",
  activateCode: "Activar código",
  typeInTheFirst6Digits: "Escribe los primeros 6 dígitos",
  typeInTheLast2To4Digits: "Escribe los últimos 2 a 4 dígitos",
  typeInTheCommodityCodeDescription: "Escribe la descripción del código de mercancía",
  typeInCountryOrRegion: "Escribe el país o región",
  commodityCode: "Código de mercancía",
  doYouReallyWantToDeleteThisCommodityCode: "¿Realmente deseas eliminar este código de mercancía?",
  deleteCommodityCode: "Eliminar código de mercancía",
  clone: "Clonar",
  adjustTheDataAsDesiredToCreateTheNewCode: "Ajusta los datos como desees para crear el nuevo código.",
  insertAValidCode: "*Inserta un código válido",
  youMustFillInTheFieldsInRed: "Debes completar los campos en rojo",
  importCSV: "Importar CSV",
  importCSVFile: "Importar archivo CSV",
  weHaveFoundSomeErrors: "hemos encontrado algunos errores",
  regions: "Regiones",
  defineWheterTheStorageBoxTypeCanApperInAllWarehouses: "Define si el tipo de caja de almacenamiento puede aparecer en todos los almacenes",
  defineIfTheStorageBoxTypeCanBeUsedInTransitInsideTheWarehouseOrBoth: "Define si el tipo de caja de almacenamiento puede usarse en tránsito, dentro del almacén o ambos",
  pleaseSelectAtLeastOne: "Por favor, selecciona al menos uno",
  originAirport: "Aeropuerto de origen",
  finalDestinationAirport: "Aeropuerto de destino final",
  plannedETD: "ETD planificado",
  departureFrom: "Salida desde",
  departedFrom: "Salió de",
  theAirplanePositionIsUpdatedFrom15To15Minutes: "La posición del avión se actualiza cada 15 minutos.",
  inviteCustomer: "Invitar cliente",
  inviteCustomers: "Invitar clientes",
  supplyChain: "Cadena de suministro",
  allSelectedCustomersMustHaveNameEmailAndNotYetBelongToShipeezi: "Todos los clientes seleccionados deben tener nombre, correo y no pertenecer aún a Shipeezi",
  theBranch: "La sucursal",
  warehouseNotFound: "Almacén no encontrado",
  isNotRelatedToInformedWarehouse: "no está relacionado con el almacén informado",
  writeACommentInSKU: "Escribir un comentario en el SKU",
  loadMore: "Cargar más",
  commentHistory: "Historial de comentarios",
  readMore: "Leer más",
  return: "Devolución",
  toAdd: "para agregar",
  shiftReturn: "Mayús + Intro",
  toBreakLine: "para saltar línea",
  now: "Ahora",
  inMoment: "En un momento",
  justNow: "Justo ahora",
  in: "in",
  years: "años",
  yearAgo: "año atrás",
  yearsAgo: "años atrás",
  months: "meses",
  monthAgo: "mes atrás",
  monthsAgo: "meses atrás",
  weeks: "semanas",
  weekAgo: "semana atrás",
  weeksAgo: "semanas atrás",
  tomorrow: "Mañana",
  yesterday: "Ayer",
  daysAgo: "días atrás",
  hour: "hora",
  hours: "horas",
  hourAgo: "hora atrás",
  hoursAgo: "horas atrás",
  minute: "minuto",
  minutes: "minutos",
  minuteAgo: "minuto atrás",
  minutesAgo: "minutos atrás",
  pleaseTypeLessThanCharacters: "Por favor escribe menos de {{maxLength}} caracteres",
  emailConfiguration: "Configuración de correo",
  selectAll: "Seleccionar Todos",
  "common.clearAll": "Clear All",
  youCantRemoveColumsTheMinimumIs: "No puedes eliminar columnas. El mínimo es",
  allTime: "Todo el tiempo",
  lastWeek: "Semana Pasada",
  allTypes: "Todos los tipos",
  editions: "Ediciones",
  loads: "Cargas",
  unloads: "Descargas",
  member: "Miembro",
  spouse: "Cónyuge",
  whoDoesThisItemBelongTo: "¿A quién pertenece este artículo?",
  searchOrAddAnItem: "Buscar o agregar un artículo",
  writeYourMessageHere: "Escribe tu mensaje aquí",
  message: "Mensaje",
  youAreNotifying: "Estás notificando",
  perDestination: "Por destino",
  asQuoted: "Según cotizado",
  noItemsHaveBeenRegisteredYet: "Aún no se han registrado artículos",
  onceItemsAreAddedToInventoryYouWillBeAbleToSeeTheirDetails: "Una vez que se agreguen artículos al inventario, podrás ver sus detalles",
  goodMorning: "Buenos días",
  goodAfternoon: "Buenas tardes",
  goodNight: "Buenas noches",
  youDontHaveAnyMovesWithUsYet: "Aún no tienes mudanzas con nosotros.",
  youHaveNotYetRequestedAQuoteFromUs: "Aún no has solicitado una cotización.",
  itSeemsLikeEverythingIsFineAroudHere: "Parece que todo está bien por aquí",
  weAreHereToHelpYourMoveToBeAsSmoothlyAsPossible: "Estamos aquí para ayudar a que tu mudanza sea lo más fluida posible",
  weAreHereToHelpYourQuoteToBeAsSmoothlyAsPossible: "Estamos aquí para ayudar a que tu cotización sea lo más fluida posible",
  yourMoves: "Tus mudanzas",
  yourQuotes: "Tus cotizaciones",
  scheduled: "Programado",
  needsYourAttention: "Necesita tu atención",
  yourScheduleIsSqueakyCleanNoUpcomingAppointmentsToWorryAbout: "Tu agenda está completamente libre. No hay citas próximas de las que preocuparte.",
  ifWeNeedYouForAnythingHereItIsThePlaceToTakeAction: "Si te necesitamos para algo, aquí es el lugar para tomar acción.",
  actualMilestone: "Hito real",
  trackingAvailable: "Seguimiento disponible",
  howAboutHavingACoffe: "¿Qué tal tomar un café?",
  everythingIsUpToDate: "Todo está actualizado",
  youWillSeeAllTheCommunicationBetweenYourselfAndUsHere: "Verás toda la comunicación entre tú y nosotros aquí.",
  transshipped: "Transbordado",
  weDidNotFindAnyMovesRelatedTo: "No encontramos ninguna mudanza relacionada con",
  noResultsFound: "No se encontraron resultados",
  nothingScheduledForNow: "Nada programado por ahora",
  timeline: "Línea de tiempo",
  home: "Inicio",
  checkAllMilestones: "Verificar todos los hitos",
  yourMoveProgress: "Progreso de tu mudanza",
  showMore: "Mostrar más",
  transport: "Transporte",
  originContacts: "Contactos de origen",
  destinationContacts: "Contactos de destino",
  checkMyInventories: "Verificar mis inventarios",
  messageSentThankYouForContactingUsWellGetBackToYouSoon: "¡Mensaje enviado! Gracias por contactarnos. Te responderemos pronto.",
  contactHistory: "Historial de contactos",
  youContacted: "Te comunicaste",
  yourMoveDocumentStatus: "Estado de los documentos de tu mudanza",
  pleaseFillInEitherTheMobileNumberOrPhoneNumberField: "Por favor, completa el campo de número móvil o número de teléfono",
  pleaseFillAtLeastOne: "Por favor, completa al menos uno",
  allItemsPacked: "Todos los artículos embalados",
  allYourItemsHaveBeenPackedAndEverythingIsFine: "Todos tus artículos han sido embalados y todo está bien.",
  couldNotFoundWithUsernamePassword: "No encontramos una cuenta con esas credenciales. Por razones de seguridad,",
  members: "Miembros",
  teams: "Equipos",
  newTeam: "Nuevo equipo",
  equipments: "Equipos",
  leaderUser: "Líder (Usuario)",
  inviteMember: "Invitar miembro",
  newMember: "Nuevo miembro",
  chooseTheTypeOfMember: "Elegir el tipo de miembro",
  theMemberCanHaveAccessToSystemOrNot: "El miembro puede tener o no acceso al sistema",
  personalDetails: "Datos personales",
  generalInformationAboutTheMember: "Información general sobre el miembro",
  howThePersonAccessesAndInteractsWithTheSystem: "Cómo la persona accede e interactúa con el sistema",
  additional: "Adicional",
  hasAccessToShipeeziSystemWithALoginAndPassword: "Tiene acceso al sistema de Shipeezi con un inicio de sesión y contraseña",
  thisMemberBelongsToASubcontractor: "Este miembro pertenece a un subcontratista",
  subcontractor: "Subcontratista",
  nickname: "Apodo",
  startEmploymentDate: "Fecha de inicio de empleo",
  endEmploymentDate: "Fecha de fin de empleo",
  citizenship: "Ciudadanía",
  license: "Licencia",
  jobTitle: "Título del cargo",
  editPhoto: "Editar foto",
  specificDetailsAboutTheStaffPerson: "Detalles específicos sobre el miembro del personal",
  staffInformation: "Información del personal",
  typerOfUser: "Tipo de usuario",
  notApproved: "No aprobado",
  review: "Revisión",
  expiry: "Vencimiento",
  certification: "Certificación",
  certifications: "Certificaciones",
  newCertification: "Nueva certificación",
  uploadANewFile: "Subir un nuevo archivo",
  confirmThisCertificationIsValidated: "Confirmar que esta certificación está validada",
  expire: "Vencimiento",
  preferNotToSay: "Prefiero no decir",
  nonBinary: "No binario",
  searchForCitizenship: "Buscar ciudadanía",
  serchForCountry: "Buscar país",
  thisUserIsAlsoALeader: "Este usuario también es un líder",
  pleaseCompleteAllRequiredFields: "Por favor, completa todos los campos obligatorios",
  createMember: "Crear miembro",
  associatedWithThisMemberWhenYouAddThem: "asociado con este miembro cuando los agregues",
  associatedWithThisEquipmentWhenTheyAreAdded: "asociado con este equipo cuando sean agregados",
  newAbsence: "Nueva ausencia",
  absences: "Ausencia",
  absence: "Ausencia",
  allDayAbsence: "Ausencia de todo el día",
  availability: "Disponibilidad",
  convertStaffIntoUser: "Convertir personal en usuario",
  convertUserIntoStaff: "Convertir usuario en personal",
  configureAsSubcontractor: "Configurar como subcontratista",
  doYouWantToConvertThisUserIntoStaff: "¿Deseas convertir este usuario en personal?",
  doYouWantToConvertThisStaffIntoUser: "¿Deseas convertir este personal en usuario?",
  youWillNeedToFillInTheMissigInformation: "Necesitarás completar la información faltante",
  thisMemberIsA: "Este miembro es un",
  andIsDefinedAsA: "y está definido como",
  subconttractorFor: "subcontratista para",
  own: "Propio",
  convertInto: "Convertir en",
  subcontractorFor: "subcontratista para",
  timesheet: "Registro de tiempo",
  timesheets: "Registros de tiempo",
  typeOfMember: "Tipo de miembro",
  ifTheTeamAlreadyHasALeaderTheMemberWillBeAddedAsStaff: "Si el equipo ya tiene un líder, el miembro será agregado como personal",
  emergencyEmail: "Correo de emergencia",
  newTime: "Nuevo tiempo",
  editTeam: "Editar equipo",
  addMember: "Agregar miembro",
  addTeam: "Agregar equipo",
  nameL: "Nombre",
  equipmentPhoto: "Foto del equipo",
  maxSize2mb: "Tamaño máximo 2 MB",
  formatsJpgGifPng: "Formatos: JPG, GIF, PNG",
  equipmentIcon: "Ícono del equipo",
  rental: "Alquiler",
  leased: "Arrendado",
  noMembersAssociatedToThisEquipment: "No hay miembros asociados a este equipo",
  youCanStartByAddingAMember: "Puedes comenzar agregando un miembro",
  newUnavailabilityTime: "Nuevo tiempo de no disponibilidad",
  allDayUnavailable: "No disponible todo el día",
  rolesecurity: "Rol (seguridad)",
  loaction: "Ubicación",
  addMembers: "Agregar miembros",
  youwillbeabletoseealltheinformationabouttheavailabilityofthismemberwhenyouaddthem: "Podrás ver toda la información sobre la disponibilidad de este miembro cuando los agregues",
  addUnavailability: "  Agregar no disponibilidad",
  addTeams: "Agregar equipos",
  enableThisFleetAsAStrorageBox: "Habilitar esta flota como caja de almacenamiento",
  dates: "Fechas",
  selectAnOptionToSeeTheForm: "Selecciona una opción para ver el formulario",
  typeInToSearchAMebmer: "Escribe para buscar un miembro",
  pantech: "Pantech",
  nickName: "Apodo",
  EuroNorm: "EUROnorm",
  driverLicense: "Licencia de conducir",
  manufacturer: "Fabricante",
  branch1: "Sucursal 1",
  warehouse1: "Almacén 1",
  enableThisFleetAsAStorageBox: "Habilitar esta flota como caja de almacenamiento",
  writeADescription: "Escribe una descripción",
  chooseAvehicleTypeOfEquipmentLikeAForkliftOrATruck: "Elige un tipo de equipo vehicular, como una carretilla elevadora o un camión",
  chooseAVehicleTypeOfEquipmentLikeAForkliftOrATruck: "Elige un tipo de equipo vehicular, como una carretilla elevadora o un camión",
  createMoreGeneralizedEquipmentWithAFewDetails: "Crear equipo más generalizado con pocos detalles",
  whoOwnsThisEquipment: "¿Quién es el propietario de este equipo?",
  businessphone: "Teléfono empresarial",
  vatcode: "Código IVA",
  iban: "IBAN",
  bic: "BIC",
  usesameasgeneraladdress: "Usar la misma dirección general",
  addaequipment: "Agregar un equipo",
  quickcreationequipment: "Creación rápida de equipo",
  addequipment: "Agregar equipo",
  addAMember: "Agregar un miembro",
  addATeam: "Agregar un equipo",
  createnew: "Crear nuevo",
  businessdetails: "Datos empresariales",
  businessinformationaboutthesubcontractor: "Información empresarial sobre el subcontratista",
  generalinformationabouttheowner: "Información general sobre el propietario",
  bankingdetails: "Datos bancarios",
  nomembersassociatedtothisequipment: "No hay miembros asociados a este equipo",
  youcanstartbyaddingamember: "Puedes comenzar agregando un miembro",
  createnewmember: "Crear nuevo miembro",
  addanexistentmember: "Agregar un miembro existente",
  quickcreation: "Creación rápida",
  equipment: "Equipo",
  quicklycreateanewequipmentwithessentialdetailsaddmoreinformationanytimeinsettings: "Crea rápidamente un nuevo equipo con detalles esenciales. Agrega más información en cualquier momento en configuración",
  createmoregeneralizedequipmentwithafewdetails: "Crear equipo más generalizado con pocos detalles",
  personaldetails: "Datos personales",
  platenumber: "Número de placa",
  subcontractors: "Subcontratistas",
  newSubcontractor: "Nuevo subcontratista",
  qtyMembers: "Cant. miembros",
  qtyEquipments: "Cant. equipos",
  businessDetails: "Datos empresariales",
  businessInformationAboutTheSubcontractor: "Información empresarial sobre el subcontratista",
  businessPhone: "Teléfono empresarial",
  generalInformationAboutTheOwner: "Información general sobre el propietario",
  addNumberHere: "Agrega número aquí",
  bankingDetails: "Datos bancarios",
  vatCode: "Código IVA",
  useSameAsGeneralAddress: "Usar la misma dirección general",
  contactEmail: "Correo de Contacto",
  noMembersAssociatedToThisSubcontractor: "No hay miembros asociados a este subcontratista",
  createNewMember: "Crear nuevo miembro",
  addAnExistentMember: "Agregar un miembro existente",
  noMembersToShow: "No hay miembros para mostrar",
  noTeamsToShow: "No hay equipos para mostrar",
  typeInToSearchAMember: "Escribe para buscar un miembro",
  addWorkTimeToMember: "Agregar tiempo de trabajo al miembro",
  howDoYouWantToAddAnewTime: "¿Cómo deseas agregar un nuevo tiempo?",
  createMockTask: "Crear tarea ficticia",
  createAMimicTaskToRecordHoursForThisMember: "Crear una tarea ficticia para registrar horas de este miembro.",
  selectExistentTask: "Seleccionar tarea existente",
  selectAnExistingTaskInTHeOrderToLogWorkTime: "Seleccionar una tarea existente en el pedido para registrar tiempo de trabajo",
  addTime: "Agregar tiempo",
  backFromBreak: "De vuelta del descanso",
  itLooksLikeNoOrderWasSelectYet: "Parece que aún no se ha seleccionado ningún pedido",
  startSearchingForAnOrderToBeAbleToCreateANewTask: "Empieza buscando un pedido para poder crear una nueva tarea",
  searchOrderBy: "Buscar pedido por",
  cancelAvailability: "Cancelar disponibilidad",
  doYouReallyWantToCancelThisAbsence: "¿Realmente deseas cancelar esta ausencia para",
  yesCancel: "Sí, cancelar",
  thisActionCannotBeUndone: "Esta acción no se puede deshacer.",
  viewTime: "Ver tiempo",
  editTime: "Editar tiempo",
  noLeaderAvailable: "Sin líder disponible",
  noStaffAvailable: "Sin personal disponible",
  noTasks: "Sin tareas",
  m3: "m³",
  unavailableUntil: "No disponible hasta",
  lv: "LV",
  noEquipmentToShow: "No hay equipo para mostrar",
  addEquipment: "Agregar equipo",
  addAnExistentEquipment: "Agregar equipo existente",
  addEquipments: "Agregar equipo",
  addAEquipment: "Agregar un equipo",
  newEquipment: "Nuevo equipo",
  chooseTheTypeOfEquipment: "Elegir el tipo de equipo",
  purchaseDate: "Fecha de compra",
  soldDate: "Fecha de venta",
  euronorm: "EUROnorm",
  lastInspectionDate: "Fecha de última inspección",
  nextInspectionDate: "Fecha de próxima inspección",
  pleaseSelectAnLaterDate: "Por favor, selecciona una fecha posterior",
  pleaseSelectAnEarlierDate: "Por favor, selecciona una fecha anterior",
  workedTime: "Tiempo trabajado",
  breaks: "Descansos",
  waitingApproval: "Esperando aprobación",
  noSubcontractorAvailable: "Sin subcontratista disponible",
  noLeaderAdded: "Sin líder agregado",
  noStaffAdded: "Sin personal agregado",
  noEquipmentAdded: "Sin equipo agregado",
  noStorageBoxAdded: "Sin caja de almacenamiento agregada",
  noOrders: "Sin pedidos agregados",
  openOrder: "Abrir pedido",
  accessDetails: "Detalles de acceso",
  membersAndTeams: "Miembros y equipos",
  membersAndEquipments: "Miembros y equipos",
  extraMembersAndTeams: "Miembros y equipos extra",
  addTeamToBoard: "Agregar equipo al tablero",
  timeMustBeAfter: "La hora debe ser después de",
  addALeader: "Agregar un líder",
  addStaffs: "Agregar personal",
  addStorageBoxes: "Agregar cajas de almacenamiento",
  timeClock: "Reloj de tiempo",
  removeTaskFromTeam: "Eliminar tarea del equipo",
  youCannotPublishATaskWithoutALeader: "No puedes publicar una tarea sin un líder",
  thisChangeWillBeProcessedShortly: "Este cambio se procesará en breve",
  noLanguageAvailable: "Sin idioma disponible",
  noJobTitleAvailable: "Sin título de cargo disponible",
  equipmentDetails: "Detalles del equipo",
  removeThisTeamFromTheBoard: "Eliminar este equipo del tablero",
  areYouSureyouWantToCancelTheTask: "¿Estás seguro de que deseas cancelar la tarea?",
  forOrder: "Para el pedido",
  createCrew: "Crear tripulación",
  noTeamsAddedYet: "Aún no se han agregado equipos",
  allCaughtUpWhatAboutACoffee: "¡Todo al día! ¿Qué tal un café?",
  weAreDoingOneLastSearchWhatAboutACoffee: "Estamos haciendo una última búsqueda... ¿Qué tal un café?",
  viewOptions: "Ver opciones",
  showItemsUnavailable: "Mostrar artículos no disponibles",
  showEmptyOrdersTasks: "Mostrar pedidos/tareas vacíos",
  showEmptyTeams: "Mostrar equipos vacíos",
  collapseOrdersTasks: "Contraer pedidos/tareas",
  collapseTeams: "Contraer equipos",
  expandOrdersTasks: "Expandir pedidos/tareas",
  expandTeams: "Expandir equipos",
  organization: "Organización",
  organiseByTask: "Organizar por tarea",
  organiseByOrder: "Organizar por pedido",
  organiseByTeam: "Organizar por equipo",
  youCannotPublishThisTask: "No puedes publicar esta tarea",
  typeHereAndPressEnter: "Escribe aquí y presiona Enter",
  noMemberFound: "Sin miembro encontrado",
  noTeamFound: "Sin equipo encontrado",
  noOrderFound: "Sin pedido encontrado",
  noInformationToShow: "Sin información para mostrar",
  noEquipmentFound: "Sin equipo encontrado",
  noStorageBoxFound: "Sin caja de almacenamiento encontrada",
  pressToSearch: "Presiona para buscar",
  noOrderAvailable: "Sin pedido disponible",
  youHaveToUnpublishFirst: "Debes cancelar la publicación primero",
  thisTaskAlreadyStartedByTheLeader: "Esta tarea ya fue iniciada por el líder",
  thisTaskAlreadyFinished: "Esta tarea ya está finalizada",
  thisTaskAlreadyCancelled: "Esta tarea ya fue cancelada",
  youHaveToAddATaskBeforeCreateASingleUse: "Debes agregar una tarea antes de crear un uso único",
  youCannotAddASingleUseForDifferentOrders: "No puedes agregar un uso único para diferentes pedidos",
  createAStorageBoxSingleUse: "Crear una caja de almacenamiento de uso único",
  thisTaskCannotBeCancelled: "Esta tarea no puede ser cancelada",
  thereIsNoNeed: "No hay necesidad",
  vipMode: "Modo VIP",
  bluebarkMove: "Mudanza Bluebark",
  satefyMove: "Mudanza de seguridad",
  dispatch: "Despacho",
  youHaveUnpublishedTasks: "¡Tienes tareas no publicadas!",
  thisTeamHasTasksAlreadyPublishedForThisLeader: "Este equipo tiene tareas ya publicadas para este líder",
  anOperationalMemberUsedJustForRegisterPurposes: "Un miembro operativo, usado solo para fines de registro",
  boardDisplay: "Vista del tablero",
  createATemporaryTeamoForTodaysTasks: "Crear un equipo temporal para las tareas de hoy",
  registredAddress: "Dirección registrada",
  noResultMatchYourSearch: "Ningún resultado coincide con tu búsqueda",
  searchAndSelectOrder: "Buscar y seleccionar pedido",
  itLooksLikeNoOrderWasSelectedYet: "Parece que aún no se ha seleccionado ningún pedido",
  startSearchingForAnOrderYoBeAbleToCreateANewTask: "Empieza buscando un pedido para poder crear una nueva tarea",
  newTaskFor: "Nueva tarea para",
  timeFor: "Tiempo para",
  notifyTheClientAboutTheStartOfTheTask30MinutesInAdvance: "Notificar al cliente sobre el inicio de la tarea con 30 minutos de anticipación",
  breakFromBreak: "De vuelta del descanso",
  albertFloresMarvinMcKinneyJeromeBell: " Albert Flores, Marvin McKinney, Jerome Bell",
  extraMembers: "Miembros y equipos extra",
  devonLane: "Devon Lane",
  readLess: "Leer menos",
  writeACommentIn: "Escribir un comentario en",
  shift: "turno",
  teamRemovalIsBlockedDueToThePresenceOfTasks: "La eliminación del equipo está bloqueada por la presencia de tareas.",
  vipTreatment: "Tratamiento VIP",
  personalAddress: "Dirección personal",
  pleaseSelectAStartDate: "Por favor, selecciona una fecha de inicio",
  morning: "Mañana",
  afternoon: "Tarde",
  evening: "Tarde-noche",
  night: "Noche",
  registeredAddress: "Dirección registrada",
  noTaskYest: "Sin tareas aún",
  writeAComment: "Escribir un comentario",
  allowBookingSearch: "Permitir búsqueda de reservas",
  securityLoginAttempts: "Por razones de seguridad, después de <strong>{{numberOfAttempts}} intentos fallidos</strong>",
  weakPassword: "Contraseña débil",
  avaragePassword: "Contraseña regular",
  goodPassword: "Buena contraseña",
  strongPassword: "Contraseña fuerte",
  passwordMustHave: "Tu contraseña debe tener:",
  UpperAndLowercaseLetters: "Letras mayúsculas y minúsculas",
  aSpecialCharacter: "Un carácter especial (#$&@)",
  atLeastOneNumber: "Al menos un número",
  minLength: "12 o más caracteres",
  pleaseEnterANewPassword: "Por favor, ingresa una nueva contraseña",
  pleaseConfirmPassword: "Por favor, confirma la contraseña",
  autoTerminateSessionExpire: "Por razones de seguridad, tu sesión expira después de 8 horas de",
  yourSessionIsAboutToExpire: "Tu sesión está a punto de expirar",
  terminatedSession: "Esta sesión ha sido terminada.",
  reEnterCreds: "Por favor <strong>vuelve a ingresar</strong> tus credenciales.",
  weWillSendALinkToResetYourPasswordToTheEmailAddressAssociatedWithYourAccount: "Te enviaremos un enlace para restablecer tu contraseña a la dirección de correo asociada con tu cuenta",
  sortReportBy: "Ordenar informe por",
  sortedByInventory: "Ordenado por inventario",
  sortedAndGroupedByStorageBox: "Ordenado y agrupado por caja de almacenamiento",
  loadOrder: "Cargar pedido",
  areYouSureYouWantToLoadThisOrder: "¿Estás seguro de que deseas cargar este pedido?",
  changeOrderStatusModalDescription: "El nuevo estado del pedido será '{{status}}'.",
  noKeepItAsItIs: "No, mantenerlo como está",
  noKeepItAsStatus: "No, mantener como {{status}}",
  yesLoad: "Sí, cargar",
  yesDeliver: "Sí, entregar",
  noPhotosHaveBeenAddedYet: "Aún no se han agregado fotos",
  transportationType: "Tipo de transporte",
  assistance: "Asistencia",
  doorToDoor: "Puerta a puerta",
  doorToPort: "Puerta a puerto",
  doorToWarehouse: "Puerta a almacén",
  fotWarehouse: "FOT Almacén",
  portToDoor: "Puerto a puerta",
  portToPort: "Puerto a puerto",
  portToWarehouse: "Puerto a almacén",
  warehouseToDoor: "Almacén a puerta",
  warehouseToPort: "Almacén a puerto",
  warehouseToWarehouse: "Almacén a almacén",
  accountType: "Tipo de cuenta",
  accountContact: "Contacto de cuenta",
  bookingAgent: "Agente de reservas",
  personalPropertyProgram: "Programa de propiedad personal",
  searchForAnOption: "Buscar una opción",
  memberWillChangeFromSubcontractorToOwnAfterSaving: "Member will change from \"subcontractor\" to \"own\" after saving",
  memberWillChangeFromOwnToSubcontractorAfterSaving: "Member will change from \"own\" to \"subcontractor\" after saving",
  memberWillChangeFromUserToStaffAfterSaving: "Member will change from \"user\" to \"staff\" after saving",
  memberWillChangeFromStaffToUserAfterSaving: "Member will change from \"staff\" to \"user\" after saving",
  noTaskYet: "Sin tarea aún",
  workHours: "Horas de trabajo",
  breakHours: "Horas de descanso",
  mostCommonTask: "Tarea más común",
  theCompanyDoesNotHaveARegisteredAddress: "La empresa no tiene dirección registrada",
  noPhotoAdded: "Sin foto agregada",
  exampleAyrton: "Ejemplo: Ayrton",
  exampleSenna: "Ejemplo: Senna",
  mailmailcom: "correo@correo.com",
  newUnavailability: "Nueva no disponibilidad",
  editTask: "Editar Tarea",
  notAllocated: "No asignado",
  vipTasksWithAssign: "Tareas VIP con asignación",
  tasksWithNoAssign: "Tareas sin asignación",
  normalTasksWithAssign: "Tareas normales con asignación",
  noCrewAssigned: "Sin tripulación asignada",
  certificationType: "Tipo de certificación",
  defineWheterTheStorageBoxTypeRequiresPhotosSealNumberOrBoth: "Define si el tipo de caja de almacenamiento requiere fotos, número de precinto o ambos",
  checklist: "Lista de verificación",
  sealsNumber: "Número de precintos",
  ifNoRuleIsAddedToAnOrderTypeTheRequiredSealNumberWillBeEqualTo1: "Si no se agrega ninguna regla a un tipo de pedido, el número de precintos requerido será igual a 1",
  checklistRules: "Reglas de la lista de verificación",
  itLooksLikeThereIsNoRulesAdded: "Parece que no hay reglas agregadas",
  youCanStartByAddingANewRuleByClickingTheButtonBellow: "Puedes comenzar agregando una nueva regla haciendo clic en el botón de abajo",
  addARule: "Agregar una regla",
  sealNumbersNeeded: "Números de precinto necesarios",
  numberOfSealsRequired: "Número de precintos requeridos",
  whenOrderTypeIs: "Cuando el tipo de pedido es",
  addAnotherRule: "Agregar otra regla",
  sealsValueMustBeGreaterThan0: "El valor de precintos debe ser mayor que 0",
  pleaseFillInTheCustomerInformationFirst: "Por favor, completa primero la información del cliente.",
  isAllocated: "Está asignado",
  clearSelection: "Limpiar selección",
  typeIn: "Escribe",
  newPlaceholderTask: "Nueva tarea de marcador",
  taskName: "Nombre de tarea",
  typeHereAComment: "Escribe aquí un comentario",
  deleteTask: "Eliminar tarea",
  yesDelete: "Sí, eliminar",
  areYouSureyouWantToDeleteTheTask: "¿Estás seguro de que deseas eliminar la tarea?",
  placeholder: "Marcador",
  taskDescription: "Descripción de la tarea",
  describeTaskHere: "Describe la tarea aquí",
  sealNumbers: "Números de precinto",
  sealNumber: "Número de Precinto",
  photosOfSpecialItemsInside: "Fotos de artículos especiales dentro",
  photosOfCaulked: "Fotos de sellado",
  photosOfPackedAndSealed: "Fotos de embalado y sellado",
  itLooksLikeThereIsNoPhotosYet: "Parece que aún no hay fotos",
  youCanStartByAddingANewPhotoOnTheButtonBelow: "Puedes comenzar agregando una nueva foto en el botón de abajo",
  addAnotherPhoto: "Agregar otra foto",
  checklistDone: "Lista de verificación completada",
  noTaskAdded: "Sin tarea agregada",
  createAnInternalTaskOrARegisterForADraftTask: "Crear una tarea interna o un registro para una tarea borrador",
  selectAReport: "Seleccionar un informe",
  crew_schedule_report: "Informe de programación de tripulación",
  warehouse_schedule_report: "Informe de programación del almacén",
  atLeastOneBranchMustBeSelected: "Debe seleccionarse al menos una sucursal",
  reportTypeIsRequired: "El tipo de informe es obligatorio",
  noReportGenerated: "Sin informe generado",
  reportGeneratedSuccessfully: "informe generado exitosamente",
  reportsGeneratedSuccessfully: "informes generados exitosamente",
  youMustSelectAtLeast1BranchToPrint: "Debes seleccionar al menos 1 sucursal para imprimir",
  leaderName: "Nombre del líder",
  memberName: "Nombre del miembro",
  equipmentName: "Nombre del equipo",
  multiDay: "Varios días",
  theTaskIsFinishedSoItCannotBeRemoved: "La tarea está finalizada, por lo que no puede ser eliminada.",
  showSupplierNameOnTheSSCCLabel: "Mostrar nombre del proveedor en la etiqueta SSCC",
  dateFor: "Fecha para",
  isThisAMultiDayTask: "¿Es esta una tarea de varios días?",
  endDateCantBeBeforeStartDate: "La fecha de fin no puede ser antes que la fecha de inicio",
  quickSearch: "Búsqueda rápida",
  newSubscriber: "Nuevo suscriptor",
  searchForAnUserByTyping: "Buscar un usuario escribiendo",
  enterContactType: "Ingresar tipo de contacto",
  unselectAll: "Deseleccionar todo",
  thereAreNoOrderBelongingToTheSelectedBranchesFor: "No hay pedidos que pertenezcan a la(s) sucursal(es) seleccionada(s) para",
  thereAreNoOrderBelongingToTheSelectedBranchesForToday: "No hay pedidos que pertenezcan a la(s) sucursal(es) seleccionada(s) para hoy",
  multi_day: "Varios días",
  fullDay: "Día completo",
  between: "entre",
  unavailableOn: "No disponible el",
  h: "h",
  m: "m",
  withPhotos: "Con fotos",
  withoutPhotos: "Sin fotos",
  manageEmailSubscriptions: "Gestionar suscripciones de correo",
  reportName: "Nombre del informe",
  subscribers: "Suscriptores",
  editActivities: "Editar actividades",
  emailActivities: "Actividades de correo",
  activities: "Actividades",
  timestamp: "marca de tiempo",
  changes: "Cambios",
  modifiedBy: "Modificado por",
  selectedFilters: "Filtros seleccionados",
  deactivate: "Desactivar",
  areYouSureYouWantToDeactivateThisReportEmailSubscription: "¿Estás seguro de que deseas desactivar esta suscripción de informe por correo?",
  youWillNoLongerReceiveEmailsForTheSelectedReport: "Ya no recibirás correos para el informe seleccionado.",
  deactivateEmailScheduleForThisReport: "¿Desactivar programación de correo para este informe?",
  yesDeactivate: "Sí, desactivar",
  cancelGoBack: "Cancelar y volver",
  noEmailSubscriptionsRegistered: "Sin suscripciones de correo registradas",
  addAdminUser: "Agregar usuario administrador",
  oneTime: "Una vez",
  emailFrequency: "Frecuencia del correo",
  noOfTasks: "N.º de tareas",
  orderCreated: "Pedido creado",
  totalOrders: "Total de pedidos",
  ordersCompleted: "Pedidos completados",
  totalTasks: "Total de tareas",
  tasksCompleted: "Tareas Completadas",
  exportingCSV: "Exportando CSV",
  taskBooked: "Tarea reservada",
  hideTasks: "Ocultar tareas",
  showTasks: "Mostrar tareas",
  lifetime: "Vida útil",
  reportLifetimeData: "Datos de vida útil del informe",
  originBranch: "Sucursal de origen",
  destinationBranch: "Sucursal de destino",
  teamBranches: "Sucursales del equipo",
  receiveOnlyOnce: "Recibir solo una vez",
  receiveEveryWeek: "Recibir cada semana",
  receiveOnceAMonth: "Recibir una vez al mes",
  sendOn: "Enviar el",
  sendEvery: "Enviar cada...",
  onceYouClickOn: "Una vez que hagas clic en",
  youWillReceiveThisReportWithAllTheSelectedFiltersAndSetFrequency: "recibirás este informe con todos los filtros seleccionados y la frecuencia establecida",
  emailDeliveryMayBeDelayedDueFactorsBeyondOurControl: "La entrega de correo puede retrasarse por factores fuera de nuestro control.",
  pleaseWhitelistToAvoidEmailsGoingToSpam: "Por favor, añade shipeezi.com a la lista blanca para evitar que los correos vayan al spam.",
  subscriberMustBeRegisteredOnShipeezi: "El suscriptor debe estar registrado en Shipeezi",
  enterADayOfTheMonthBetween1and28: "Ingresa un día del mes entre 1 y 28",
  selectReportType: "Seleccionar tipo de informe",
  allReports: "Todos los informes",
  selectTaskReportType: "Seleccionar tipo de informe de tarea",
  generateAndDownload: "Generar y descargar",
  workOrder: "Orden de trabajo",
  applicableOnlyOnInventoryConditionReport: "Aplicable solo en el informe de condición de inventario",
  applicableOnlyOnLoadAndTransshipmentReport: "Aplicable solo en el informe de carga y transbordo",
  applicableOnInventoryConditionReportMechanicalAndEletricalChecklistHightValuePropertyDemange: "Aplicable en informe de condición de inventario, lista de verificación mecánica y eléctrica, propiedad de alto valor",
  listOfReports: "Lista de informes",
  allAvailableReportsForThisOrderWillBeGeneratedInOneBatchWhichMayTakeLongerThanUsual: "Todos los informes disponibles para este pedido se generarán en un lote, lo que puede tardar más de lo habitual",
  pleaseNoteThatGrayedOutReportsAreCurrentlyUnavailbaleForThisOrder: "Ten en cuenta que los informes en gris no están disponibles actualmente para este pedido",
  youCanChooseTheSpecificReportsYouNeedAndEachSelectedReportWillBeGeneratedAsAnIndividualFileWhichMayTakeLongerThanUsual: "Puedes elegir los informes específicos que necesitas y cada informe seleccionado se generará como un archivo individual",
  security: "Seguridad",
  enableTwoFactorAuthenticationToLogin: "Habilitar autenticación de dos factores para iniciar sesión",
  enableAnExternalMethodToAuthenticateLogin: "Habilitar un método externo para autenticar el inicio de sesión.",
  limitUnsuccessfulLogonAttempts: "Limitar intentos de inicio de sesión sin éxito",
  anThe4thFailedAttemptTheAccountWillBeLockedFor30Seconds: "En el 4.º intento fallido, la cuenta se bloqueará durante 30 segundos",
  onThe5thFailedAttemptTheAccountWillBeLockedFor60Seconds: "En el 5.º intento fallido, la cuenta se bloqueará durante 60 segundos",
  anyFailedAttemptsAfterThe5thTheAccountWillBeLockedFor120Seconds: "Cualquier intento fallido después del 5°, la cuenta será bloqueada por 120 segundos.",
  onThe6thFailedAttemptTheAccountWillBeLockedFor120Seconds: "En el 6° intento fallido, la cuenta será bloqueada por 120 segundos;",
  anyFailedAttemptsAfterThe6thTheAccountWillBeLockedFor120Seconds: "Cualquier intento fallido después del 6°, la cuenta será bloqueada por 120 segundos.",
  autoTerminateSessionsAfter8HoursFromLogin: "Terminar sesiones automáticamente 8 horas después del inicio de sesión",
  thePlatformCalculates8HoursFromTheMostRecentLoginAndTerminatesTheSessionRequiringTheUserToLogInAgain: "La plataforma calcula 8 horas desde el inicio de sesión más reciente y termina la sesión, requiriendo que el usuario inicie sesión nuevamente.",
  aWarningAppears15MinutesBeforeTheSessionTeminates: "Aparece una advertencia 15 minutos antes de que la sesión finalice.",
  minimumPasswordComplexityPolicy: "Política de complejidad mínima de contraseña",
  passwordsMustFulfilMinimumRequirementsForAComplexPasswordWhenCreatingOrResettingAPassword: "Las contraseñas deben cumplir los requisitos mínimos de una contraseña compleja al crear o restablecer una contraseña.",
  prohibitPasswordReuse: "Prohibir la reutilización de contraseñas",
  prohibitUsersFromReusingAPreviousPasswordWhenCreatingOrResettingAPassword: "Prohibir a los usuarios reutilizar una contraseña anterior al crear o restablecer una contraseña.",
  automatedPasswordResetPolicy: "Política de restablecimiento automático de contraseña",
  passwordsMustBeChangedEvery90Days: "Las contraseñas deben cambiarse cada 90 días.",
  operationsApp: "App de Operaciones",
  inventoryNumberingIsTheStartingInventoryNumberEditable: "Numeración de inventario: ¿Es editable el número de inventario inicial?",
  enforceAppLockScreen: "Aplicar pantalla de bloqueo de la app",
  usingTheAppForMilitaryPurpose: "¿Usando la app con fines militares?",
  ifAUserIsInactiveForASetPeriodTheAppLocksAutomaticallyForSecurityUsersChooseAPinAtFirstLoginAndCanResetItUsingTheirUsernameAndPasswordThisPreventsUnauthorizedAccessToSensitiveData: "Si un usuario está inactivo durante un período determinado, la app se bloquea automáticamente por seguridad. Los usuarios eligen un PIN en el primer inicio de sesión y pueden restablecerlo con su nombre de usuario y contraseña. Esto previene el acceso no autorizado a datos sensibles.",
  enterInactivityTime: "Ingresar tiempo de inactividad",
  fieldRelatedSettings: "Configuraciones relacionadas con el campo",
  loadIntoStorageBoxIsMandatoryInUpliftTask: "Cargar en Caja de Almacenamiento es obligatorio en la Tarea de Recogida",
  systemConfigurationIsNotAvailablePleaseContactTheAdministratorForAssistance: "La configuración del sistema no está disponible. Comuníquese con el administrador para obtener asistencia.",
  updatedSuccessfully: "Actualizado exitosamente",
  ifVolumeConfirmationIsMandatoryThenStorageBoxMandatoryOptionMustBeSetToFalse: "Si la Confirmación de Volumen es obligatoria, entonces la opción obligatoria de Caja de Almacenamiento debe establecerse en falso.",
  volumeConfirmation: "Confirmación de Volumen",
  autofillBasedOnTheTask: "Autocompletar según la tarea",
  allowMultipleSelection: "Permitir selección múltiple",
  inventoryFields: "Campos de inventario",
  expanseManagement: "Gestión de gastos",
  others: "Others",
  cost: "Cost",
  onceDeletedThisEntryWillBePermanentlyRemoved: "Una vez eliminada, esta entrada se eliminará de forma permanente.",
  loadingTaskInformation: "Cargando información de la tarea...",
  taskNotFound: "Tarea no encontrada",
  couldNotLoadRequestedTaskDetails: "No se pudieron cargar los detalles de la tarea solicitada.",
  recalculateExpenses: "Recalcular Gastos",
  isTimeSlotRequiredForMultiDayTask: "¿Se requiere franja horaria para tareas de varios días?",
  fixedTimeSlot: "Franja horaria fija",
  variableTimeSlot: "Franja horaria variable",
  addAnotherDate: "Agregar otra fecha",
  itShouldBeAtLeastTwoDates: "Debe haber al menos dos fechas.",
  endTimeMustBeGreaterThanStartTime: "La hora 'Hasta' debe ser mayor que la hora 'Desde'.",
  generatingYourReportMightTakeLongerThanUsual: "La generación de su informe puede tardar más de lo habitual.",
  weWillNotifyYouAsSoonAsItsReadyForDownload: "Le notificaremos en cuanto esté listo para descargar. Puede cerrar esta ventana con seguridad mientras tanto.",
  categorizeItemsInOperationsApp: "Categorizar elementos en la app de operaciones",
  checkedFieldsWillBeMarkedAsAMandatory: "Los campos marcados se establecerán como obligatorios.",
  selectCategories: "Seleccionar categorías",
  mandatoryFields: "Campos Obligatorios",
  mandatoryFieldsByCategory: "Campos obligatorios por categoría",
  noAccess: "Sin acceso",
  fullAccess: "Acceso completo",
  partialAccess: "Acceso parcial",
  newAccessRuleAdded: "Nueva Regla de Acceso '{{accessRuleName}}' agregada",
  newAccessRuleAddedAndSetAsInactive: "Nueva Regla de Acceso '{{accessRuleName}}' agregada y establecida como inactiva",
  accessRuleUpdatedSuccessfully: "Regla de Acceso '{{accessRuleName}}' actualizada exitosamente",
  accessRuleDeletedSuccessfully: "Regla de Acceso '{{accessRuleName}}' eliminada exitosamente",
  thisIsASystemDefaultAccessRuleAndCannotBeModifiedYouAreWelcomeToCreateANewAccessRuleOrDuplicateAsNeeded: "Esta es una regla de acceso predeterminada del sistema y no puede modificarse. Puede crear una nueva regla de acceso o duplicarla según sea necesario.",
  thisAccessRuleIsUtilizedBy: "Esta regla de acceso es utilizada por {{group}}",
  returnToPermissions: "Volver a los permisos",
  thisRuleIsCurrentlyUtilizedByGroupsAndCannotBeDeactivated: "Esta regla está siendo utilizada por grupos y no puede desactivarse.",
  thisRuleIsCurrentlyUtilizedByGroupsAndCannotBeDeleted: "Esta regla está siendo utilizada por grupos y no puede eliminarse.",
  pleaseUseOnlyLettersNumbersAndSpacesSpecialCharactersAreNotAllowed: "Utilice solo letras, números y espacios. No se permiten caracteres especiales.",
  enterNameForThisAccessRule: "Ingrese el nombre para esta regla de acceso",
  describeThisAccessRuleInFewWords: "Describa esta regla de acceso en pocas palabras",
  failedToAssignPermissionsToAccessRulePleaseTryAgain: "Error al asignar permisos a la regla de acceso. Inténtelo de nuevo.",
  yourPermissionsHaveBeenUpdatedPleaseLogInAgainToApplyTheNewChanges: "Un administrador ha actualizado los permisos de acceso de su grupo. Para aplicar los cambios, debe cerrar sesión e iniciar sesión nuevamente.",
  signBackIn: "Volver a iniciar sesión",
  groupAccessRuleUpdated: "Regla de acceso del grupo actualizada",
  theAccessRuleNameAlreadyExistsPleaseChooseADifferentName: "El nombre de regla de acceso '{{accessRuleName}}' ya existe. Por favor, elige un nombre diferente.",
  enterNickname: "Ingresar apodo",
  nicknameIsForYourOwnReference: "El apodo es para tu propia referencia",
  dateOfDeparture: "Fecha de salida",
  arrivalAtAod: "Llegada en AoD",
  enterOrder: "Ingresar pedido",
  enterEmail: "Ingresar correo electrónico",
  enterMobileNumber: "Ingresar número móvil",
  realTimeTrackingUnavailable: "Seguimiento en tiempo real no disponible",
  liveTrackingIsUnavailableOnYourCurrentPlanUnlockThisFeatureByUpgradingYourPlanOrContactingOurSupportTeamForAssistance: "El seguimiento en vivo no está disponible en tu plan actual. Desbloquea esta función actualizando tu plan o contactando a nuestro equipo de soporte.",
  typeOfContact: "Tipo de contacto",
  notifyVia: "Notificar vía",
  refineByOrder: "Filtrar por pedido",
  bolBooking: "BoL/Reserva",
  pol: "PoL",
  utilization: "Utilización",
  destinationAirport: "Aeropuerto de destino",
  display: "Mostrar",
  items2: "artículos",
  exportCSV: "Exportar CSV",
  numberOfRowsPerPage: "Número de filas por página",
  errorField: "Error",
  showHideColumn: "Mostrar/Ocultar columnas",
  typeAndClickEnterToAdd: "Escribe y presiona Enter para agregar",
  communicationSentSuccessfully: "¡Comunicación enviada exitosamente!",
  deSelectAll: "Deseleccionar todo",
  selectOrders: "Seleccionar pedidos",
  addSelectedOption: "Agregar pedidos seleccionados",
  volumeAdded: "Volumen agregado",
  noLinkNotYet: "¡Aún no hay pedidos vinculados!",
  notifyUsers: "Notificar usuarios",
  notificationSentSuccessfully: "¡Notificación enviada exitosamente!",
  continueBooking: "Continuar reserva",
  saveADraft: "Guardar borrador",
  grossWeightKg: "Peso bruto (Kg)",
  saveThisSearch: "Guardar esta búsqueda",
  serial: "Serie",
  groupManagementCreatedSuccessfully: "Grupo '{{groupName}}' creado exitosamente",
  groupManagementUpdatedSuccessfully: "Grupo '{{groupName}}' actualizado exitosamente",
  errorUpdateGroupManagement: "Ocurrió un error al actualizar el grupo '{{groupName}}'. Contacta al soporte de Shipeezi.",
  groupInfoViewOnly: "Este es un grupo predeterminado del sistema que no puede modificarse, pero puedes agregar o eliminar miembros",
  groupNameAlreadyExists: "El nombre de grupo '{{groupName}}' ya existe. Por favor, elige un nombre diferente.",
  itLooksLikeYoureAboutToLeaveTheBookingProcessIfYouExitNowYourBookingWillNotBeCompletedAndAllTheInformationYouveEnteredSoFarWillBeLost: "Parece que estás a punto de salir del proceso de reserva. Si sales ahora, tu reserva no se completará y toda la información ingresada se perderá.",
  importantOnceYouLeaveTheresNoGuaranteeThatTheSameAvailabilityAndRatesWillStillApplyIfYouStartTheBookingAgain: "Importante: Una vez que salgas, no hay garantía de que la misma disponibilidad y tarifas se apliquen si inicias la reserva nuevamente.",
  areYouSureYouWantToCancel: "¿Estás seguro de que deseas cancelar?",
  connectionTimeout: "Tiempo de conexión agotado: Por favor, inténtalo de nuevo",
  timeoutDetail: "Está tardando más de lo esperado. Puede ser un problema temporal. Por favor, actualiza la página o inténtalo de nuevo.",
  retry: "Reintentar",
  nothingToDisplayHere: "¡Nada que mostrar aquí!",
  toGetStartedFillOutTheSearchFormWithYourFreightDetailsAndHitTheSearchButtonToSeeTheBestAvailableOptions: "To get started, fill out the search form with your freight details and hit the \"Search\" button to see the best available options.",
  averagePassword: "Contraseña regular",
  tariff: "Arancel",
  roadFreightPickUp: "Flete por carretera\n(recogida)",
  thcO: "THC-O",
  exportService: "Servicio de exportación",
  thcD: "THC-D",
  importService: "Servicio de importación",
  roadFreightDelivery: "Flete por carretera (entrega)",
  carbonOffset: "Compensación de carbono",
  transportMode: "Modo de transporte",
  rateValidity: "Validez de tarifa",
  totalCargoWeight: "Peso total de carga",
  inspectionServices: "Servicios de inspección",
  customClearance: "Despacho aduanero",
  etaAtWarehouse: "ETA en almacén",
  edd: "EDD",
  etaUnpack: "ETA de desembalaje",
  supplierPortalBannerMessagePaymentPending: "Según el <strong>Incoterm {{incoterm}}</strong>, los costos deben ser pagados por el comprador. La reserva se confirmará tras el pago.",
  supplyChainBannerMessagePaymentPending: "Según el <strong>Incoterm {{incoterm}}</strong>, los costos deben pagarse para confirmar la reserva.",
  originTerminalHandlingCharge: "Cargo de manejo en terminal de origen",
  destinationTerminalHandlingCharge: "Cargo de manejo en terminal de destino",
  portOfLoadingPoL: "Puerto de carga (PoL)",
  portOfDischargePoD: "Puerto de descarga (PoD)",
  movementType: "Tipo de movimiento",
  freightCharges: "Cargos de flete",
  payWithCard: "Pagar con tarjeta",
  notRequired: "No requerido",
  paymentWillBeAvailableToTheBuyerSoon: "El pago estará disponible para el comprador pronto.",
  theBuyerHasPaidSuccessfully: "El comprador ha pagado exitosamente.",
  thisBookingHasExpiredAndBeenCancelled: "Esta reserva ha expirado y fue cancelada.",
  onceConfirmedThisWillBeSentToTheCarrierYouAreNotAbleToMakeAnyAdditionalChanges: "Una vez confirmado, esto se enviará al transportista. No podrás realizar cambios adicionales.",
  payBooking: "Pagar reserva",
  paidOn: "Pagado el",
  noAllocated: "No asignado",
  thisFieldDoesntAllowSpecialCharacters: "Este campo no permite caracteres especiales",
  anErrorOccurredWhileProcessingYourRequestPleaseTryAgainOrContactSupport: "Ocurrió un error al procesar tu solicitud. Por favor, inténtalo de nuevo o contacta soporte.",
  anErrorOccurredWhileProcessingYourRejectionPleaseTryAgainOrContactSupport: "Ocurrió un error al procesar tu rechazo. Por favor, inténtalo de nuevo o contacta soporte.",
  errorProcessingRejection: "Error al procesar el rechazo",
  errorProcessingRequest: "Error al procesar la solicitud",
  areYouAnExistingShipeeziUser: "¿Eres un usuario existente de Shipeezi?",
  yesGoToLoginPage: "Sí, ir a la página de inicio de sesión",
  noRegisterAsAnAgent: "No, registrarse como agente",
  selectCompany: "Seleccionar empresa",
  enterName: "Ingresar nombre",
  connect: "Conectar",
  anErrorOccurredWhileTryingToConnectTheCompaniesPleaseTryAgainLater: "Ocurrió un error al intentar conectar las empresas. Por favor, inténtalo de nuevo más tarde.",
  invalidOrExpiredLink: "Enlace inválido o expirado",
  thisInvitationLinkIsInvalidOrHasAlreadyExpiredPleaseContactUsToReceiveANewInvitation: "Este enlace de invitación es inválido o ya ha expirado. Contáctanos para recibir una nueva invitación.",
  paymentPending: "Pago pendiente",
  processing: "Procesando",
  searchFreight: "Buscar flete",
  freightBooking: "Reserva de flete",
  YourShipeeziID: "Tu ID de Shipeezi",
  noOfOrders: "N.º de pedidos",
  carriersFound: "Transportistas encontrados",
  LowToHigh: "De menor a mayor",
  HighToLow: "De mayor a menor",
  directRoutes: "Rutas directas",
  alternateRoutes: "Rutas alternativas",
  alternate: "Alternativo",
  direct: "Directo",
  Shipmentno: "N.º de envío",
  passwordResetSuccesfully: "Contraseña restablecida exitosamente",
  frieghtid: "ID de flete",
  passwordRestLinkExpired: "El enlace para restablecer contraseña ha expirado",
  valid: "Válido",
  customerIsNotAllowedToReceiveNotification: "El cliente no puede recibir notificaciones",
  carbonFootprint: "Huella de carbono",
  PlaceOfDestination: "Lugar de destino",
  advanceShippingNoticeIsRequired: "El aviso de envío anticipado es obligatorio",
  weightCantBe0: "El peso no puede ser 0",
  shipTermsIsRequired: "Los términos de envío son obligatorios",
  selectOfficeFromTheDropdown: "Seleccionar oficina del desplegable",
  marksAndNumber: "Marcas y números",
  requiredDocument: "Documentos obligatorios",
  supportingDocuments: "Documentos de soporte",
  optionalShipmentData: "Datos opcionales del envío",
  requiredVolumeConfirmation: "La confirmación de volumen es obligatoria",
  shipmentsSettings: "Envíos",
  seaTrackingEnabled: "Seguimiento marítimo habilitado",
  airTrackingEnabled: "Seguimiento aéreo habilitado",
  accessRuleCreatedSuccessfully: "Nueva regla de acceso '{{accessRuleName}}' agregada",
  accessRuleDuplicatedSuccessfully: "Nueva regla de acceso '{{accessRuleName}}' agregada e inactivada",
  accessRuleInfoViewOnly: "Esta es una regla de acceso predeterminada del sistema y no puede modificarse. Puedes crear una nueva o duplicarla según sea necesario.",
  viewGroupAccessRuleTitle: "Esta regla de acceso es utilizada por {{groupCount}} grupos",
  accessRuleNameHaveSpecialCharacter: "Por favor, usa solo letras, números y espacios. No se permiten caracteres especiales.",
  updatedPreference: "¡Preferencia de tabla de datos actualizada!",
  subscriberThatLinkedToOrdersIsNotAllowedToBeDelete: "¡Los suscriptores vinculados a pedidos no pueden eliminarse!",
  minimumPageSizeGreaterThanTen: "El tamaño mínimo de página es 10",
  subscriberSuccessfullyAdded: "Suscriptor agregado exitosamente",
  defaultTeam: "Equipo predeterminado",
  customTeam: "Equipo personalizado",
  created: "Creado",
  noMatchingRecordsFound: "No se encontraron registros coincidentes",
  tryAdjustingYourFilters: "Intenta ajustar tus filtros.",
  noRecordFound: "No se encontró registro",
  haveTask: "Tiene tarea",
  dontHaveTask: "No tiene tarea",
  forContainerOnRow: "Para contenedor en fila",
  column: "columna",
  storeName: "Nombre de tienda",
  loadedStatus: "Estado de carga",
  markAsDefault: "Marcar como predeterminado",
  enterTemplateName: "Ingresar nombre de plantilla",
  enterSubject: "Ingresar asunto",
  enterFromName: "Ingresar nombre de remitente",
  enterStatus: "Ingresar estado",
  enterAvailableIn: "Ingresar disponible en",
  enterAutomation: "Ingresar automatización",
  enterLastUpdate: "Ingresar última actualización",
  addBusinessIcon: "Agregar ícono empresarial",
  addBusinessLogo: "Agregar logo empresarial",
  addIcon: "Agregar ícono",
  fromName: "Nombre del remitente",
  formatsJPG_GIF_PNG: "Formatos: JPG, GIF, PNG",
  maxSize2MB: "Tamaño máximo: 2 MB",
  attachments: "Adjuntos",
  pushNotification: "Notificación push",
  salesApp: "App de Ventas",
  linkedAutomation: "Automatización vinculada",
  noAutomationsLinked: "Sin automatizaciones vinculadas",
  notShared: "No compartido",
  partiallyShared: "Parcialmente compartido",
  fullyShared: "Completamente compartido",
  scac: "SCAC",
  inventorySummary: "Resumen de inventario",
  networkDetails: "DETAILS",
  networkRoles: "ROLES",
  networkWeightAndMeasurements: "WEIGHT AND MEASUREMENTS",
  networkPickup: "PICKUP",
  networkDelivery: "DELIVERY",
  networkGeneralComments: "GENERAL COMMENTS",
  networkActualInventory: "ACTUAL INVENTORY",
  networkQuotedInventory: "QUOTED INVENTORY",
  networkPhotosAndVideos: "PHOTOS & VIDEOS",
  networkDocuments: "DOCUMENTS",
  networkSettingsBannerMessage: "Elige los campos de datos de la sección de abajo que deseas mostrar al agente de red al aceptar la tarea.",
  failedToSaveNetworkSettings: "Error al guardar la configuración de red",
  assignToAnAgent: "¿Asignar a un agente?",
  selectAnAgent: "Seleccionar un agente",
  additionalInstructions: "Instrucciones adicionales",
  enterAdditionalInstructions: "Ingresar instrucciones adicionales",
  agentName: "Nombre del agente",
  started: "Started",
  taskAddedSuccessfully: "¡Tarea agregada exitosamente!",
  thisInstructionWillBeVisibleInTheEmailAndTaskView: "Esta instrucción será visible en el correo electrónico y en la Vista de Tarea.",
  moreJobTypes: "Más tipos de trabajo",
  moreTaskTypes: "Más tipos de tarea",
  moreTriggers: "Más disparadores",
  selectTaskTypes: "Seleccionar tipos de tarea",
  selectOrderTypes: "Seleccionar tipos de pedido",
  selectTriggers: "Seleccionar disparadores",
  typeCode: "Código de tipo",
  newChecklist: "Nueva lista de verificación",
  enterQuestionHere: "Ingrese la pregunta aquí",
  responseType: "Tipo de respuesta",
  addLogic: "Agregar lógica",
  shortDescription: "Descripción corta",
  enterDescriptionHere: "Ingrese la descripción aquí",
  singleChoiceQuestion: "Pregunta de opción única",
  multipleChoiceQuestion: "Pregunta de opción múltiple",
  inputText: "Ingresar texto",
  inputNumber: "Ingresar número",
  selectDate: "Seleccionar Fecha",
  addSignature: "Agregar firma",
  checklistItem: "Elemento de lista de verificación",
  enterOptions: "Ingresar opciones",
  option: "Option",
  addQuestion: "Agregar pregunta",
  defaultState: "Estado predeterminado",
  taskTypes: "Tipos de Tarea",
  jobTypes: "Tipos de Trabajo",
  ifAnswer: "Si respuesta",
  is: "is",
  isNot: "no es",
  then: "then",
  enterText: "Ingresar texto",
  enterNumber: "Ingresar número",
  selectOption: "Seleccionar opción",
  isLesserThan: "es menor que",
  isGreaterThan: "es mayor que",
  selected: "Seleccionado",
  notSelected: "no seleccionado",
  if: "If",
  requireEvidence: "Requerir evidencia",
  askQuestion: "Hacer pregunta",
  chooseTheEvidenceThatllBeRequiredWhenThisAnswerIsSelected: "Elija la evidencia que se requerirá cuando se seleccione esta respuesta.",
  youShouldAddAtLeastOneOption: "Debe agregar al menos una opción.",
  youShouldAddAtLeastTwoOptions: "Debe agregar al menos dos opciones.",
  allOptionsShouldHaveAName: "Todas las opciones deben tener un nombre.",
  methodOfPreparation: "Método de Preparación",
  itemCharacteristics: "Características del Artículo",
  highRiskHighValueChecklist: "Lista de Verificación de Alto Riesgo/Alto Valor",
  proGearChecklist: "Lista de Verificación Pro-Gear",
  isHighRisk: "Es de alto riesgo",
  notHighRisk: "No es de alto riesgo",
  isProGear: "Es Pro-Gear",
  notProGear: "No es Pro-Gear",
  meChecklistNotDone: "Lista M&E no completada",
  unsavedItem: "Artículo sin guardar, guarda para aplicar todos los filtros correctamente",
  youHaveUnsavedChanges: "Tienes cambios sin guardar.",
  doYouWantToSaveBeforeLeaving: "¿Deseas guardar antes de salir?",
  timezoneIssue: "Problema de zona horaria",
  allQuestionsMustHaveATitleAndAllLogicsFieldsMustBeFilled: "Todas las preguntas deben tener un título y todos los campos de lógica deben estar completos.",
  areYouSureYouWantToDeleteThisLogic: "¿Estás seguro de que deseas eliminar esta lógica?",
  deleteLogic: "Eliminar lógica",
  atLeastOneOptionIsRequired: "Se requiere al menos una opción",
  atLeastTwoOptionsAreRequired: "Se requieren al menos dos opciones",
  templateNameAlreadyExists: "¡El nombre de la plantilla ya existe!",
  userUploaded: "Cargas del usuario",
  systemGenerated: "Cargas del sistema",
  uploadFiles: "Subir archivos",
  orDragAndDropHere: "o arrastra y suelta archivos aquí",
  maxFileSizeLimit: "El tamaño máximo de archivo es 25 MB. Formatos aceptados:",
  quickOrder: "Pedido rápido",
  createQuickOrder: "Crear pedido rápido",
  automaticSequenceUnavailableEnterReferenceManually:
    "La secuencia automática no está disponible. Introduzca la referencia manualmente.",
  enableQuickOrder: "Habilitar pedido rápido",
  showOrderReportInManagement: "Mostrar informe de pedidos en Management",
  reportsAvailableForSharingViaOpsApp:
    "Informes disponibles para compartir vía Ops App",
  noReportsAvailableForSharingViaOpsApp:
    "No hay informes disponibles para compartir vía Ops App",
  orderReport: "Informe de pedidos",
  orderAlreadyExists: "El pedido ya existe",
  searchOrAddCustomer: "Buscar o agregar cliente",
  aCustomerWithSameIdAlreadyExists: "Ya se agregó un cliente con el mismo ID",
  addANoteAsEvidence: "Agregar una nota como evidencia",
  addAPhotoAsEvidence: "Agregar una foto como evidencia",
  displayInDispatchModule: "Mostrar en módulo de despacho",
  leavingTheWarehouse: "Saliendo del almacén",
  leads: "Prospectos",
  estimates: "Estimaciones",
  proposal: "Propuesta",
  invoicing: "Facturación",
  creditNotes: "Notas de Crédito",
  expenses: "Gastos",
  claims: "Reclamaciones",
  storageBoxUnit: "Caja de almacenamiento y unidad",
  storageAccount: "Cuenta de Almacenamiento",
  finance: "Finanzas",
  packageType: "Tipo de Empaque",
  methodType: "Tipo de método",
  itemInstruction: "Instrucción del Ítem",
  leadSoure: "Fuente del contacto",
  help: "Ayuda",
  askDumont: "Preguntar a Dumont",
  dumontHelpDocumentation: "Ayuda y Documentación",
  dumontSendFeedback: "Enviar Comentarios",
  dumontContactSupport: "Contactar Soporte",
  dumontLearnHowToUseDumont: "Aprende a usar Dumont",
  dumontHelpUsImproveDumont: "Ayúdanos a mejorar Dumont",
  dumontGetHelpFromTeam: "Obtén ayuda de nuestro equipo",
  dumontQuickActions: "Acciones Rápidas",
  dumontContactOurSupport: "Contacta nuestro soporte",
  dumontGetHelpWithIssues: "Obtén ayuda con problemas y preguntas",
  dumontSendUsYourFeedback: "Envíanos tus comentarios",
  dumontShareThoughtsAndSuggestions: "Comparte tus pensamientos y sugerencias",
  dumontCommonQuestions: "Preguntas Frecuentes",
  dumontHowToCreateCustomAgent: "¿Cómo creo un agente personalizado?",
  dumontHowToCreateCustomAgentAnswer: "Para crear un agente personalizado, navega a la sección Agentes y haz clic en Crear Nuevo Agente. Luego puedes configurar las capacidades y ajustes del agente según tus necesidades.",
  dumontWhatCanDumontHelp: "¿Con qué puede ayudarme Dumont?",
  dumontWhatCanDumontHelpAnswer: "Dumont es tu asistente de IA especializado en logística y mudanzas. Puedo ayudarte con la planificación de despacho, gestión de pedidos, optimización de rutas y responder preguntas sobre tus operaciones.",
  dumontHowToAccessChatHistory: "¿Cómo accedo a mi historial de chat?",
  dumontHowToAccessChatHistoryAnswer: "Haz clic en el icono de Historial en la barra lateral para ver todas tus conversaciones anteriores con Dumont. Puedes buscar en tu historial y retomar cualquier conversación anterior.",
  dumontCanCustomizeAgentCapabilities: "¿Puedo personalizar las capacidades de los agentes?",
  dumontResources: "Recursos",
  dumontKnowledgeBase: "Base de Conocimiento",
  dumontCompleteGuidesAndTutorials: "Guías completas y tutoriales",
  dumontSelectAnOption: "Selecciona una opción",
  dumontFeedbackHelpsImprove: "Tus comentarios nos ayudan a mejorar Dumont",
  dumontIssueType: "Tipo de Problema",
  dumontSubject: "Asunto",
  dumontBriefDescriptionOfIssue: "Breve descripción del problema",
  dumontMessage: "Mensaje",
  dumontPleaseDescribeIssueDetail: "Por favor describe tu problema en detalle...",
  dumontIncludeErrorMessages: "Incluye cualquier mensaje de error o pasos para reproducir el problema",
  dumontGotIt: "Entendido",
  dumontCancel: "Cancelar",
  dumontSendFeedbackButton: "Enviar Comentarios",
  dumontSendMessage: "Enviar Mensaje",
  dumontSupportRequestSentSuccessfully: "Tu solicitud de soporte fue enviada exitosamente. Nuestro equipo responderá en 24 horas.",
  dumontFeedbackSentSuccessfully: "Tus comentarios fueron enviados exitosamente. ¡Agradecemos tu aporte!",
  dumontSearchPlaceholder: "Buscar chats, agentes, historial...",
  dumontNavigation: "Navegación",
  dumontNewChat: "Nuevo Chat",
  dumontChats: "Chats",
  dumontNoChatsFound: "No se encontraron chats",
  dumontNoRecentChats: "No hay chats recientes",
  dumontAgents: "Agentes",
  dumontNoAgentsFound: "No se encontraron agentes",
  dumontReturnToShipeezi: "Volver a Shipeezi",
  dumontHelp: "Ayuda",
  dumontWelcomeMessage: "Hola, {{userName}}, soy Dumont, tu asistente de IA especializado en logística y mudanzas. Creado para simplificar flujos complejos, aprendo continuamente para brindarte soporte más rápido, inteligente y preciso para tu negocio.",
  dumontWelcomeMessageBusiness: "¡Hola, {{userName}}, soy el Asistente de Negocios Dumont! 💼 Me especializo en ventas y cotizaciones. Puedo ayudarte a crear cotizaciones precisas de flete, gestionar relaciones con clientes y cerrar negocios más rápido. ¿Cómo puedo ayudarte hoy?",
  dumontWelcomeMessageOperations: "¡Hola, {{userName}}, soy el Asistente de Operaciones Dumont! 📊 Soy tu experto en operaciones. Puedo ayudarte a rastrear envíos, monitorear entregas, gestionar trabajos y garantizar operaciones logísticas fluidas. ¿Con qué necesitas ayuda?",
  dumontWelcomeMessageWarehousing: "¡Hola, {{userName}}, soy el Asistente de Almacenaje Dumont! 🏭 Me especializo en inventario y operaciones de almacén. Puedo ayudarte a gestionar niveles de stock, rastrear inventario, coordinar almacenamiento y optimizar la eficiencia del almacén. ¿Cómo puedo ayudar?",
  dumontDispatchQuickActions: "Acciones rápidas para Despacho",
  dumontHistory: "Historial",
  dumontConversationHistory: "Historial de Conversaciones",
  dumontNoConversationsFound: "No se encontraron conversaciones",
  dumontNoConversationHistory: "Sin historial de conversaciones",
  dumontTryDifferentSearchTerm: "Intenta con un término de búsqueda diferente",
  dumontStartNewConversation: "Inicia una nueva conversación para verla aquí",
  dumontFileTooLarge: "El archivo es demasiado grande. El tamaño máximo es 10MB.",
  dumontUnsupportedFileType: "Tipo de archivo no compatible. Selecciona archivos TXT, PDF o DOC/DOCX.",
  dumontDocumentProcessing: "El procesamiento de PDF/DOC estará disponible pronto. Por favor usa archivos TXT por ahora.",
  dumontFileProcessingError: "Error al procesar el archivo. Por favor intenta nuevamente.",
  dumontAskDumont: "Preguntar a Dumont...",
  dumontAskDumontAnything: "Pregúntale cualquier cosa a Dumont",
  dumontUpload: "Subir archivo",
  dumontUsesAI: "Dumont usa Inteligencia Artificial. Revisa las respuestas.",
  dumontCopyConversation: "Copiar conversación",
  dumontExportChat: "Exportar chat",
  dumontClearConversation: "Limpiar conversación",
  dumontLoadingAgents: "Cargando agentes...",
  dumontAgentsTitle: "Agentes Dumont",
  dumontCreateAgent: "Crear Agente",
  dumontSearchAgents: "Buscar agentes...",
  dumontNoAgentsAvailable: "No hay agentes disponibles",
  dumontAgentsAvailableSoon: "Los agentes estarán disponibles pronto",
  featureLocked: "Función bloqueada",
  accountNotHaveAccess: "Tu cuenta no tiene acceso a esta función en este momento.",
  reachSupportTeam: "Contacta a nuestro equipo de soporte",
  forDetails: " para más detalles.",
  titleFeatureRequestSupport: "Solicitar acceso a esta función",
  sendRequestSupport: "Enviar solicitud al soporte",
  itLooksLikeYouDontHaveAcessThisFeatureYet: "Parece que aún no tienes acceso a esta función. Si deseas usarla, envía una solicitud a nuestro equipo de soporte.",
  feature: "Función",
  pleaseDescribeYouIntendUseFeature: "Por favor, describe cómo piensas usar esta función",
  yourMessageShouldLeast50Characters: "Tu mensaje debe tener al menos 50 caracteres.",
  minCharacters: "Tu mensaje debe tener al menos {{count}} caracteres.",
  maxCharacters: "Tu mensaje no debe superar {{count}} caracteres",
  yourRequestHasBeenSentOurSupportTeam: "Tu solicitud ha sido enviada a nuestro equipo de soporte",
  TermsConditions: "Términos y condiciones",
  Iso14451: "ISO14451-1:2016",
  Iso17451: "ISO17451 - 1:2016",
  dumontComingSoon: "Próximamente...",
  dumontBusinessAssistant: "Asistente de Negocios",
  dumontBusinessAssistantDesc: "Especializado en ventas y cotizaciones",
  dumontOperationsAssistant: "Asistente de Operaciones",
  dumontOperationsAssistantDesc: "Experto en todas tus operaciones",
  dumontWarehousingAssistant: "Asistente de Almacenaje",
  dumontWarehousingAssistantDesc: "Experto en inventario y operaciones de almacén",
  dumontCanCustomizeAgentCapabilitiesAnswer: "¡Sí! Cada agente puede ser personalizado para adaptarse a tu flujo de trabajo específico. Puedes ajustar sus capacidades, establecer parámetros específicos y configurar a qué fuentes de datos tienen acceso.",
  dumontFeedbackType: "Tipo de Comentario",
  dumontYourFeedback: "Tus Comentarios",
  dumontTellUsWhatYouThink: "Dinos qué piensas...",
  dumontPleaseSelectTextFile: "Selecciona un archivo de texto (.txt)",
  dumontDocumentAttached: "Documento adjunto",
  dumontRemoveDocument: "Eliminar documento",
  dumontDefaultResponse: "¡Gracias por contactarnos! Estoy analizando tu solicitud y proporcionaré la mejor solución.",
  dumontSales: "Ventas",
  dumontOperations: "Operaciones",
  dumontLogistics: "Logística",
  dumontDispatchShowTodayOrders: "Mostrar órdenes de despacho de hoy",
  dumontDispatchShowTodayOrdersDesc: "Obtén un resumen de todas las órdenes programadas para despacho hoy",
  dumontDispatchFindCustomer: "Buscar órdenes por nombre de cliente",
  dumontDispatchFindCustomerDesc: "Busca órdenes específicas usando información del cliente",
  dumontDispatchTrackStatus: "Rastrear estado de la orden",
  dumontDispatchTrackStatusDesc: "Verifica el estado actual de las órdenes en el sistema",
  dumontDispatchOptimizeRoutes: "Optimizar rutas de entrega",
  dumontDispatchOptimizeRoutesDesc: "Obtén sugerencias para las rutas de entrega más eficientes",
  dumontWhatCanIHelpYouWith: "¿Con qué puedo ayudarte?",
  dumontOptimizeLogisticsOperations: "Optimizar mis operaciones logísticas",
  dumontOptimizeLogisticsOperationsDesc: "Obtén recomendaciones personalizadas para mejorar la eficiencia y reducir costos",
  dumontTrackShipmentStatus: "Rastrear estado del envío",
  dumontTrackShipmentStatusDesc: "Obtén actualizaciones en tiempo real sobre tus envíos y estimaciones de entrega",
  dumontCalculateShippingCosts: "Calcular costos de envío",
  dumontCalculateShippingCostsDesc: "Estima costos para diferentes métodos y destinos de envío",
  dumontFindWarehouseLocations: "Encontrar ubicaciones de almacenes",
  dumontFindWarehouseLocationsDesc: "Descubre ubicaciones óptimas de almacenes para tu red de distribución",
  dumontManageInventoryLevels: "Gestionar niveles de inventario",
  dumontManageInventoryLevelsDesc: "Obtén información sobre optimización de inventario y gestión de stock",
  dumontScheduleDeliveries: "Programar entregas",
  dumontScheduleDeliveriesDesc: "Planifica y optimiza rutas de entrega para máxima eficiencia",
  dumontHowCanIHelpYou: "¿Cómo puedo ayudarte?",
  invalidFileType: "Tipo de archivo inválido",
  uploadFailed: "Error al subir",
  tooManyFiles: "Demasiados archivos",
  filesExceedSizeLimit: "Los archivos superan el límite de tamaño",
  allFilesUploadedSuccessfully: "Todos los archivos fueron subidos exitosamente",
  moreBranches: "Más sucursales",
  maximum10FilesPerUpload: "Máximo 10 archivos por carga.",
  generate: "Generar",
  onCSVWeHaveFoundSomeErrors: "En el CSV <strong>{{csvFileName}}</strong> hemos encontrado algunos errores. Debes ajustar esas líneas para continuar:",
  weReSecurelyLoadingYourDataIntoShipeeziSCertifiedFramework: "Estamos cargando de forma segura tus datos en el marco certificado de Shipeezi.",
  weFoundSomeIssuesInYourCSV: "Encontramos algunos problemas en tu \"{{csvFileName}}\". Por favor, corrige estas líneas antes de continuar:",
  needHelp: "¿Necesitas ayuda?",
  forTheCorrectFormat: "para el formato correcto.",
  noScreenshotsCaptured: "No se capturaron capturas de pantalla",
  noParticipantsAvailable: "No hay participantes disponibles",
  companySlug: "Slug de la empresa",
  aUniqueIDUsedToIdentifyThisOrganization: "Un ID único para identificar esta organización",
  thisSubdomainIsNotAvailablePleaseChooseADifferentOne: "Este subdominio no está disponible. Por favor, elige uno diferente.",
  fileIsTooBig: "El archivo es demasiado grande. El tamaño máximo es 25 MB",
  multiFactorAuthentication: "Autenticación multifactor",
  mfaMultiFactorAuthentication: "Autenticación multifactor",
  configureMfaSettingsPerGroup: "Configurar ajustes de MFA por grupo",
  mfaSettings: "Ajustes de MFA",
  enableMfa: "Habilitar MFA",
  mfaEnabled: "MFA habilitado",
  mfaDisabled: "MFA deshabilitado",
  authenticationMethod: "Método de autenticación",
  selectMethod: "Seleccionar método",
  environments: "Entornos",
  enabledEnvironments: "Entornos habilitados",
  savingMfaSettings: "Guardando ajustes de MFA...",
  mfaSettingsUpdated: "Ajustes de MFA actualizados exitosamente",
  errorUpdatingMfaSettings: "Error al actualizar los ajustes de MFA",
  noGroupsFound: "No se encontraron grupos",
  mfaVerificationTitle: "Ingresar código de verificación",
  mfaVerificationDescription: "Se ha enviado un código de verificación a:",
  mfaVerificationCode: "Código de verificación",
  verify: "Verificar",
  resendCode: "Reenviar código",
  resendViaEmail: "Reenviar por correo electrónico",
  resendViaSms: "Reenviar por SMS",
  mfaCodeResent: "Código de verificación reenviado exitosamente",
  errorResendingCode: "Error al reenviar el código. Por favor, inténtalo de nuevo.",
  invalidCode: "Código inválido. Por favor, inténtalo de nuevo.",
  codeExpired: "Código expirado",
  expiresIn: "Expira en",
  smsRequiresPhoneNumber: "SMS requiere número de teléfono",
  activeLoginSessions: "Sesiones de inicio de sesión activas",
  operating_system: "Sistema operativo",
  application: "Aplicación",
  shipeezi_platform: "Plataforma Shipeezi",
  ip_address: "Dirección IP",
  last_active_date: "Última actividad",
  youHaveToSelectAtLeastOnePlatform: "Debes seleccionar al menos una plataforma",
  prohibitSimultaneousLogin: "Prohibir inicio de sesión simultáneo",
  prohibitSimultaneousLoginDescription: "Evitar que los usuarios inicien sesión en múltiples dispositivos o plataformas al mismo tiempo",
  applyToPlatforms: "Aplicar a plataformas",
  selectEquipmentType: "Seleccionar tipo de equipo",
  infoMessageEquipmentTypeFilterTitle: "Este filtro es opcional.",
  infoMessageEquipmentTypeFilterNoSelection: "Sin selección → el informe incluye todos los tipos de equipo.",
  infoMessageEquipmentTypeFilterSpecificType: "Tipo específico seleccionado → el informe incluye solo tareas con ese tipo.",
  infoMessageEquipmentTypeFilterNoTasks: "Sin tareas para el tipo seleccionado → el informe no muestra resultados.",
  defaultTemplate: "Plantilla predeterminada",
  originFile: "Archivo de origen",
  templateContent: "Contenido de la plantilla",
  onboardingTrigger: "Incorporación",
  signupTrigger: "Registro",
  offboarding: "Desvinculación",
  sendViaVideoSurveyLink: "Enviar vía enlace de encuesta de video",
  sendANewInvitationToTheScheduleVideoSurvey: "Enviar una nueva invitación a la encuesta de video programada",
  thereIsNoActiveVideoSurvey: "No hay encuesta de video activa.",
  videoSurveyLinkSentToCustomer: "Enlace de encuesta de video enviado al cliente",
  videoSurveyLinkSendFailed: "Error al enviar el enlace de encuesta de video",
  plainText: "Texto plano",
  header: "Encabezado",
  copyrightText: "Texto de derechos de autor",
  shipeeziBranding: "Marca Shipeezi",
  scheduleSend: "Programar envío",
  sendDate: "Fecha de envío",
  sendTime: "Hora de envío",
  selectAnUser: "Seleccionar un usuario",
  currentShipByDate: "Fecha de envío actual",
  originalShipByDate: "Fecha de envío original",
  signup: {
    left: {
      title: "Bienvenido a Shipeezi — donde la visibilidad, el control y la simplicidad se unen",
      subtitle: "Start your free trial and experience how Shipeezi unifies every part of your workflow, from sales to operations to warehousing.",
      card1Title: "Simplicidad a escala",
      card1Desc: "Shipeezi reúne todos tus procesos en un solo lugar, ayudando a tu equipo a trabajar de forma más inteligente y rápida en todo el mundo.",
      card2Title: "Más control, menos costos",
      card2Desc: "Con todo conectado, ahorrarás tiempo, reducirás errores y cortarás costos, mientras brindas a tus clientes una experiencia fluida.",
      trusted: "Con la confianza de líderes de la industria en todo el mundo",
    },
    right: {
      createAccount: "Crear tu cuenta",
      subtitle: "You are just moments away of having full visibility and control over your shipments!",
      haveAccount: "¿Tienes cuenta?",
      signIn: "Iniciar sesión",
      thankYou: "Gracias por solicitar una cuenta con Shipeezi",
      pendingApproval: "Nuestro equipo se pondrá en contacto contigo antes de activar tu cuenta",
      step2Title: "Cuéntanos sobre tu empresa",
      step2Subtitle: "Adaptaremos Shipeezi a las necesidades de tu empresa",
      companyName: "Nombre de la empresa",
      companyType: "Tipo de empresa",
      selectYourPlatform: "Selecciona tu plataforma",
      step3Title: "¿Qué te gustaría mejorar con Shipeezi?",
      step3Subtitle: "Elige las áreas de tu negocio que deseas simplificar y escalar",
      sales: "Ventas",
      operations: "Operaciones",
      warehousing: "Almacenaje",
      next: "Siguiente",
      back: "Atrás",
      requestAccount: "Solicitar cuenta",
      termsOfUse: "Términos de uso",
      privacyPolicy: "Política de Privacidad",
      and: "y",
      byContinuingYouReAgreeingToShipeeziS: "Al continuar, aceptas los términos de Shipeezi",
      getEmailsFromShipeeziAboutProductUpdatesIndustryNewsAndEventsIfYouChangeYourMindYouCanUnsubscribeAtAnyTime: "Recibe correos de Shipeezi sobre actualizaciones de productos, noticias del sector y eventos.",
      captchaExpired: "Captcha expirado",
      step4Title: "Ayúdanos a entender tu proceso de ventas",
      step4Subtitle: "Tus respuestas nos ayudarán a configurar Shipeezi para tu equipo",
      videoSurveysQuestion: "¿Ofreces encuestas de video a tus clientes?",
      salesRepsQuestion: "¿Cuántos representantes de ventas tiene tu empresa?",
      yes: "Sí",
      no: "No",
      range_1_10: "1-10",
      range_11_20: "11-20",
      range_above_30: "Más de 30",
      salesStepTitle: "Ayúdanos a entender tu proceso de ventas",
      salesStepSubtitle: "Tus respuestas nos ayudarán a configurar Shipeezi para tu equipo",
      operationsStepTitle: "Cuéntanos sobre tus operaciones",
      operationsStepSubtitle: "Configuraremos Shipeezi según cómo tu empresa opera hoy",
      warehousingStepTitle: "Cuéntanos sobre tu almacenamiento",
      warehousingStepSubtitle: "Optimizaremos tu configuración de almacenamiento e inventario en Shipeezi",
      storageQuestion: "¿Ofreces almacenamiento a tus clientes?",
      warehousesCountQuestion: "¿Cuántos almacenes administras?",
      shipmentType: "Tipo de envío",
      local: "Local",
      international: "Internacional",
      interstate: "Interestatal",
      military: "Militar",
      annualShipmentVolume: "Volumen anual de envíos",
      v_1_4: "1-4",
      v_5_600: "5-600",
      v_601_10000: "601 - 10,000",
      v_10001_20000: "10,001 - 20,000",
      v_20001_plus: "20,001 +",
      step5Title: "¡Increíble! ¡Casi terminamos!",
      step5Subtitle: "¡Nos encantaría saber cómo descubriste Shipeezi!",
      thankYouV2Title: "¡Gracias por registrarte!",
      thankYouV2Description: "Nuestro equipo se pondrá en contacto pronto para activar tu cuenta. Estarás listo para experimentar Shipeezi — una plataforma, cada mudanza.",
      returnToWebsite: "Volver a nuestro sitio web",
      discover: {
        website: "Nuestro Sitio",
        email: "Email Marketing",
        google: "Google",
        newsletter: "Boletín informativo",
        aiTools: "Herramientas de IA",
        referral: "Referido",
        whereLabel: "¿Dónde?",
        whoReferredLabel: "¿Quién te refirió?",
        other: "Otro",
      },
      wh_1_10: "1-10",
      wh_11_30: "11-30",
      wh_above_30: "Más de 30",
      trustedBy: "Con la confianza de líderes del sector en todo el mundo",
      paymentTerms: "Términos de pago",
      privacyAndCompliance: "Política de privacidad y cumplimiento",
      saasAgreement: "Acuerdo SAAS y SLA",
      termsOfSale: "Términos de venta",
      termsPrefix: "Al continuar, acepta los",
      ownWords: {
        questionLabel: "¿Cuáles son sus desafíos u obstáculos actuales?",
        placeholder: "Escriba algo...",
        characters: "caracteres",
        helperShort: "Su mensaje debe tener al menos 50 caracteres.",
        helperLong: "Mantenga su mensaje por debajo de 500 caracteres.",
      },
    },
  },
  common: {
    close: "Cerrar",
    save: "Guardar",
    saving: "Guardando",
  },
  onboarding: {
    pageTitle: "Incorporación",
    left: {
      title: "Bienvenido a Shipeezi — donde la visibilidad, el control y la simplicidad se unen",
      subtitle: "You're just a few quick steps away from setting up your account. Shipeezi will help you simplify processes, connect your team, and give you full control over every move. Let's get started.",
    },
    steps: {
      introduction: "Introducción",
      companyDetails: "Agrega la información de tu empresa, dirección comercial y contacto principal",
      myBilling: "Mi facturación",
      members: "Miembros",
      uploadCentre: "Sube tu información inicial para que Shipeezi pueda conectar tus datos",
      complete: "Completo",
    },
    uploadCentre: {
      title: "Bienvenido a Shipeezi — donde la visibilidad, el control y la simplicidad se unen",
      description: "Aquí puedes subir tus propios archivos (como inventario, personal o listas de servicios) o",
      uploadOwnList: "Subir mi propia lista",
      uploadOwnListDescription: "Trae tus propios datos para personalizar Shipeezi desde el inicio.",
      useDefaultList: "Usar la lista predeterminada de Shipeezi (ISO17451-1:2016)",
      useDefaultListDescription: "Comienza rápidamente con nuestra lista preconfigurada, basada en el estándar global ISO17451-1:2016. Puedes actualizarla o expandirla en cualquier momento.",
      downloadTemplate: "Descarga nuestra plantilla CSV aquí",
      complete: "Completo",
    },
    complete: {
      title: "Bienvenido a Shipeezi — donde la visibilidad, el control y la simplicidad se unen",
      subtitle: "",
      button: "Comenzar",
      leftTitle: "¡Configuración completa!",
      leftSubtitle: "Todo listo para comenzar a gestionar cada mudanza en una sola plataforma.",
    },
    buttons: {
      goBackToLogin: "Volver al inicio de sesión",
      skip: "Omitir por ahora",
      downloadCsvTemplate: "Descarga nuestra plantilla CSV aquí",
      next: "Siguiente",
      back: "Atrás",
    },
    introduction: {
      companyDetails: "Agrega la información de tu empresa, dirección comercial y contacto principal",
      members: "Miembros",
      uploadCentre: "Sube tu información inicial para que Shipeezi pueda conectar tus datos",
    },
    members: {
      title: "Miembros",
      description:     "Invite a las personas que usarán Shipeezi con usted. Asigne su rol y sucursal para que tengan el acceso correcto desde el inicio. Siempre puede actualizar o agregar más miembros después.",
      registeredMembers: "Miembros registrados",
      firstName: "Nombre",
      lastName: "Apellido",
      email: "Correo electrónico",
      memberCode: "Código de miembro",
      branch: "Sucursal",
      mobile: "Móvil",
      accessGroup: "Grupo de acceso",
      memberType: "Tipo de miembro",
      additionalMembers: "Miembros adicionales",
      uploadMembers: "Subir miembros",
      addMembers: "Agregar miembros",
      name: "Nombre",
      group: "Grupo",
      type: "Tipo",
      noAdditionalMembers: "Sin miembros adicionales",
      downloadTemplate: "Descargar plantilla",
      uploadCSV: "Subir CSV",
      addMember: "Agregar miembro",
      userCode: "Código de usuario",
    },
    billing: {
      useSameAdmin: "Use the same “administrator user\" details",
      contactName: "Nombre del contacto de facturación",
      email: "Email",
      phone: "Número de teléfono",
      address: "Dirección",
      paymentMethod: "Método de pago",
      noPaymentMethod: "No hay método de pago registrado",
      addPaymentMethod: "Agregar método de pago",
      creditCard: "Tarjeta de crédito",
      nameOnCard: "Nombre en la tarjeta",
    },
  },
  branding: "Marca",
  legal: "Legal",
  localization: "Localización",
  unitSystem: "Sistema de unidades",
  servicesAndTariffs: "Servicios y Tarifas",
  dumontYou: "Tú",
  dumontSending: "Enviando…",
  dumontTypeAMessage: "Escribe un mensaje...",
  dumontThankYou: "¡Gracias!",
  dumontConnectionError: "Hubo un problema al contactar a Ask Dumont. Por favor, intenta de nuevo más tarde.",
  dumontUnableToConnect: "No se puede conectar a Ask Dumont.",
  dumontNoMessagesToCopy: "No hay mensajes para copiar",
  dumontConversationCopied: "Conversación copiada al portapapeles",
  dumontFailedToCopyConversation: "Error al copiar conversación",
  dumontNoMessagesToExport: "No hay mensajes para exportar",
  dumontChatExportedSuccessfully: "Chat exportado exitosamente",
  dumontFailedToExportChat: "Error al exportar el chat",
  dumontNoMessagesToClear: "No hay mensajes para limpiar",
  dumontConversationCleared: "Conversación borrada",
  dumontOpenInNewWindow: "Abrir Dumont AI en una nueva ventana",
  dumontCloseShortcut: "Haz clic o presiona ⌘K para cerrar Dumont AI",
  wouldYouLikeToSendAnInviteToAgentName: "¿Desea enviar una invitación a {{agentName}} para unirse a su red Shipeezi?",
  selectAtLeastOneItem: "Seleccione al menos un elemento",
  shipmentNotFound: "Envío no encontrado",
  expensesRecalculatedSuccessfully: "Gastos recalculados con éxito",
  reconnecting: "Reconectando",
  pleaseSelectAFile: "¡Por favor, seleccione un archivo!",
  commentsSavedSuccessfully: "Comentarios guardados con éxito",
  couldNotSaveComments: "No se pudieron guardar los comentarios",
  anErrorOccurred: "Se produjo un error",
  unknownError: "Error desconocido",
  newNotification: "Nueva Notificación",
  externalAgentAssignmentInfo:
    "Está asignado a un agente externo, que recibirá una invitación por correo electrónico para aceptar o rechazar la asignación. Si no hay respuesta, el sistema enviará correos electrónicos de recordatorio durante tres días. Si el agente no responde dentro de ese período, la tarea se cancelará automáticamente.",
  page: "página",
  originCriterion: "Criterio de Origen",
  originCriterionMustBeWOrP: "El Criterio de Origen debe ser 'W' o 'P'",
  uploadPDF: "Subir PDF",
  addManualItems: "Agregar ítems manuales",
  editManualItems: "Editar ítems manuales",
  editInventory: "Editar inventario",
  describeEachBingoItem: "Ingrese una descripción para cada ítem a continuación. Use la paginación cuando agregue muchos ítems.",
  createInventory: "Crear inventario",
  editInventoryManualTitle: "Editar inventario (ítems manuales)",
  customerSurvey: "Encuesta del Cliente (Salida)",
  statementOfAsp: "Declaración de Servicios Accesorios Realizados",
  downloadCsv: "Descargar CSV",
  associateShipmentToOrder: "Asociar envío al pedido",
  shipmentSavedAsDraft: "Envío guardado como borrador",
  shipmentCreationFailedAtIndex: "No se pudo crear el envío {{current}} de {{total}}. Los envíos anteriores pueden haberse guardado. Revise el pedido o agregue los envíos restantes manualmente.",
  scacCodePlaceholder: "Buscar o ingresar código SCAC",
  grade: "Grado",
  gradePlaceholder: "ej: A, B, C",
  scacInformation: "Información SCAC",
  scacDescription: "Descripción SCAC",
  claimsPhone: "Teléfono de Reclamos",
  claimsEmail: "Correo de Reclamos",
  itemIsTv: "El ítem es un TV",
  screenSize: "Tamaño de pantalla",
  screenType: "Tipo de pantalla",
  remoteControl: "Control remoto",
  powerCord: "Cable de alimentación",
  tvBaseStand: "Base/soporte de TV",
  baseStandHardware: "Hardware de base/soporte",
  tv: "TV",
  vehicle: "Vehículo",
  serialNumberVin: "Número de serie / VIN",
  odometerMiles: "Kilometraje del odómetro",
  km: "KM",
  accessoriesIncluded: "Accesorios incluidos",
  gasTankEmpty: "Tanque de combustible vacío",
  fuelSystemPurged: "Sistema de combustible purgado",
  batteryDisconnected: "Batería desconectada",
  preApprovals: "Pre-aprobaciones",
  noPreApprovals: "Sin pre-aprobaciones",
  approvalItem: "Ítem de Aprobación",
  goShareId: "ID Go Share",
  count: "Cantidad",
  storageInTransitOriginSit: "Almacenamiento en Tránsito (SIT Origen)",
  sitInDate: "Fecha de entrada SIT",
  sitOutDate: "Fecha de salida SIT",
  sitOutDateMustBeAfterSitInDate: "La fecha de salida SIT debe ser posterior a la fecha de entrada SIT.",
  sitNumber: "Número SIT",
  baseCode: "Código de base",
  baseDescription: "Descripción de base",
  areaCode: "Código de área",
  areaDescription: "Descripción de área",
  zipCode: "Código postal",
  itemIsVehicle: "El ítem es un Vehículo",
  vehicleType: "Tipo de Vehículo",
  motorcycle: "Motocicleta",
  car: "Auto",
  boat: "Bote",
  startingNumber: "Número Inicial",
  decreaseStartingNumber: "Disminuir número inicial",
  increaseStartingNumber: "Aumentar número inicial",
  editDescriptionForItem: "Editar descripción del ítem",
  itemDescriptionDefaultPlaceholder: "Se aplica a todos los ítems de este inventario",
  defaultManualInventoryItemDescription: "Vide Inventario",
  customerSignature: "Firma del cliente",
  removalistName: "Nombre del operario de mudanza",
  removalistSignature: "Firma del operario de mudanza",
  removeFile: "Eliminar archivo",
  removeInventoryPdf: "Eliminar PDF del inventario",
  removeInventoryPdfConfirmation: "El PDF del inventario será eliminado de este pedido. Los ítems ya agregados no se eliminarán. ¿Continuar?",
  viewInventory: "Ver Inventario",
  noDocumentsHaveBeenAddedYet: "No se han agregado documentos aún",
  askEnzo: "Preguntar a Enzo",
  enzoHelpDocumentation: "Ayuda y Documentación",
  enzoSendFeedback: "Enviar Comentarios",
  enzoContactSupport: "Contactar Soporte",
  enzoLearnHowToUseEnzo: "Aprenda a usar Enzo de manera efectiva",
  enzoHelpUsImproveEnzo: "Ayúdenos a mejorar Enzo",
  enzoGetHelpFromTeam: "Obtenga ayuda de nuestro equipo",
  enzoQuickActions: "Acciones Rápidas",
  enzoContactOurSupport: "Contacte nuestro soporte",
  enzoGetHelpWithIssues: "Obtenga ayuda con cualquier problema o pregunta",
  enzoSendUsYourFeedback: "Envíenos sus comentarios",
  enzoShareThoughtsAndSuggestions: "Comparta sus opiniones y sugerencias",
  enzoCommonQuestions: "Preguntas Frecuentes",
  enzoHowToCreateCustomAgent: "¿Cómo creo un agente personalizado?",
  enzoHowToCreateCustomAgentAnswer: "Para crear un agente personalizado, navegue a la sección Agentes y haga clic en el botón \"Crear Nuevo Agente\". Luego puede configurar las capacidades y ajustes del agente según sus necesidades.",
  enzoWhatCanEnzoHelp: "¿En qué puede ayudarme Enzo?",
  enzoWhatCanEnzoHelpAnswer: "Enzo es su asistente de IA especializado en logística y mudanzas. Puedo ayudarle con la planificación de despachos, gestión de pedidos, optimización de rutas y responder preguntas sobre sus operaciones.",
  enzoHowToAccessChatHistory: "¿Cómo accedo a mi historial de conversaciones?",
  enzoHowToAccessChatHistoryAnswer: "Haga clic en el ícono Historial en la barra lateral para ver todas sus conversaciones anteriores con Enzo. Puede buscar en su historial y retomar cualquier conversación anterior.",
  enzoCanCustomizeAgentCapabilities: "¿Puedo personalizar las capacidades de los agentes?",
  enzoResources: "Recursos",
  enzoKnowledgeBase: "Base de Conocimiento",
  enzoCompleteGuidesAndTutorials: "Guías y tutoriales completos",
  enzoSelectAnOption: "Seleccione una opción",
  enzoFeedbackHelpsImprove: "Sus comentarios nos ayudan a mejorar Enzo",
  enzoIssueType: "Tipo de Problema",
  enzoSubject: "Asunto",
  enzoBriefDescriptionOfIssue: "Breve descripción de su problema",
  enzoMessage: "Mensaje",
  enzoPleaseDescribeIssueDetail: "Por favor, describa su problema en detalle...",
  enzoIncludeErrorMessages: "Incluya mensajes de error o pasos para reproducir el problema",
  enzoGotIt: "Entendido",
  enzoCancel: "Cancelar",
  enzoSendFeedbackButton: "Enviar Comentarios",
  enzoSendMessage: "Enviar Mensaje",
  enzoSupportRequestSentSuccessfully: "Su solicitud de soporte fue enviada con éxito. Nuestro equipo responderá dentro de las 24 horas.",
  enzoFeedbackSentSuccessfully: "Sus comentarios fueron enviados con éxito. ¡Agradecemos su aporte!",
  enzoSearchPlaceholder: "Buscar conversaciones, agentes, historial...",
  enzoNavigation: "Navegación",
  enzoNewChat: "Nueva Conversación",
  enzoChats: "Conversaciones",
  enzoNoChatsFound: "No se encontraron conversaciones",
  enzoNoRecentChats: "No hay conversaciones recientes",
  enzoAgents: "Agentes",
  enzoNoAgentsFound: "No se encontraron agentes",
  enzoReturnToShipeezi: "Volver a Shipeezi",
  enzoHelp: "Ayuda",
  enzoWelcomeMessage: "Hola, {{userName}}, soy Enzo, tu asistente de IA especializado en logística y mudanzas. Diseñado para simplificar flujos de trabajo complejos, aprendo continuamente para ofrecer soporte más rápido, inteligente y preciso para tu negocio.",
  enzoWelcomeMessageBusiness: "Hola, {{userName}}, ¡soy Enzo Asistente Comercial! 💼 Me especializo en ventas y cotizaciones. Puedo ayudarte a crear cotizaciones de flete precisas, gestionar relaciones con clientes y cerrar negocios más rápido. ¿Cómo puedo ayudarte hoy?",
  enzoWelcomeMessageOperations: "Hola, {{userName}}, ¡soy Enzo Asistente de Operaciones! 📊 Soy tu experto en operaciones. Puedo ayudarte a rastrear envíos, monitorear entregas, gestionar trabajos y asegurar operaciones logísticas fluidas. ¿En qué necesitas ayuda?",
  enzoWelcomeMessageWarehousing: "Hola, {{userName}}, ¡soy Enzo Asistente de Almacén! 🏭 Me especializo en inventario y operaciones de almacén. Puedo ayudarte a gestionar niveles de stock, rastrear inventario, coordinar almacenamiento y optimizar la eficiencia del almacén. ¿Cómo puedo ayudar?",
  enzoDispatchQuickActions: "Acciones rápidas para Despacho",
  enzoHistory: "Historial",
  enzoConversationHistory: "Historial de Conversaciones",
  enzoNoConversationsFound: "No se encontraron conversaciones",
  enzoNoConversationHistory: "No hay historial de conversaciones",
  enzoTryDifferentSearchTerm: "Intente con un término de búsqueda diferente",
  enzoStartNewConversation: "Inicie una nueva conversación para verla aquí",
  enzoFileTooLarge: "El archivo es demasiado grande. El tamaño máximo es 10MB.",
  enzoUnsupportedFileType: "Tipo de archivo no soportado. Seleccione archivos TXT, PDF o DOC/DOCX.",
  enzoDocumentProcessing: "El procesamiento de PDF/DOC estará disponible pronto. Por favor, use archivos TXT por ahora.",
  enzoFileProcessingError: "Error al procesar el archivo. Por favor, intente nuevamente.",
  enzoAskEnzo: "Pregúntale a Enzo...",
  enzoAskEnzoAnything: "Pregúntale cualquier cosa a Enzo",
  enzoUpload: "Subir",
  enzoUsesAI: "Enzo utiliza Inteligencia Artificial. Revise las respuestas.",
  enzoCopyConversation: "Copiar conversación",
  enzoExportChat: "Exportar conversación",
  enzoClearConversation: "Limpiar conversación",
  enzoLoadingAgents: "Cargando agentes...",
  enzoAgentsTitle: "Agentes Enzo",
  enzoCreateAgent: "Crear Agente",
  enzoSearchAgents: "Buscar agentes...",
  enzoNoAgentsAvailable: "No hay agentes disponibles",
  enzoAgentsAvailableSoon: "Los agentes estarán disponibles pronto",
  enzoComingSoon: "Próximamente...",
  enzoBusinessAssistant: "Asistente Comercial",
  enzoBusinessAssistantDesc: "Especializado en ventas y cotizaciones",
  enzoOperationsAssistant: "Asistente de Operaciones",
  enzoOperationsAssistantDesc: "Su experto en operaciones",
  enzoWarehousingAssistant: "Asistente de Almacén",
  enzoWarehousingAssistantDesc: "Experto en inventario y operaciones de almacén",
  enzoCanCustomizeAgentCapabilitiesAnswer: "¡Sí! Cada agente puede personalizarse para adaptarse a su flujo de trabajo específico. Puede ajustar sus capacidades, establecer parámetros específicos y configurar a qué fuentes de datos tiene acceso.",
  enzoFeedbackType: "Tipo de Comentario",
  enzoYourFeedback: "Su Comentario",
  enzoTellUsWhatYouThink: "Díganos lo que piensa...",
  enzoPleaseSelectTextFile: "Por favor, seleccione un archivo de texto (.txt)",
  enzoDocumentAttached: "Documento adjunto",
  enzoRemoveDocument: "Eliminar documento",
  enzoDefaultResponse: "¡Gracias por comunicarse! Estoy analizando su solicitud y le proporcionaré la mejor solución.",
  enzoSales: "Ventas",
  enzoOperations: "Operaciones",
  enzoLogistics: "Logística",
  enzoDispatchShowTodayOrders: "Mostrar pedidos de despacho de hoy",
  enzoDispatchShowTodayOrdersDesc: "Obtenga un resumen de todos los pedidos programados para despacho hoy",
  enzoDispatchFindCustomer: "Buscar pedidos por nombre del cliente",
  enzoDispatchFindCustomerDesc: "Busque pedidos específicos usando información del cliente",
  enzoDispatchTrackStatus: "Rastrear estado del pedido",
  enzoDispatchTrackStatusDesc: "Verifique el estado actual de los pedidos en el sistema",
  enzoDispatchOptimizeRoutes: "Optimizar rutas de entrega",
  enzoDispatchOptimizeRoutesDesc: "Obtenga sugerencias para las rutas de entrega más eficientes",
  enzoWhatCanIHelpYouWith: "¿En qué puedo ayudarle?",
  enzoOptimizeLogisticsOperations: "Optimizar mis operaciones logísticas",
  enzoOptimizeLogisticsOperationsDesc: "Obtenga recomendaciones personalizadas para mejorar la eficiencia y reducir costos",
  enzoTrackShipmentStatus: "Rastrear estado del envío",
  enzoTrackShipmentStatusDesc: "Obtenga actualizaciones en tiempo real sobre sus envíos y estimaciones de entrega",
  enzoCalculateShippingCosts: "Calcular costos de envío",
  enzoCalculateShippingCostsDesc: "Estime costos para diferentes métodos de envío y destinos",
  enzoFindWarehouseLocations: "Encontrar ubicaciones de almacén",
  enzoFindWarehouseLocationsDesc: "Descubra ubicaciones óptimas de almacén para su red de distribución",
  enzoManageInventoryLevels: "Gestionar niveles de inventario",
  enzoManageInventoryLevelsDesc: "Obtenga información sobre optimización de inventario y gestión de stock",
  enzoScheduleDeliveries: "Programar entregas",
  enzoScheduleDeliveriesDesc: "Planifique y optimice rutas de entrega para máxima eficiencia",
  enzoHowCanIHelpYou: "¿Cómo puedo ayudarle?",
  fileSizeIsTooLarge: "El archivo es mayor que 2MB",
  propertyDamageReport: "Reporte de daños a la propiedad",
  optional: "Opcional",
  photoRequiredAtUpliftCompletion: "Foto requerida al completar la recolección",
  customerPhoneNumber: "Teléfono del cliente",
  alternativePhone: "Teléfono alternativo",
  alternativeEmail: "Correo electrónico alternativo",
  mailingAddress: "Dirección de correspondencia",
  customerFields: "Campos del cliente",
  requireCustomerInformationFields: "Requerir campos de información del cliente",
  customerFieldsWillBeRequired: "Los campos del cliente serán obligatorios",
  selectMadatory: "Seleccionar obligatorio",
  military: "Militar",
  templateType: "Tipo de plantilla",
  assignedTemplate: "Plantilla asignada",
  packingList: "Lista de embalaje",
  billOfLading: "Conocimiento de embarque",
  inventoryReport: "Reporte de inventario",
  shippingManifest: "Manifiesto de envío",
  deliveryReceipt: "Comprobante de entrega",
  customsDeclaration: "Declaración aduanera",
  saveTemplates: "Guardar plantillas",
  shipeeziDefault2: "Predeterminado Shipeezi",
  clientCustomTemplate: "Plantilla Personalizada del Cliente",
  customTemplate: "Plantilla Personalizada",
  reportTemplates: "Plantillas de Reportes",
  defineWhichTemplateEachReportUses: "Defina qué plantilla utiliza cada reporte. Las plantillas se guardan por empresa y solo son visibles para cuentas Militares. Identifique si cada reporte utiliza la plantilla predeterminada de Shipeezi o una plantilla personalizada del cliente.",
  accessToThisSectionIsRestrictedByPermissionLevel: "El acceso a esta sección está restringido por nivel de permisos. Los cambios se guardan por empresa y están ocultos para cuentas Comerciales.",
  customerPortalAddress: "Dirección del Portal del Cliente",
  definesLinkYourCustomerWillUse: "Define el enlace que sus clientes usarán para rastrear pedidos y ver detalles de envíos",
  dateFormat: "Formato de fecha",
  timeFormat: "Formato de hora",
  accountPreferences: "Preferencias de la cuenta",
  addPreApprovalItem: "Agregar ítem de pre-aprobación",
  removePreApprovalItem: "Eliminar ítem",
  pleaseFillAllPreApprovalFields: "Complete la descripción de la pre-aprobación para cada fila.",
  unitOfMeasure: "Unidad de Medida (UdM)",
  boxes: "Cajas",
  pairs: "Pares",
  sets: "Conjuntos",
  pallets: "Paletas",
  customerLogo: "Logo del Cliente",
  removeShipmentFromOrder: "Eliminar Envío del Pedido",
  thisShipmentHasNoOtherOrdersAssociated: "Este envío no tiene otros pedidos asociados. ¿Qué le gustaría hacer con él?",
  revertToDraft: "Revertir a Borrador",
  leaveAsDraft: "Dejar como Borrador",
  cancelShipment: "Cancelar Envío",
  MB: "MB",
  "Search...": "Buscar...",
  activate: "activar",
  inactivate: "desactivar",
  cancelButton: "Cancelar",
  cereLifeLocalAmount: "Importe local CereLife",
  commercial: "Comercial",
  confirmDelete: "Eliminar",
  confirmation: "Confirmación",
  containerId: "ID del contenedor",
  createANewPort: "Crear un nuevo puerto",
  customerLastName: "Apellido del cliente",
  customerPhone: "Teléfono del cliente",
  dateCannotBeInThePast: "La fecha no puede estar en el pasado",
  decimalPlaces: "Decimales",
  deleteData: "Eliminar datos",
  deletePlaceholderTask: "Eliminar tarea provisional",
  editPort: "Editar puerto",
  emailIsInvalid: "El correo electrónico no es válido",
  errorFetchingTriggers: "Error al obtener disparadores",
  errorLoadingTemplates: "Error al cargar plantillas",
  errorReadingFile: "Error al leer el archivo",
  errorUpdatingTemplate: "Error al actualizar plantilla",
  errorUploadingFile: "Error al subir el archivo",
  errorValidatingTemplateName: "Error al validar el nombre de la plantilla",
  inAMoment: "en un momento",
  invalidDateTime: "Fecha y hora no válidas",
  invalidTimeFormat: "Formato de hora no válido",
  inviteAgent: "Invitar agente",
  invoicedAmount: "Importe facturado",
  iso174511Description:
    "Use la lista de inventario predeterminada de Shipeezi certificada ISO17451-1:2016. Puede actualizarla o ampliarla en cualquier momento.",
  itShouldBeAtLeastOneBranch: "Debe haber al menos una sucursal",
  itShouldHaveLeastOneBranch: "Debe tener al menos una sucursal",
  "label.item.packaging": "Embalaje del artículo",
  last: "Último",
  loadingLocations: "Cargando ubicaciones...",
  militaryReportsDescription: "Configure plantillas de informes para cuentas militares.",
  noInformationToBeShwon: "No hay información para mostrar",
  noLinkedAutomationsFound: "No se encontraron automatizaciones vinculadas",
  noReports: "Sin informes",
  only: "Solo",
  operationFailed: "La operación falló",
  origins: "Orígenes",
  picture: "Imagen",
  pictures: "Imágenes",
  pushCharacterLimitExceeded: "Se superó el límite de caracteres de la notificación push",
  scheduledTimeCannotBeInThePast: "La hora programada no puede estar en el pasado",
  seconds: "segundos",
  selectAContainerNumber: "Seleccione un número de contenedor",
  selectAtLeastOneTarget: "Seleccione al menos un destino",
  selectOptions: "Seleccionar opciones",
  sending: "Enviando",
  shipeeziDefaultTemplate: "Plantilla predeterminada Shipeezi",
  shipmentInformation: "Información del envío",
  smsCharacterLimitExceeded: "Se superó el límite de caracteres del SMS",
  someFilesFailedToUpload: "Algunos archivos no se pudieron subir",
  taskUnpublishedCannotBeEdited: "Las tareas no publicadas no se pueden editar",
  theLimitOfLinesIs: "El límite de líneas es",
  thisCustomerDoesNotHaveAnEmailToSendInvitation: "Este cliente no tiene correo electrónico para enviar la invitación",
  thisFieldIsNumber: "Este campo debe ser un número",
  uploadCategories: "Categorías de carga",
  uploadCategoriesDescription: "Suba su lista de categorías para comenzar.",
  uploadCentreDescription:
    "Aquí puede subir sus propios archivos (como inventario, personal o listas de servicios) o comenzar con la lista predeterminada de Shipeezi. Siempre puede actualizarlo más tarde.",
  useShipeeziSDefaultListDescription:
    "Comience rápidamente con nuestra lista preconfigurada, basada en el estándar global ISO17451-1:2016. Puede actualizarla o ampliarla en cualquier momento.",
  url: "URL",
  v: "V",
  youCannotInviteInactiveCustomers: "No puede invitar clientes inactivos",
  youDontHavePermissionToAccessShipmentData: "No tiene permiso para acceder a los datos del envío",
  youHaveToAddAtLeastOneOrder: "Debe agregar al menos un pedido",
  youMustEnterAAgentId: "Debe ingresar un ID de agente",
  youMustHaveAtLeastOneContact: "Debe tener al menos un contacto",
  youMustHaveAtLeastOnePrimaryContact: "Debe tener al menos un contacto principal",
  yourPasswordMustBeAtLeast6CharactersLong: "Su contraseña debe tener al menos 6 caracteres",
  memberCode: "Código de miembro",
  uploadOwnListDescription: "Importe sus propios datos para personalizar Shipeezi desde el principio.",
  downloadCsvTemplate: "Descargar plantilla CSV",
};
